var _view, _g, _view2, _g2, _view3, _defs, _g3, _view4, _g4, _view5, _defs2, _g5, _view6, _defs3, _g6, _view7, _g7, _view8, _g8, _view9, _g9, _view0, _defs4, _g0, _view1, _g1, _view10, _g10, _view11, _g11, _view12, _g12, _view13, _defs5, _g13, _view14, _g14, _view15, _g15, _view16, _g16, _view17, _g17, _view18, _g18, _view19, _defs6, _g19, _view20, _g20, _view21, _g21, _view22, _g22, _view23, _g23, _view24, _g24, _view25, _g25, _view26, _defs7, _g26, _g27, _g28, _g29, _view27, _g30, _view28, _g31, _view29, _g32, _view30, _defs8, _g33, _view31, _g34, _view32, _g35, _view33, _g36, _view34, _g37, _view35, _defs9, _g38, _view36, _g39, _view37, _defs0, _rect, _rect2, _rect3, _rect4, _rect5, _view38, _g40, _view39, _g41, _view40, _g42, _view41, _g43, _view42, _g44, _view43, _g45, _view44, _g46, _view45, _defs1, _g47, _view46, _g48, _view47, _g49, _view48, _g50, _view49, _g51, _view50, _g52, _view51, _g53, _view52, _g54, _view53, _defs10, _g55, _view54, _g56, _view55, _g57, _view56, _defs11, _g58, _view57, _g59, _view58, _g60, _view59, _g61, _view60, _g62, _view61, _g63, _view62, _g64, _view63, _g65, _view64, _defs12, _g66, _view65, _g67, _view66, _g68, _view67, _g69, _view68, _defs13, _g70, _view69, _g71, _view70, _g72, _view71, _g73, _view72, _g74, _view73, _g75, _view74, _g76, _view75, _g77, _view76, _g78, _view77, _g79, _view78, _g80, _view79, _defs14, _g81, _view80, _defs15, _g82, _view81, _g83, _view82, _g84, _view83, _g85, _view84, _g86, _view85, _defs16, _g87, _view86, _g88, _view87, _defs17, _g89, _view88, _defs18, _g90, _view89, _g91, _view90, _g92, _view91, _g93, _view92, _g94, _view93, _g95, _view94, _g96, _view95, _g97, _view96, _g98, _view97, _g99, _view98, _g100, _view99, _g101, _view100, _g102, _view101, _g103, _view102, _g104, _view103, _defs19, _g105, _view104, _g106, _view105, _g107, _view106, _g108, _view107, _g109, _view108, _g110, _view109, _g111, _view110, _g112, _view111, _g113, _view112, _g114, _view113, _g115, _view114, _g116, _view115, _g117, _view116, _g118, _view117, _defs20, _g119, _view118, _g120, _view119, _defs21, _g121, _view120, _g122, _view121, _g123, _view122, _g124, _view123, _g125, _view124, _defs22, _g126, _view125, _g127, _view126, _defs23, _g128, _view127, _g129, _view128, _defs24, _g130, _view129, _g131, _view130, _g132, _view131, _g133, _view132, _g134, _view133, _g135, _view134, _g136;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTldSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 332,
    viewBox: "330 182 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _view || (_view = /*#__PURE__*/React.createElement("view", {
    id: "academy",
    viewBox: "300 60 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-3649H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 13.273l.001 5.602a1.5 1.5 0 11-2.001 0V14.35l2-1.077z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15.427v2.329a2 2 0 01-1.106 1.789L15.5 20.742a7.826 7.826 0 01-7 0l-2.394-1.197A2 2 0 015 17.755v-2.328l2 1.076v1.253l2.394 1.197a5.826 5.826 0 004.963.117l.249-.117L17 17.756v-1.253l2-1.076zm-6.526-11.68l10.89 5.864a1 1 0 010 1.761l-10.89 5.865a1 1 0 01-.948 0L.636 11.372a1 1 0 010-1.76l10.89-5.865a1 1 0 01.948 0zM12 5.763l-8.782 4.729 8.781 4.728 8.782-4.73L12 5.764z",
    fill: "#9896E0"
  }))))), _view2 || (_view2 = /*#__PURE__*/React.createElement("view", {
    id: "accountants",
    viewBox: "0 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3647H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 2.825c5.051 0 9.165 2.007 9.328 4.513l.005.154v14c0 2.577-4.179 4.666-9.333 4.666-.817 0-1.61-.052-2.365-.15a11.722 11.722 0 002.482-2.184l-.117.001c2.163 0 4.159-.422 5.556-1.12.961-.481 1.386-.94 1.438-1.168l.006-.045v-1.58c-1.351.765-3.198 1.308-5.29 1.502a11.61 11.61 0 00.891-2.468c1.13-.19 2.144-.502 2.955-.908.961-.48 1.386-.939 1.438-1.167l.006-.046v-1.58c-1.086.616-2.493 1.087-4.09 1.349a11.742 11.742 0 00-.163-2.341c1.072-.191 2.033-.494 2.809-.882.961-.48 1.386-.938 1.438-1.167l.006-.046v-1.58c-1.26.714-2.948 1.233-4.865 1.458a11.637 11.637 0 00-1.16-2.241c1.783-.105 3.397-.498 4.58-1.09 1.031-.516 1.445-1.004 1.445-1.213 0-.209-.414-.698-1.444-1.213-1.397-.698-3.393-1.12-5.556-1.12-1.396 0-2.722.175-3.862.487a11.565 11.565 0 00-3.545-.994c1.705-1.11 4.389-1.827 7.407-1.827zm-8.75 3.5c5.476 0 9.916 4.44 9.916 9.917 0 5.477-4.44 9.916-9.916 9.916C4.44 26.158 0 21.718 0 16.242c0-5.477 4.44-9.917 9.917-9.917zm0 2.333a7.583 7.583 0 100 15.167 7.583 7.583 0 000-15.167zm2.916 8.75a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm.825-4.908a1.167 1.167 0 010 1.65l-5.833 5.833a1.167 1.167 0 11-1.65-1.65l5.833-5.833a1.167 1.167 0 011.65 0zM7 11.575a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view3 || (_view3 = /*#__PURE__*/React.createElement("view", {
    id: "africa",
    viewBox: "260 279 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 260,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "acb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "acc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "ace"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-99.637%",
    y1: "-31.409%",
    x2: "-57.207%",
    y2: "0%",
    id: "acf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "acg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-34.775%",
    y1: "-31.409%",
    x2: "-10.737%",
    y2: "0%",
    id: "ach"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aci"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "acj"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-43.812%",
    y1: "-31.409%",
    x2: "-17.211%",
    y2: "0%",
    id: "ack"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "acl"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "20.764%",
    x2: "106.168%",
    y2: "173.632%",
    id: "acm"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.83%",
    y1: "-31.409%",
    x2: "-12.925%",
    y2: "0%",
    id: "acn"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "aca",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-6479h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "acd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aca"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#acb)",
    fillRule: "nonzero",
    xlinkHref: "#aca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8a1 1 0 11.085-1.996 1.499 1.499 0 012.831 0L21 6a1 1 0 010 2z",
    fill: "url(#acc)",
    fillRule: "nonzero",
    mask: "url(#acd)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#acd)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(15 1)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#acd)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ace)",
    d: "M22 15l6.444-8 6.445 8z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#acf)",
    d: "M28.44 7l-1 8H21z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#acg)",
    d: "M9 15L19.5 0 30 15z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ach)",
    d: "M19.5 0l-1 15H9z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 14c-6-1.333-11-1.333-15 0s-7 2-9 2v7h26v-9",
    fillOpacity: 0.45,
    fill: "url(#aci)",
    transform: "rotate(-3 -2.594 189.348)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#acj)",
    d: "M6 16l6.111-11 6.111 11z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ack)",
    d: "M12.1 5l-1 11H4z",
    transform: "translate(-9 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.687 15.226c-6-1.333-11-1.333-15 0-6 2-7.914 1.81-14.612.048-4.465-1.174-2.594 1.81 5.612 8.952h26v-9",
    fillOpacity: 0.5,
    fill: "url(#acl)",
    transform: "scale(-1 1) rotate(-2 -24.145 775.016)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#acm)",
    fillRule: "nonzero",
    d: "M7 9l4.5-8L17 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#acn)",
    fillRule: "nonzero",
    d: "M11.5 1L11 9H5.8z"
  })))), _view4 || (_view4 = /*#__PURE__*/React.createElement("view", {
    id: "agency",
    viewBox: "30 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-4367H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78 13.186l3.5 6.062-2.021 1.167-3.5-6.063 2.02-1.166zm18.011-.447a1.167 1.167 0 01.136 2.326l-.136.007h-4.083a1.167 1.167 0 01-.136-2.325l.136-.008h4.083zm-.57-5.582c.3.518.156 1.17-.313 1.52l-.114.074-4.547 2.625a1.167 1.167 0 01-1.28-1.946l.114-.075 4.546-2.625a1.167 1.167 0 011.594.427zm-4.972-4.871c.518.3.72.936.488 1.472l-.06.122-2.042 3.536a1.167 1.167 0 01-2.082-1.045l.06-.122 2.042-3.536a1.167 1.167 0 011.594-.427z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.904 22.255l.014-.002 2.722 2.815a1.167 1.167 0 01-1.577 1.715l-.1-.093-3.132-3.239 2.073-1.196zm1.144-17.27c.15.1.277.234.367.39l7.446 12.897a1.167 1.167 0 01-.94 1.748l-8.532.512-5.052 2.917a1.167 1.167 0 01-1.594-.427l-3.5-6.063a1.167 1.167 0 01.427-1.593l5.052-2.917 4.71-7.133a1.167 1.167 0 011.616-.33zm-.71 3.191l-3.972 6.018-4.52 2.608 2.334 4.042 4.519-2.608 7.197-.432-5.558-9.628z",
    fill: "#9896E0"
  }))))), _view5 || (_view5 = /*#__PURE__*/React.createElement("view", {
    id: "ai",
    viewBox: "286 279 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 286,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aea"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1v-16a1 1 0 011-1h18zm-1 2H4v14h16v-14zM8.75 8a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm0 1.167a.583.583 0 100 1.166.583.583 0 000-1.166zm5.47 5.399a.5.5 0 01.185.682 2.499 2.499 0 01-4.338.01.5.5 0 01.866-.5 1.499 1.499 0 002.604-.006.5.5 0 01.682-.186zM16 9a1 1 0 010 2h-2a1 1 0 010-2h2zM18.5.5a1 1 0 01.501 1.866L19 5.5h-1V2.366A1 1 0 0118.5.5z",
    id: "aeb"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-6479h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#aea)",
    fillRule: "nonzero",
    xlinkHref: "#aeb"
  })))), _view6 || (_view6 = /*#__PURE__*/React.createElement("view", {
    id: "app",
    viewBox: "330 0 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "afa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.264 4.305v16h8v-16h-8zm0-2h8a2 2 0 012 2v16a2 2 0 01-2 2h-8a2 2 0 01-2-2v-16a2 2 0 012-2zm12.013 1.907a5 5 0 010 10v-2a3 3 0 000-6v-2zm.162 3.298a1.75 1.75 0 010 3.5v-1.5a.25.25 0 100-.5v-1.5zm-6.175-5.205a1 1 0 011 1v1a1 1 0 01-1 1h-4a1 1 0 01-1-1v-1a1 1 0 011-1h4z",
    id: "afb"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-6479H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#afa)",
    fillRule: "nonzero",
    transform: "rotate(-15 9.973 11.805)",
    xlinkHref: "#afb"
  })))), _view7 || (_view7 = /*#__PURE__*/React.createElement("view", {
    id: "army",
    viewBox: "60 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-488H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.033 21.492a.2.2 0 01.08.017L14 24.889l7.888-3.38a.2.2 0 01.279.183v2.104a.2.2 0 01-.122.184L14 27.428 5.955 23.98a.2.2 0 01-.122-.184v-2.104c0-.11.09-.2.2-.2zm0-4.666a.2.2 0 01.08.016L14 20.222l7.888-3.38a.2.2 0 01.279.184v2.103a.2.2 0 01-.122.184L14 22.761l-8.045-3.448a.2.2 0 01-.122-.184v-2.103c0-.11.09-.2.2-.2zm0-4.667a.2.2 0 01.08.016L14 15.555l7.888-3.38a.2.2 0 01.279.184v2.104a.2.2 0 01-.122.183L14 18.094l-8.045-3.448a.2.2 0 01-.122-.183v-2.104c0-.11.09-.2.2-.2zm8.065-10.454a.3.3 0 01.185.185l1.233 3.547 3.755.077a.3.3 0 01.175.539L16.453 8.32l1.088 3.595a.3.3 0 01-.459.333L14 10.104l-3.082 2.145a.3.3 0 01-.459-.333l1.088-3.595-2.993-2.268a.3.3 0 01.175-.54l3.755-.076 1.233-3.547a.3.3 0 01.381-.185z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view8 || (_view8 = /*#__PURE__*/React.createElement("view", {
    id: "art",
    viewBox: "300 87 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 87,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-4606H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.711 14.449a1.5 1.5 0 10-.423 2.968 1.5 1.5 0 00.423-2.968m-2.422-6.03a1.499 1.499 0 11.422-2.97 1.5 1.5 0 01-.422 2.97",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.985 11.145a1.5 1.5 0 11-2.97-.422 1.5 1.5 0 012.97.422m-8-3a1.5 1.5 0 11-2.97-.422 1.5 1.5 0 012.97.422m5.303 13.066c-1.396-1.657-4.819-5.441-7.173-5.712l-.001-.001a2.358 2.358 0 00-.257-.014c-1.327 0-3.311 1.014-4.529 1.718A8.92 8.92 0 013 12.492c0-4.963 4.038-9 9-9 4.963 0 9 4.037 9 9 0 3.81-1.907 7.28-4.712 8.719M12 1.49c-6.065 0-11 4.935-11 11 0 2.429.776 4.732 2.243 6.659a1 1 0 001.329.24c1.556-.981 3.676-1.977 4.313-1.905 1.406.162 4.551 3.358 6.336 5.576a1.004 1.004 0 001.137.307C20.331 21.847 23 17.476 23 12.492c0-6.066-4.934-11-11-11",
    fill: "#9896E0"
  }))))), _view9 || (_view9 = /*#__PURE__*/React.createElement("view", {
    id: "attorney",
    viewBox: "0 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-488H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.167 22.658a3.5 3.5 0 013.5 3.5h-2.334c0-.644-.522-1.166-1.166-1.166h-7c-.645 0-1.167.522-1.167 1.166h-2.333a3.5 3.5 0 013.5-3.5h7zM8.862 15.47l1.65 1.65-6.187 6.188a1.167 1.167 0 11-1.65-1.65l6.187-6.188zm5.362-11.96l1.238 1.237c.61.61.812 1.476.604 2.254l2.916 2.916a2.332 2.332 0 012.255.605l1.237 1.237a2.333 2.333 0 010 3.3l-4.95 4.95a2.333 2.333 0 01-3.3 0l-1.237-1.238a2.332 2.332 0 01-.604-2.254L9.466 13.6a2.332 2.332 0 01-2.254-.604l-1.237-1.238a2.333 2.333 0 010-3.3l4.95-4.95a2.333 2.333 0 013.3 0zm-1.65 1.65l-4.95 4.95 1.238 1.237 1.303-.348 4.82 4.82-.348 1.3 1.237 1.24 4.95-4.95-1.237-1.237-1.303.347-4.82-4.82.348-1.3-1.237-1.24z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view0 || (_view0 = /*#__PURE__*/React.createElement("view", {
    id: "au",
    viewBox: "330 26 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "ajb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.013%",
    x2: "76.253%",
    y2: "50%",
    id: "ajd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.013%",
    x2: "75.31%",
    y2: "50%",
    id: "aje"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.013%",
    x2: "76.263%",
    y2: "50%",
    id: "ajf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "37.013%",
    x2: "76.348%",
    y2: "50%",
    id: "ajg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.212%",
    y1: "21.372%",
    x2: "89.871%",
    y2: "61.121%",
    id: "ajh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "49.91%",
    x2: "90.509%",
    y2: "50%",
    id: "aji"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "49.436%",
    x2: "90.509%",
    y2: "50%",
    id: "ajj"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "aja",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-6479H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ajc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aja"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#ajb)",
    fillRule: "nonzero",
    xlinkHref: "#aja"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#ajc)",
    cx: 20,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#ajc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.337 6.368s-.837 4.557-.334 9.112c-.002.018-2.336-.114-7.003-.396C15 8 22.337 6.368 22.337 6.368z",
    fill: "url(#ajd)",
    transform: "rotate(4 -38.604 12.925)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8.774s4.566.89 4.273 5.076c-2.849.365-4.208.442-4.079.231C3 12.29 2 8.774 2 8.774z",
    fill: "url(#aje)",
    transform: "rotate(-4 61.416 13.486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 3.556S18 9.18 18.83 15.044l-8.83-.5C10 5 19.25 3.557 19.25 3.557z",
    fill: "url(#ajf)",
    transform: "rotate(4 -42.648 11.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.368s5.648 1.333 5.388 6.4c-3.592-.049-5.306.048-5.143.291C5 10.714 4 7.368 4 7.368z",
    fill: "url(#ajg)",
    transform: "rotate(-4 63.97 12.714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25.744s-1.75 7.733-.42 13.597c.113-.16-2.83-.357-8.83-.591C5 2 15.25.744 15.25.744z",
    fill: "url(#ajh)",
    transform: "rotate(4 -46.682 9.543)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aji)",
    d: "M0 13h24v2H0z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ajj)",
    d: "M0 15h24v5H0z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5c-1.53 0-2.31-.598-2.957-1.078-.547-.406-.942-.7-1.833-.7-.89 0-1.285.294-1.832.7-.647.48-1.453 1.078-2.957 1.078-1.504 0-2.31-.598-2.956-1.078-.548-.406-.943-.7-1.833-.7s-1.286.294-1.833.7c-.647.48-1.452 1.078-2.956 1.078-1.505 0-2.337-.598-2.984-1.078-.547-.406-.973-.7-1.859-.7V20.5c1.53 0 2.336.598 2.983 1.078.547.406.956.7 1.846.7.89 0 1.292-.294 1.84-.7.646-.48 1.455-1.078 2.96-1.078 1.504 0 2.31.598 2.958 1.078.547.406.943.7 1.833.7s1.286-.294 1.833-.7c.647-.48 1.453-1.078 2.957-1.078 1.505 0 2.31.598 2.957 1.078.547.406.947.7 1.833.7V24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21c-1.53 0-2.31-.598-2.957-1.078-.547-.406-.942-.7-1.833-.7-.89 0-1.285.294-1.832.7-.647.48-1.453 1.078-2.957 1.078-1.504 0-2.31-.598-2.956-1.078-.548-.406-.943-.7-1.833-.7s-1.286.294-1.833.7C7.152 20.402 6.347 21 4.843 21c-1.505 0-2.337-.598-2.984-1.078-.547-.406-.973-.7-1.859-.7V17c1.53 0 2.336.598 2.983 1.078.547.406.956.7 1.846.7.89 0 1.292-.294 1.84-.7.646-.48 1.455-1.078 2.96-1.078 1.504 0 2.31.598 2.958 1.078.547.406.943.7 1.833.7s1.286-.294 1.833-.7C16.9 17.598 17.706 17 19.21 17c1.505 0 2.31.598 2.957 1.078.547.406.947.7 1.833.7V21z"
  })))))), _view1 || (_view1 = /*#__PURE__*/React.createElement("view", {
    id: "best",
    viewBox: "30 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1877H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.834 20.417v5.923a1.167 1.167 0 01-1.503 1.118L14 26.158l-4.331 1.3a1.167 1.167 0 01-1.502-1.118v-5.923c.725.45 1.508.82 2.333 1.094v3.261l3.5-1.05 3.5 1.05v-3.261a11.032 11.032 0 002.334-1.094zM14 1.658a9.333 9.333 0 110 18.667 9.333 9.333 0 010-18.667zm0 2.334a7 7 0 100 14 7 7 0 000-14zm.207 2.386c.092.045.166.12.211.212l1.125 2.278 2.514.365a.467.467 0 01.259.796l-1.82 1.774.43 2.504a.467.467 0 01-.677.492L14 13.617l-2.249 1.182a.467.467 0 01-.677-.492l.43-2.504-1.82-1.774a.467.467 0 01.259-.796l2.514-.365 1.125-2.278a.467.467 0 01.625-.212z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view10 || (_view10 = /*#__PURE__*/React.createElement("view", {
    id: "bike",
    viewBox: "60 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-3647H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.992a1.167 1.167 0 01.136 2.325l-.136.008h-.84l.584 2.333h7.989l-.507-2.333H15.75A1.167 1.167 0 0115.614 4l.136-.008h2.917c.12 0 .234.018.343.051l.017.006a.69.69 0 01.08.029l.033.014a1.02 1.02 0 01.109.056l.029.017.028.017.041.029.009.006.08.065.009.007.006.006a1.16 1.16 0 01.348.58l.008.036 1.576 7.25a6.417 6.417 0 11-2.282.495l-.361-1.664h-8.566l-.655 1.965a6.417 6.417 0 11-2.214-.737l.814-2.442-.863-3.453H5.833A1.167 1.167 0 015.697 4l.136-.008H10.5zm-4.083 10.5a4.083 4.083 0 102.344.74l-1.238 3.712a1.167 1.167 0 01-2.249-.606l.036-.132 1.237-3.712a4.159 4.159 0 00-.13-.002zm15.476.011l.83 3.824a1.167 1.167 0 01-2.243.627l-.037-.131-.832-3.824a4.083 4.083 0 102.282-.496z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view11 || (_view11 = /*#__PURE__*/React.createElement("view", {
    id: "biz",
    viewBox: "90 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1877H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.719 12.877l8.947 3.132v2.472l-9.718-3.402c-.608-.213.163-2.415.77-2.202zm23.333 2.202l-9.719 3.402v-2.473l8.948-3.131c.608-.213 1.38 1.99.771 2.202z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7.492a2.333 2.333 0 012.333 2.333v14a2.333 2.333 0 01-2.333 2.333h-21a2.333 2.333 0 01-2.333-2.333v-14A2.333 2.333 0 013.5 7.492h21zm0 2.333h-21v14h21v-14zm-9.333 3.5a2.333 2.333 0 012.333 2.333v2.334a2.333 2.333 0 01-2.333 2.333h-2.334a2.333 2.333 0 01-2.333-2.333v-2.334a2.333 2.333 0 012.333-2.333h2.334zm0 2.333h-2.334v2.334h2.334v-2.334zm2.589-12.833c1.007 0 1.893.646 2.21 1.588l.053.18.434 1.732h-2.406l-.291-1.167h-7.512l-.292 1.167H7.546l.435-1.732a2.333 2.333 0 012.076-1.76l.187-.008h7.512z",
    fill: "#9896E0"
  }))))), _view12 || (_view12 = /*#__PURE__*/React.createElement("view", {
    id: "business",
    viewBox: "90 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-2165H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.719 12.877l8.947 3.132v2.472l-9.718-3.402c-.608-.213.163-2.415.77-2.202zm23.333 2.202l-9.719 3.402v-2.473l8.948-3.131c.608-.213 1.38 1.99.771 2.202z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7.492a2.333 2.333 0 012.333 2.333v14a2.333 2.333 0 01-2.333 2.333h-21a2.333 2.333 0 01-2.333-2.333v-14A2.333 2.333 0 013.5 7.492h21zm0 2.333h-21v14h21v-14zm-9.333 3.5a2.333 2.333 0 012.333 2.333v2.334a2.333 2.333 0 01-2.333 2.333h-2.334a2.333 2.333 0 01-2.333-2.333v-2.334a2.333 2.333 0 012.333-2.333h2.334zm0 2.333h-2.334v2.334h2.334v-2.334zm2.589-12.833c1.007 0 1.893.646 2.21 1.588l.053.18.434 1.732h-2.406l-.291-1.167h-7.512l-.292 1.167H7.546l.435-1.732a2.333 2.333 0 012.076-1.76l.187-.008h7.512z",
    fill: "#9896E0"
  }))))), _view13 || (_view13 = /*#__PURE__*/React.createElement("view", {
    id: "ca",
    viewBox: "330 52 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aob"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "aod"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aoe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aof"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "aog"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "aoa",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-6641h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "aoc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aoa"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#aob)",
    fillRule: "nonzero",
    xlinkHref: "#aoa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#aoc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.3 16v-.013a1.5 1.5 0 11.882-2.823A2 2 0 114 16H1.3z",
    fill: "url(#aod)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 17,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8v1.003l.464.047a33.076 33.076 0 00.368 9.195l.125.657-.98.196A32.498 32.498 0 015.775 18H4.192c-.061.366-.129.732-.202 1.098l-.98-.196c.657-3.285.82-6.568.492-9.852L4 8.999V8h2zM2 7a2 2 0 110-4h6a2 2 0 110 4zm4-7a1 1 0 110 2H4a1 1 0 110-2h2z",
    fillOpacity: 0.99,
    fill: "url(#aoe)",
    transform: "translate(5 3)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5a.5.5 0 11-1 0v-5a.5.5 0 111 0v5z",
    fill: "url(#aof)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20a1 1 0 11.085-1.996 1.499 1.499 0 012.831 0L20 18a1 1 0 010 2z",
    fill: "url(#aog)",
    fillRule: "nonzero"
  })))), _view14 || (_view14 = /*#__PURE__*/React.createElement("view", {
    id: "cafe",
    viewBox: "0 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-3359H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.188 1.804c.563 0 1.02.457 1.02 1.021 0 1.524-.571 2.667-1.73 3.247-.397.197-.603.61-.603 1.42a1.02 1.02 0 01-2.042 0c0-1.524.572-2.667 1.731-3.247.396-.198.603-.61.603-1.42 0-.564.457-1.02 1.02-1.02zm4.666 0a1.02 1.02 0 011.021 1.021c0 1.524-.571 2.667-1.731 3.247-.396.197-.602.61-.602 1.42a1.02 1.02 0 01-2.042 0c0-1.524.571-2.667 1.731-3.247.396-.198.602-.61.602-1.42 0-.564.457-1.02 1.021-1.02zm4.667 0c.564 0 1.02.457 1.02 1.021 0 1.524-.57 2.667-1.73 3.247-.396.197-.603.61-.603 1.42a1.02 1.02 0 11-2.041 0c0-1.524.571-2.667 1.73-3.247.397-.198.603-.61.603-1.42 0-.564.457-1.02 1.02-1.02z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667 24.992a1 1 0 011 1v.333a1 1 0 01-1 1H6.833a1 1 0 01-1-1v-.333a1 1 0 011-1h10.834zM20 9.825a1 1 0 011 1v1.333h1.13a4.152 4.152 0 014.12 4.667 5.327 5.327 0 01-5.286 4.667h-2.765A8.75 8.75 0 013.5 15.075v-4.25a1 1 0 011-1H20zm-1.333 2.333H5.833v2.917a6.417 6.417 0 1012.834 0v-2.917zm3.428 2.334H21v.583a8.712 8.712 0 01-1.01 4.083h.938a3.08 3.08 0 002.989-2.333 1.878 1.878 0 00-1.822-2.333z",
    fill: "#9896E0"
  }))))), _view15 || (_view15 = /*#__PURE__*/React.createElement("view", {
    id: "cards",
    viewBox: "30 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-488H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.249 6.613v13.98L1.44 10.128a2 2 0 011.196-2.563l2.613-.952z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 1.658a2.333 2.333 0 012.334 2.334v21a2.333 2.333 0 01-2.334 2.333h-14A2.333 2.333 0 017 24.992v-21a2.333 2.333 0 012.333-2.334h14zm0 2.334h-14v21h14v-21zm-7 4.666l3.984 3.984a2.333 2.333 0 01-3.26 3.34l1.24 2.892a.467.467 0 01-.54.637l-1.424-.353-1.422.353a.467.467 0 01-.541-.637l1.24-2.893a2.333 2.333 0 01-3.26-3.34l3.983-3.983z",
    fill: "#9896E0"
  }))))), _view16 || (_view16 = /*#__PURE__*/React.createElement("view", {
    id: "care",
    viewBox: "60 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-3503H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.004 12.158l.212.007.241.023.235.038.296.073.11.034.163.058.157.065.137.064.154.08.05.03c.074.042.148.089.22.138l.176.129.185.155.14.132 4.946 4.947a1.168 1.168 0 011.653-.003l.825.825a1.167 1.167 0 010 1.65l-.825.825-.825-.825-4.95 4.95.825.825-.825.825a1.167 1.167 0 01-1.65 0l-.825-.825a1.167 1.167 0 01-.003-1.647l-.905-.906h-9.25l-.145-.003-.198-.014-.22-.028-.195-.038-.216-.054-.199-.064a3.447 3.447 0 01-.367-.155l-.128-.066-.108-.06-.132-.083-.164-.113-.093-.071-.153-.128-.157-.148-3.416-3.416a3.5 3.5 0 114.95-4.95l.951.953a3.5 3.5 0 013.49-3.229h5.833zm.02 2.334h-5.853a1.167 1.167 0 00-.136 2.325l.116.007 3.52.001a1.167 1.167 0 110 2.333h-4.585a4.667 4.667 0 01-3.3-1.367l-1.707-1.707a1.167 1.167 0 00-1.747 1.54l.098.11 3.487 3.483.065.05.104.069.073.038.059.027.117.042.117.029.12.016.099.004h10.216l1.589 1.589 3.3-3.3-4.914-4.915-.072-.069-.142-.113-.113-.066a1.153 1.153 0 00-.124-.054l-.152-.044a1.157 1.157 0 00-.235-.028zM12.037 1.659c.08 0 .162.008.243.018a2.9 2.9 0 011.625.726l.095.089c.47-.46 1.045-.73 1.723-.81 2.577-.324 5.26 3.733-1.479 7.992l-.243.151-.021-.014c-6.804-4.173-4.469-8.2-1.943-8.152z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view17 || (_view17 = /*#__PURE__*/React.createElement("view", {
    id: "careers",
    viewBox: "90 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-3503H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.225 5.11l.072-.007h.167l.133.018.121.03.138.052.119.061.138.096.085.076.088.098.062.084.065.11 2.016 3.873a1.167 1.167 0 01-1.994 1.203l-.076-.125-.716-1.375-1.959 6.215a1.167 1.167 0 01-2.259-.57l.034-.131 1.959-6.216-1.374.716A1.167 1.167 0 012.84 7.324l.125-.076L6.84 5.232l.134-.06.105-.032.064-.016.083-.014z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.869 2.885c.568.19.893.772.773 1.344l-.035.132-7 21a1.167 1.167 0 01-2.25-.607l.036-.131.654-1.965H11.34l-.9 2.703a1.167 1.167 0 01-2.249-.607l.036-.131 7-21a1.167 1.167 0 012.249.606l-.036.132-.655 1.964h5.707l.901-2.702a1.167 1.167 0 011.476-.738zm-6.266 15.106h-5.707l-.778 2.334h5.707l.778-2.334zm1.556-4.666H14.45l-.778 2.333h5.707l.779-2.333zm1.555-4.667h-5.708l-.778 2.333h5.708l.778-2.333z",
    fill: "#9896E0"
  }))))), _view18 || (_view18 = /*#__PURE__*/React.createElement("view", {
    id: "center",
    viewBox: "120 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2978H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.158a1.167 1.167 0 01.136 2.326l-.136.008h-1.85l3.025 3.025a1.167 1.167 0 01-1.54 1.747l-.11-.097L21 23.143v1.849c0 .598-.45 1.091-1.03 1.159l-.137.007c-.598 0-1.091-.45-1.158-1.03l-.008-.136v-5.25c0-.322.26-.584.583-.584h5.25zm-15.75 0c.322 0 .583.262.583.584v5.25a1.167 1.167 0 01-2.325.136L7 24.992v-1.85l-3.025 3.025a1.167 1.167 0 01-1.747-1.54l.097-.11 3.024-3.025H3.5c-.598 0-1.091-.45-1.159-1.03l-.008-.137c0-.598.45-1.091 1.03-1.159l.137-.008h5.25zM3.865 2.72l.11.097L7 5.84V3.99c0-.598.45-1.09 1.03-1.158l.137-.008c.598 0 1.091.45 1.158 1.03l.008.137v5.25a.583.583 0 01-.583.583H3.5A1.167 1.167 0 013.364 7.5l.136-.008h1.85L2.324 4.467a1.167 1.167 0 011.54-1.747zm21.81.097c.42.42.453 1.082.097 1.54l-.097.11-3.024 3.025H24.5c.598 0 1.091.45 1.159 1.03l.008.136c0 .599-.45 1.092-1.03 1.16l-.137.007h-5.25a.583.583 0 01-.583-.583v-5.25a1.167 1.167 0 012.325-.136l.008.136V5.84l3.025-3.024a1.167 1.167 0 011.65 0z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.825a4.667 4.667 0 110 9.333 4.667 4.667 0 010-9.333zm0 2.333a2.333 2.333 0 100 4.667 2.333 2.333 0 000-4.667z",
    fill: "#9896E0"
  }))))), _view19 || (_view19 = /*#__PURE__*/React.createElement("view", {
    id: "ch",
    viewBox: "330 78 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 78,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aua"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "auc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "aud"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.17 23.103a3.056 3.056 0 01-4.325 0l-7.18-7.18a3.056 3.056 0 010-4.325 3.056 3.056 0 014.324 0l7.18 7.181a3.056 3.056 0 010 4.324z",
    id: "aub"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-6641h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#aua)",
    xlinkHref: "#aub"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.227 5.614l-1.965 1.968a.967.967 0 01-.343.223.988.988 0 01-1.028-1.618l1.965-1.965a2.932 2.932 0 00-4.208 2.465l-.02.2c.002.35.067.7.191 1.028l-2.9 2.901c.62.539 1.213 1.111 1.82 1.67l2.826-2.826c.328.126.677.19 1.029.192l.199-.02a2.932 2.932 0 002.465-4.211l-.03-.007z",
    fill: "url(#auc)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aud)",
    d: "M4.854 5.045l.799-2.507L4.847 0H3.235l-.806 2.538.796 2.507v4.019h1.632z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14 19h1v3h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16 20v1.125h-3V20z"
  }))))), _view20 || (_view20 = /*#__PURE__*/React.createElement("view", {
    id: "chat",
    viewBox: "120 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-488H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 1.658c4.51 0 8.166 2.743 8.166 6.125 0 .902-.26 1.758-.726 2.529l-.163.253.726 1.676.033.1a.584.584 0 01-.611.713l-.093-.014-1.103-.264c-2.135-3.42-6.567-5.74-11.639-5.862l-.577-.006c-.722 0-1.43.046-2.12.134.487-3.033 3.931-5.384 8.107-5.384z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 8.658c6.444 0 11.667 3.918 11.667 8.75 0 4.833-5.223 8.75-11.667 8.75-1.743 0-3.397-.286-4.883-.8L3.305 27.37a.583.583 0 01-.8-.67l.971-4.065c-1.45-1.459-2.31-3.268-2.31-5.228 0-4.832 5.224-8.75 11.667-8.75zm0 2.334c-5.276 0-9.333 3.042-9.333 6.416 0 1.266.557 2.503 1.63 3.582l.918.922-.46 1.926 2.267-.982.858.297c1.271.44 2.67.672 4.12.672 5.277 0 9.334-3.042 9.334-6.417 0-3.374-4.057-6.416-9.334-6.416zM8.458 15.95a1.458 1.458 0 110 2.917 1.458 1.458 0 010-2.917zm4.375 0a1.458 1.458 0 110 2.917 1.458 1.458 0 010-2.917zm4.375 0a1.458 1.458 0 110 2.917 1.458 1.458 0 010-2.917z",
    fill: "#9896E0"
  }))))), _view21 || (_view21 = /*#__PURE__*/React.createElement("view", {
    id: "church",
    viewBox: "120 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-632H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 .492c.644 0 1.167.522 1.167 1.166v2.333H17.5a1.167 1.167 0 010 2.334h-2.334v3.24l8.884 6.91c.284.22.45.56.45.92v10.097a1 1 0 01-1 1h-7.167v-6.417a2.333 2.333 0 10-4.666 0v6.417H4.5a1 1 0 01-1-1V17.396c0-.36.166-.7.45-.921l8.883-6.91v-3.24H10.5a1.167 1.167 0 110-2.333l2.333-.001V1.658c0-.644.523-1.166 1.167-1.166zm0 11.122l-8.167 6.352v8.192h3.5v-4.083a4.667 4.667 0 019.334 0v4.083h3.5v-8.192L14 11.614z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view22 || (_view22 = /*#__PURE__*/React.createElement("view", {
    id: "city",
    viewBox: "0 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3359H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.325v4.667H8.167v-4.667H10.5zm11.667-1.167v2.334H17.5v-2.334h4.667zm-11.667-3.5v2.334H8.167v-2.334H10.5zm11.667-1.166v2.333H17.5v-2.333h4.667zm-11.667-3.5v2.333H8.167v-2.333H10.5zm0-4.667v2.333H8.167V6.325H10.5z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.667 27.325A1.167 1.167 0 013.5 26.158V2.825c0-.644.522-1.167 1.167-1.167H14c.644 0 1.167.523 1.167 1.167v4.407l8.589 3.334c.448.174.744.606.744 1.087v14.505c0 .645-.522 1.167-1.167 1.167H4.667zm8.166-23.333h-7v21h7v-21zm2.334 5.742v15.258h7v-12.54l-7-2.718z",
    fill: "#9896E0"
  }))))), _view23 || (_view23 = /*#__PURE__*/React.createElement("view", {
    id: "clinic",
    viewBox: "30 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-632H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.834 17.25v6.575h16.333l-.001-6.546a5.251 5.251 0 002.335-.002l-.001 7.715c0 .644-.522 1.166-1.167 1.166H4.667A1.167 1.167 0 013.5 24.992v-7.69a5.246 5.246 0 002.334-.051zm8.333-3.342a1 1 0 011 1v1.916l1.916.001a1 1 0 011 1v.333a1 1 0 01-1 1h-1.916v1.917a1 1 0 01-1 1h-.334a1 1 0 01-1-1v-1.917h-1.916a1 1 0 01-1-1v-.333a1 1 0 011-1h1.916v-1.917a1 1 0 011-1h.334zm1.738-10.55l9.29 5.832a3.51 3.51 0 011.108 4.823 3.475 3.475 0 01-4.8 1.113l-7.456-4.68-7.566 4.69a3.475 3.475 0 01-4.795-1.14A3.51 3.51 0 012.821 9.18l9.407-5.833a3.47 3.47 0 013.677.01zm-2.328 1.905l-.129.07-9.407 5.833a1.17 1.17 0 00-.378 1.605c.314.512.959.694 1.487.441l.111-.06 8.793-5.453 8.68 5.449c.543.341 1.26.175 1.6-.371a1.17 1.17 0 00-.266-1.535l-.104-.073-9.29-5.833a1.157 1.157 0 00-1.097-.073z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view24 || (_view24 = /*#__PURE__*/React.createElement("view", {
    id: "clothing",
    viewBox: "60 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-632H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.992a4.667 4.667 0 011.167 9.186v1.148l10.645 6.402a2.333 2.333 0 01-1.312 4.263h-21a2.333 2.333 0 01-1.312-4.263l10.645-6.402v-2.168c0-.644.523-1.166 1.167-1.166a2.333 2.333 0 10-2.333-2.334 1.167 1.167 0 01-2.334 0A4.667 4.667 0 0114 3.992zm0 12.355L3.507 22.658h20.986L14 16.348z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view25 || (_view25 = /*#__PURE__*/React.createElement("view", {
    id: "club",
    viewBox: "300 114 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 114,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-4606h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9896E0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.977 9.48v3.996h-4.004v4.004H7.977v-4.004l3.995-.001.001-3.995h4.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.977 13.492c0 5.507-4.481 9.988-9.988 9.988C6.481 23.48 2 18.999 2 13.492a9.942 9.942 0 015.521-8.936 1 1 0 11.895 1.788A7.953 7.953 0 004 13.492c0 1.453.396 2.813 1.078 3.988h2.899v2.909a7.938 7.938 0 003.996 1.09v-4h4.004v2.924A8.033 8.033 0 0018.9 17.48h-2.923v-4h4a7.938 7.938 0 00-1.091-4h-2.909v-2.9a7.918 7.918 0 00-3.988-1.077 1 1 0 01-1-1l.001-.005-.001-.006v-2a1 1 0 112 0v1.062c5.039.503 8.988 4.767 8.988 9.938z"
  }))))), _view26 || (_view26 = /*#__PURE__*/React.createElement("view", {
    id: "co",
    viewBox: "330 104 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "bbLayer_1",
    "data-name": "Layer 1",
    viewBox: "-1 -1 26 26",
    width: 26,
    height: 26,
    x: 330,
    y: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bbcls-1",
    cx: 9.31,
    cy: 15.52,
    rx: 6.5,
    ry: 8.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M2.81 7.02h13v17h-13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M2.81 7.02h13v17h-13z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M2.41-1.93Q-.16 8.15 2.27 11.73C4.7 15.3 6.81 22.42 5.41 26.5S-7.12 23.1-7 14.91-2.77-2.8 0-2.77c1.78.02 2.6.3 2.41.84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    transform: "rotate(-71 9.308 15.523)",
    d: "M-.84 6.61h20.31v17.83H-.84z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M6.81 15.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M6.81 17.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M7.69 6.72l2.37-.83c1.8 4.75 2 8.31.53 10.71a13.57 13.57 0 00-1.71 7.25H6.35a15.75 15.75 0 012.08-8.49c1.01-1.63.83-4.52-.74-8.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M14.19 12.3S5 6.5 9.9-.08c0 0 8.19 5.31 4.29 12.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M4.96-.08h13.13V12.3H4.96z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M13 12.86s-4.71-9.2 5.48-11c-.01-.02 4.09 8.27-5.48 11z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M7.81 1.02h14v12h-14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    transform: "rotate(-62 14.805 7.027)",
    d: "M6.22-1.97h17.17v17.99H6.22z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M18.56 1.63l-6 11.25q-3.79-4.82-1.08-8a8.74 8.74 0 017.08-3.25z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M7.81 1.02h14v12h-14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "bbcls-1",
    cx: 15,
    cy: 16.73,
    rx: 8.17,
    ry: 5.56,
    transform: "rotate(-62.99 15.002 16.734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M7.81 8.02h14v17h-14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M7.81 8.02h14v17h-14z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M18.24 9.17c-.33 4-1.6 7.6-2.93 8.6-2 1.5-4.5 5-4.5 7.5s7.17.38 9-4c2-4.66 1.64-9.4.22-11-.6-.68-1.79-1.43-1.79-1.1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M14.81 13.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M12.81 14.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M16.81 18.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M11.81 16.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M15.81 20.02h1v1h-1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    d: "M18.37 9l1.76-.29c-.92 4.62-2.25 7.72-4.13 9.29-1.23 1-2.48 3.16-3.7 6.53l-1.63-.19c1.41-3.92 3-6.63 4.8-8.09 1.09-.94 2.12-3.33 2.9-7.25z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bbclip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-1",
    transform: "rotate(-60 14.81 16.53)",
    d: "M3.95 6.21h21.72v20.62H3.95z"
  })), /*#__PURE__*/React.createElement("style", null, ".bbcls-1{fill:none}.bbcls-2{clip-path:url(#bbclip-path)}.bbcls-3{isolation:isolate}.bbcls-4{clip-path:url(#bbclip-path-2)}.bbcls-5{opacity:0}.cls-6{clip-path:url(#bbclip-path-4)}.bbcls-7{clip-path:url(#bbclip-path-6)}.cls-8{clip-path:url(#bbclip-path-8)}.bbcls-9{clip-path:url(#bbclip-path-10)}.bbcls-10{fill:#fff}.bbcls-11{clip-path:url(#bbclip-path-11)}.bbcls-12{clip-path:url(#bbclip-path-12)}.bbcls-13{clip-path:url(#bbclip-path-16)}.cls-14{clip-path:url(#bbclip-path-17)}.bbcls-15{opacity:.75}.bbcls-16{clip-path:url(#bbclip-path-19)}.bbcls-17{clip-path:url(#bbclip-path-20)}.cls-18{clip-path:url(#bbclip-path-22)}.bbcls-19{clip-path:url(#bbclip-path-24)}.cls-20{clip-path:url(#bbclip-path-26)}.bbcls-21{clip-path:url(#bbclip-path-28)}.bbcls-22{clip-path:url(#bbclip-path-29)}.cls-23{clip-path:url(#bbclip-path-31)}.bbcls-24{clip-path:url(#bbclip-path-33)}.bbcls-25{clip-path:url(#bbclip-path-37)}.bbcls-26{clip-path:url(#bbclip-path-38)}.bbcls-27{clip-path:url(#bbclip-path-39)}.bbcls-28{clip-path:url(#bbclip-path-40)}.bbcls-29{clip-path:url(#bbclip-path-41)}.bbcls-30{clip-path:url(#bbclip-path-42)}.cls-31{clip-path:url(#bbclip-path-44)}"))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "bbcls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 72,
    transform: "matrix(.24 0 0 .24 2.64 6.96)",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAABICAYAAABSr21SAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAgklEQVRoQ+3bsRFAUABEQYz+e6MKP5MZESWI17yNL3kF3Hwc1zPGPf3ROsY97dv5tSMtXwNZcariVMWpilMVpypOVZyqOFVxquJUxamKUxWnKk5VnKo4VXGq4lTFqYpTFacqTlWcqjhVcariVMWpilMVpypOVZyqOFVxquJU85+v1C/d/BMRYbu8kwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 72,
    transform: "matrix(.24 0 0 .24 2.64 6.96)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAABICAYAAABSr21SAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAnUlEQVRoQ+3UsQ3DMBAEwZPB/vsi1IXZADPB0TtQAYz3sRN/sjiC15y77rnT0UgldbqCGklSTetGJW2ne59l27i0HS6j2i/XNc4PBepzOiAzjso4KuOojKMyjso4KuOojKMyjso4KuOojKMyjso4KuOojKMyjso4KuOojKMyjso4KuOojKMyjso4KuOojKMyjso4qmt9n1rrd7pD+gPzZyILeZJHXQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 99,
    height: 105,
    transform: "matrix(.24 0 0 .24 -2.64 2.88)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABpCAYAAAAuoJ3zAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEHUlEQVR4Xu2dO1bcMBRAL5ycw3TQiS478KyCrCJZXbIKWAXeQTrcZbqhIkUwER5/pKcn+fduN2fU3ePrJ2Q8V29vb28UpK5PAFTV7cTK/XFVUkbTnHl6bD4+O3fA3R9MzDtFZdT1ifr5T+931fEO525w7tD7/R74MrVAkyER3e/2KqaYjKY5Ty35YK9iCsp4nVrSy57EFJMxlqhQti6miIyYRIXSitnSRFZkmhqbojRZu5giMn79/D21RJ01iskuo7vRm4O1iMkuo1SiQlmymOwy5khUKM4dqI63i5nIsspY2lUxxhJG5ayjbfOiP9LmYgl7mLwyMuwvSjCXmGwy2nOLtVNSTDYZa0pUKF0x2hNZthv4kqcoTTRH5Swy1jRFaZIqJouMp8dmtTdvLSRissjYS6JCCRWjLmOviQplTIy6DEtUON1RWX20NRHhdEfl65G10WxlozcHzctZV8YWN3qlcPcHZRmWKDFVdasnwxIlp72B68mwcVaMu1eUYXlKo91zKMmQPS1o/E8UKMmwRMlpEwUKMixRafh/FlGQYYmSUh3vPn1OlmGJkuPczafPSTIsUWl0z9ITZViipHQTBYkyLFFyuomCBBmWqDT6HvdJkGGJktKXKEiQYYmS05coEMqwRKUx9ESiSEb9bH8ulzKUKBDKsCtDzlCiQCDDDpHSGHtoOlqGnXPLGUsUSGRYosSMJQoiZVii0pj6v44oGZYoOVOJglgZligxUw89Q4QMS5ScqTy1BMuwRMnxz7nHCJdhiRITkigIlGGJkhOaKAiUYYmSE5ooCJVhiRITmigIkGGJkhOTKAiQYYmSE5MomJDRNGdLVAIxiYJJGXbOLSU2UTAhw8655cQmCkZkWJ7SiE0UjMqwREmRJApGZFii5FTH+KsCBmRYotJQvTIsUXJCDpGG6JVhiZIzdc49xoUMS1Qa0kRBrwxLlJSUREGPDEuUnJREQUeGJSqNlETBhQxLlJTUREFHhiVKTmqiwJNhh0hppCYKPBl2iCRHI1Hgy7CbtxiNRMG7DEtUGhqJgncZlig5WomCVoYlSozkEGmIa0uUHK08tXy88bmuTzQv9jRIDNq/oXHx+u1/j+e82gYwgO8/vk4tiWL0XegmZhjnDjx8c1PLogh+Mb2J+Yx2oiBCho+J0U8UCGX47FFMjkSBggyfvUxkORIFyjJ8tiwmR6IgowyfLYnJlSgoJMNn7WJyJQpmkOGzRjG5EgUzy/BZw6+Y5UwULEhGy5JH5ZyJggXK8FmamJyJgoXL8JlbTO6rAlYkw2cOMQ/fnPr5RZdVyvBpmjP18yn7RJY7UbABGT65RuUSiYKNyfDRFFMiUbBhGT6pYkokCnYiwydWTKlEwQ5l+ISIKZUo2LmMlrFRuVSiwGRc4IspmSiAv6DQpqNsUi5iAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("image", {
    width: 99,
    height: 105,
    transform: "matrix(.24 0 0 .24 -2.64 2.88)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M5.81 14.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M5.81 16.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 72,
    transform: "matrix(.24 0 0 .24 2.64 6.96)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAABICAYAAABSr21SAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfklEQVRoQ+3PsRFAQAAAQfTf3KuC7DMjogTxmtv4klvHmM8+5vJH21cga07VnKo5VXOq5lTNqZpTNadqTtWcqjlVc6rmVM2pmlM1p2pO1ZyqOVVzquZUzamaUzWnak7VnKo5VXOq5lTNqZpTNadqTtWc6tdz63Fcz3neXx3pBfXKDUT2gX0+AAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 72,
    transform: "matrix(.24 0 0 .24 2.64 6.96)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAABICAYAAABSr21SAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAkklEQVRoQ+3SsQ2AMBQDUYOy/1pkDrJAOkT1GSH1hXu1m5N89GtW7zM7apUktZoxtdS2bWlJUpvW/eCWm8adqwGZcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRzVMe6nxnhXO6QP6OkYBkuB9pkAAAAASUVORK5CYII="
  }))))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "bbcls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 56,
    height: 53,
    transform: "matrix(.24 0 0 .24 4.8 -.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA1CAYAAAAUGCjAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAfElEQVRoQ+3PsQ2AIBQAUTAmtnZsofuPIVNAp5Wx+o5AfeRefc3liIg0sbXWJ9XrHnVIx7mnZRTROUjnIJ2DdA7SOUjnIJ2DdA7SOUjnIJ2DdA7SOUjnIJ2DdA7SOUjnIJ2DdA7SOUjnIJ2DdA7STT+YW3uj92/UIZWypR8umxDC2uOcRgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 56,
    height: 53,
    transform: "matrix(.24 0 0 .24 4.8 -.24)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA1CAYAAAAUGCjAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA00lEQVRoQ+2asQ7CQAxD3SpSV7ZO/QX4/8+AT+CW3sZWdTIDAsab7eTNWaLEdk66ad8P9n7CkXVdEL2feNxfo1pJrrcL5lGROgka5KhEGAIBADRucjbuDUSCCQZo3CAzuKjr8IAkGqwcVMfeZILwnSBRGtQnhwZd1/Qf9INCZerYVqeObXUChK/LMIGL2ptMHdvSfDXo3KS9yZQGpakHrwH14FWnjm11cpiMa0x8TKY0qI3/a8J8Q+vYlidHDrqu6S8HbVeUCVZ0as+DrXn+2d62BW/eHW6Ya6ET4wAAAABJRU5ErkJggg=="
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "bbcls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 101,
    height: 99,
    transform: "matrix(.24 0 0 .24 2.64 -4.8)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABjCAYAAACCJc7SAAAACXBIWXMAAC4jAAAuIwF4pT92AAADzUlEQVR4Xu2dPVIbQRBGP1SuQpnIJvQNVqeAU9ins08Bp9DewOFmKFMmB6oGIWY0P9s9v/1C2IDi8Wp7e0fFw/l8PkOpio3vAiU/KqVCVEqFqJQKUSkVolIqRKVUSBEpy3LyXTI0P3wXSPD2ugAApv0TpmnnuXo8HnI/0c/zEfPh/cvXVM5Xskv5++ef83sq50JWKbZKbDy/GBiz9V3WLdmkLMvp414SgjFbTPvdkHKySXl7XZKmrhHlZJESW4mNkeRkkZJaiQ1jtnh+Mb7LmkZcCkclNnqe1MSlcFZio0c5olKkKrHRkxxRKdKV2OhBjthCcllO2YUAwHx4L/LHwIlYKffWKblodYwWkRK6TslFa3JEpNRQiY1W5LDfU+b56LukGDQN1vwzAgKl1FqJjVonNVYptd1LQqlNDquUliqxUYscNimtPxsQNQwDLFJyrlNyUVIOi5ReKrFRQs5qKT1WYiOnnNVSeq7ERo6XbKukjFKJDclJbZWU0SqxISEnWcrIldjglJMspfUHRSk4DhImSWl1nZKLtZNakhStJIxUOdFStJJ4YuVES9FK0gmVE/WSq/aXQ7UT+pItqhSthBfXGB1cis+uEo/r3hwkZVlOenMXYNo/Wb8eJGU+aCUSuDYAXimlTjr2jqsSIECKViLDvT3ZXSlaiQz3KgE8UrQSGXzbZKcUrUSGkLeWTilaCT/GbL0rFsAhZZ6PWokA0z7sJZhdij4oshNaCWCRousUGUIrAWxStBJ2YioBbqRoJTLEVALcStFK2ImtBLiSopXIEPJccsunFK2EHd86xcUGgB6qE8K3TnGx0XWKDKmVAAGreyWN1EqAq4MTep6Lj7Xnir+dZlE56/n1+6fvkrtYjxhdDkroUjIF8QPeKicOrk95BR3GUzlhcFQCBEohVI4brkqASCmEforrO1yVAIlSCJ3ULnBWAqyUQowuh7MSgEkKMaIc7koAZinESB/l5q4EEJICjDGprV2nuBCTQvQsZ+06xYW4FKI3OVKVABmlEL0840hVAhSQQrQ8qUlWAhSUQrQoR7ISoAIpRCtypCsBKpJC1CxH4kHRRpH/iHqPadrBmMcqJ7XYk46pVFfKNTWN0bkqASqXQtQgR2Kd4qIJKUQpOTkrARo790W/nDUH3VLIdS8hmirllhyTWu5KgMalEJJyct5LiC6kENxySlQCdCYF4B0GpNcpLrqTQqyVk2Od4qJbKUSqnFKVAANIIWLklKwEGEgKEfKSrWQlwIBSCNekVroSYGApxK2c0pUAKuWDeT7CmMfsD4o2/gOT6w0ec0DUDgAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 101,
    height: 99,
    transform: "matrix(.24 0 0 .24 2.64 -4.8)",
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-17"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 51,
    transform: "matrix(.24 0 0 .24 7.68 .96)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAzCAYAAAApdnDeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAc0lEQVRoQ+3RsRGAMAwEQZuh/95QFXYGEUMkSlB+uo0/ufmZmTmaOKoBSavYM+IZcd3VDqHVs8ZSGUtlLJWxVMZSGUtlLJWxVMZSGUtlLJWxVMZSGUtlLJWxVMZSGUtlLJWxVMZSGUvVKnau9ebeX7VD+AEkJRAcgDbsXAAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 51,
    transform: "matrix(.24 0 0 .24 7.68 .96)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAAzCAYAAAApdnDeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAqElEQVRoQ+2XsRHEMAzDEJ/3380/wnuBdLlUygjuCaFWwyNl0ddad/3WjYFxGkiixabSYlOZFFSdxjJQOTskpgKyGE/wiJXFGJGzp4EkVA+Uy9nC4+ykAI1YNFp7Z2MZmgxja1ASnYDM2b6zqcwCjVqXs72zoXRdTEVVKnxfPEuUXa9x39lQZDtbntOjirHvzlpi3N04ld7ZVFR1URXja/+f2vs9zUXwAdt7UPtz0pgHAAAAAElFTkSuQmCC"
  }))))))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "bbcls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 72,
    transform: "matrix(.24 0 0 .24 7.68 7.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABICAYAAABIk43cAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAiElEQVR4Xu3RsRHCMAAEQZuh/95QFXYGEUMkSlC+uo0/uflzzjmPTTxWA0mxqq1in2N8jvF6r3aErZ4tVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqzqv6zvv+7faEf7lQhBGPUj3swAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 72,
    transform: "matrix(.24 0 0 .24 7.68 7.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABICAYAAABIk43cAAAACXBIWXMAAC4jAAAuIwF4pT92AAACJ0lEQVR4XuXVS3bDIAyF4T/Z/+bSRbQddtbTER3UTonCw2AeQmEQcyyZ8OU69uV2+3Jvty9eYVxzDVaGcy+Cde7vaB67Q80n60NNYyUUjGJD0JdI1p+bw8o0zSabgoIhbA5qJtkjUCxgj0Idi2NLoEsnWwpdNtka6JIPqFooLIY9A10q2X3TsXkOuswDKpZmCdSxALYVVH2yLaGqk20NdU4ptgcUFGJ7QdUl2xOqCtsbCkqwI6Aqko3iZH37qIXCZGxqY7Fka6FTk81trBSKqMn1mIXtAXWiFuofjp0FdW4wdgQUua43H4YdBZXX+fMhWA1QRmC1QB2dsZqgXZPNQZ/6ZL0x1PXCHoHKWm8odMBqhUJjbA306drtozUUGmJroblkW0GhETaHSdVKoYj+h/X8vsA4jc1hUrUaqKzF1giNU9gcJlUbDYUT2BwmVZsBhUpsDpOqzYJCBTaHSdVmQqEQm8PcjwqhUIAtgcqNaYDCQWwpFFF76OO/byQUDmBroHKD0eQHQiGDnQElgJJ3Re2IYmdBXWK9M1CIYC1CIYC1CgWBtQwFD2sdChtWokLnVocCXPG/gMDGIbjp1aAQSLYZFF1QgOu+dg0Uf064rgUK221cC5XnNEMh8oA6DSUP3XGjoCBu4/vxLFSuEYA6r2/UeE7WKBTkq8cwFPxkjUNh/8++ABT2Vw+YhwJc3t+/3efHz31j94M/3yb+XPbB/w8ga7Jv1vgFJEypEb1MwCIAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 72,
    transform: "matrix(.24 0 0 .24 7.68 7.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABICAYAAABIk43cAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAiElEQVR4Xu3RsRHCMAAEQZuh/95QFXYGEUMkSlC+uo0/uflzzjmPTTxWA0mxqmJVxaq2in2O8TnG673aEbZ6tlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqzqv6zvv+7faEf7EnRBGx+wKiwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("image", {
    width: 59,
    height: 72,
    transform: "matrix(.24 0 0 .24 7.68 7.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABICAYAAABIk43cAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAp0lEQVR4Xu3UsQ3DQAwEwZOh/iuzmvA3oMxwIrqEz/d2YiYLEjyu9z3XdafBOUlmdmMMZyZJTWxqWj1jrHOSPC2xVZtNalp9UFhlZzzJPLsxhrLNxgeFVHbG03TGSc1qX7sBEmOpjKUylspYKmOpjKUylspYKmOpjKUylspYKmOpjKUylspYKmOpjKUylspYKmOpjKUylspYKmOpqmKP9fnOWr/dHMIf8/s0FhomFwQAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M13.81 12.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M11.81 13.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M15.81 17.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M10.81 15.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bbcls-10",
    d: "M14.81 19.02h3v3h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "bbcls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bbcls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 121,
    height: 122,
    transform: "matrix(.24 0 0 .24 .24 1.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB6CAYAAACbbvznAAAACXBIWXMAAC4jAAAuIwF4pT92AAAE/0lEQVR4Xu2cPW7dOhCFTy4C5HZ2p/LtQHcVySqS1eWtwl5FtIN0T91zdzunMGjQiiSSEn8OyfNVQaIAAb6cmeHQ0qfX19dXiKa5uB4Q9SPJHSDJHSDJHVCN5Hm+Y57vrsfECp9dD7Dw/DQDAIbhivH2gGG4Ov6GMFSR5Gl6ef/1PN/x/DR/+D2xz6cazsn//vy9+Wfj7RHj+LD556ICyc9Ps7MXq4TvQy3ZlGZfJHsd6p48/Qrru+rX69AmOTTFa3z9NijVIJa8N2yFoBJOKnmaXjD9+t/1WBDDcMXXb4PrsSahkxyjTO/R45GLTrLPkSkGPfVrKsmpU7ykl35NJTlXipe03q9pJKcYtkJptV/TLENKCwbe/g2lqklKKJLMkOIlLfXr4pJzD1uhtFDCi0uupTzWLLtoT67pR3pq7tdFkxxrP52b2vp1sSTXfB1Y25VmsSTXmuI12FekRSTX2tv2YC7h2SWzH5nOwrgizS65xRSvwXTkyiq59RSvwdCvs0puadgKoXS/ziaZcT+dm1L9OpvkXlO8Ru5+nUVyL8NWCDlLeHLJPQ5bIeSQnXytGfoWRG/kWJEmTbKGrXBS9OukSZbgcFJcaSZLslJ8nlhHriSSNWzF5WwJTyI5drkRbxxdkUaXrBSn5ciRK7pkpTgPIf06qmQNW/nx6ddRJWs/XY69fh1NslJcnq1+HWUZMs93CSbADL3LmSiKZO2nuTktuaa3IHpgGK7xy7XOxFyMt78n7VOSU16PiXDG2+PqhH1OsoYtKrbOy4clq0xzsbf9OiRZwxYXa8OWzSHJOjJxsTZs2QRLVoq5cKUYOCBZvZgLn5uoIMk6MnEx3h5djwAIkKz9NB+uK0aDt2QNW1z4lGmDl2QNW1z4DFs2XpKVYi5cR6YlTsnT9KIUE7G1n97DLVnDFhW+w5bNrmQdmbjwPTIt2ZSsIxMXw3A9lGJgR7KGLS5Chy2bVck6MnERemRasipZKebiTIqBFck6MnFx5Mi05G/JGraoODps2XyQrGtELo4emZa8S9awxcWZI9OSd8katrg4O2zZXAClmI2zR6YlF0C9mI2Qu2IfLtpPcxFr2LK5jOND9P854jixhi2bDy+h60Xyshz9uo+L1S8N6OMu+Qn50Esom5+TeLtq1IozF6lSDHh8M0Tf5UpPyhQDHpIN6tfp+P7jH9cjp/CWbFC/jovPd7jOEiwZUL+OSeoUAwclG1TCz5Fy2LI5Jdkg2eGkHrZsPrse8GEcHzAMX1TCA4h5y+QiSpJt1K/d5Bi2bJxvUIRiylCKRXsr5BQMJEjyEvXrj+ROMZBBMqASbsg5bNlkkWzofUWa68i0JKtkQ48lvFSKgUKSDT2tSEulGCgsGeijX5cYtmyKSza03K9z7Kf3oJFsaK1flyzThihrzZi0tCKN/fPTR6FLsk3t/ZohxUCCtWZMal6RsqQYIE/ykpr6delhy4auJ+9RS79mqzxVJdmGuV8zpRioWLKBrYSzDFs21Us2MKxIS+6n92hGMlC+hDOmGGhMsqHEipQ1xUCjkg05+zXbsGXTtGRD6n5d+pbJRReSgXT9mrlMG7qRbIjdr1mHLZvuJBti9OsaUgxUttaMSYwVac63IM7QbZJtjvRr9mHLhvqqMRdHrjRrEQwoyau4+nVNKQYkeZOtEl7LsGUjyQ6Wsms4Mi2RZE+m6QXzf/fqUgwAfwA3S8Dg5kp/JwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("image", {
    width: 121,
    height: 122,
    transform: "matrix(.24 0 0 .24 .24 1.92)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB6CAYAAACbbvznAAAACXBIWXMAAC4jAAAuIwF4pT92AAAJ2UlEQVR4Xu2dT2/cxhmHf1wU6N52b9Rf9BtoJct/Kt3j2E4CpE0TX9qm7ecp+iWSi+tr2wDJXQvXERDpGxiSJW1P2tve3MNy6JfDdzgz5Aw5Q+4DLEQtuZc8+b3vO8MVnXz48OEDImN+tsT87B4np1OcnE50lw+eke6CEJmf3ec/X79a4PpqpfnEsEliS/LrVwtcMVL398c4OZ1gb3/MfGrYRJXk66sVKxgArq5W+OerBeZnS/b8kIkqyaoUc3zzMt2kOiMayddZUm3YlPA10Uj+x9/f6S5Rsr8/xtcvU91lvSUKyWLJ1JShLrmikNwkxRxD69fBS7YZtmwYUr8OeglVtWRqypCWXEEn2VeKOfrcr4NNss8Uc/R5izTYJLsetmzoW78OMsld98m+9evgklxnZ8s3sffr4JIcYnpi79dBJTnEFMvEuEUalOQ2l0xNiamEByPZ1f5028SwRRqM5C6XTE1IRusS/tuTCfb2wpQdhORYU4wESMhrb2+Mr/4QXr/uXHIMw5YSSbJ4PXkyxeMn4fTrziXHNGzJJAmUopME+PJ3KXZ3uy/hnUqOOsUoCkUCjBjpu7tjPHo8wc5Od7I7lRzrsCVIRkCCcoK5dD96NMXxw25KeGeSox22BFQisp9EuqqMP3w4xYPjdmV3tq0ZtWCZTGp+XP415/z8Hv/+1wK3t+3NIZ0kOeZhS6AbuhLok72zPcbR8QRbW377detJbvvLAD6hKZUTyyU7kVJ+e7fCD/9Z4Jdf/N6UaT3JfUgxUE7pKNGkW3xGHDPXHh5OMTt0369/pbvAJb1JMZNSuReXYE4k0nsXF/dY/G+F2WyCNHVXwltNcuxLphxNSsV5bt3MvYDye2k6xidP3WyRttaTQ/wyQF1KoaRvCOm6ZBNk0QCwWKzw/XfvcHnZ/L9bi5J7tGSCmTyuhKs+J5duweXFPb7/7h0Wi/ptrpVy3ZdhS8ANXZVlOfsMYHBtxf89aTrGQY1+7T3JvRm2ZKSUJuRYeS2TbBsWixV++nGBn3602+/3LrlPvRgAX3sZaybCq1JbhW2/9lquo9+f5tCV5SzS2nUzeQHAKIubrXiTEu5Vcm+WTAStOKB0d8pENBVehyrZ3sp178o0IfOWH5dOShcJeQ0cahH9mivhXpIc+5cBqrC5h8ymXHOtKw5mUxwcrLdIvWxr9jbFXHxtUiol2yeXF/dY3K1wMJu4l9zbJZNMlsj8uPwrDyPal/TFYoXLCw89ubcphp08E2+0RPsSfTCbuJU8P1v2PsVMpS6/QUTbSHfNwWyKNB27ltyzNbEMI0wpjynHbYsWg5czyX0u0wCU/Vc+LsCc8FWWZQ5m0/zYieTrq1X/U0yhwiVplcI9919Bmo7zFAOOJPc+xajov9mxbf+lA5dr6Qez4leIGksezJIJZvJsyrlrucA6xfLWZmPJfd3ZUiG15vIJcuxDog45xUBDyUMo0zm0p6L4k0US3YZvsWSSaSh5IMMWV3tt5HnsvxQ6bFFqS349sDJdQCGahL0MOeFjl6vqm521JA9p2ALsyjJ5qxKXorlhi1JL8qB6cQZXsUtv0L5tU84bwg1bFGvJQ0sxgEJZlio1T4uidSkGakge2pKJtWojz2FZ5jD5KwsryUMs0wWYKNdJtnxcF7o/XYWx5MHtT2fYyDPx5lK0askkYyx5yCk2EV3o2xrpTeUCZmVaYCR5kMOWgCnLSkdMSh34LGEybFGMJA82xYr+Kx8XYE64SC5Ft2SS0Uoewld6jKiIsolwV6JV+9NVGEge3rAlKHmRomzSf9kS3kC46bBFqZQ82DJNMPJhUc6biDZdMskoJQ91ycQhtebyCXJcR54J8ld6bFBK3qQYhf6rFE2RRLv0bTtsUVjJg14yCbjaayPPYbJtl0wyrORNihkUoknYyxDRzXpx/RQDjOTNkmmNTVkmb1VSR3SdJZMMI3kzbAm4il16g/Ztm3JuSN1hi1KQPOiv9MgQYVKl5vEguu6SSSaXvBm2CJxVG3k1yrJMkyWTTC55M2wpYKJcJ9nysY6mwxZlBGxSLGMjz8SbreimSyaZETDAr/QYYCK60Lc10k3kCmzuFZsw2pRpBqYsKx0xKbXwWcLVsEUZnZxO8E1k/4qoVxT9Vz4uwJywSS7F1bBFKTziqZdP0LMlQb5DlSRZikcfj8X5ygehks8A5fMqPnmaOu3FAvY5Xn17qq0VKnGyQGTCdNdnUnWPVXT5EHMZ5cPa1rcah7fFmYvRSRbH5Nomjzn2lWKgQrKgz0/X4ygIMREHNH6Wtc8UAwaSBUPp13JKqfAqefQzVddy/PFPv+FPOMJYsqDX/ZqTZtl/xWcAM8n0GZi+sJYM9Lhf6+Rlol0+y9p3ioGakgV9K+FacYDTZ1n7HLYojSQL+iJbFqddCyeoPXT5HrYoTp6Se3I6wf7+r+Mv4cnHH8IJE8DSRQn5nCku7zLpcJJkSrT9WpFScaxLaf45g6GrjWGLov0LClv29sf4+mWKk1P3G+2tQSMppbQyrVKy5WNBm4IBD0mWiaVfa9MKWCcbWE/WXaYYaEEyEEcJz8UYyJNFmw5dbQ5blFYkC0LeIm367yGbSG5rySTTqmRBiCVctZ1ZKZoKT1A5dHWVYqAjyYJgtkg5aUz/1a6bK+4hd5VioGPJQCD9WiWOCDQq4eQFfNzOnB22P2xROpcs6LJf52IqJKvuIZu82tifriIYyYIu+nUhgYnBtAwYb2c+/bS7Mi1wsq3pkk62SDNR+Pgj/8kirpU+I5Nuuf3+dF2CSzKllX6tSGkCmJfl7DNA8f1Pn3WfYsDDtqZLOtkilaJsm2yR7q1AUgwEnmQZH/1am1ag1j3kP3/b7bBFCa4nV+GrX9OUlhLLRFmkVZXumYe/gmhCVEmmuOrXPv495G//Ek6KgYglCxqVcEZY06Hr2fMUW1th9GJB9JIFtbZIFcLklOrWwuK1tTXGs+fd7E9X0RvJgH0J16YVsEp2iCkGeiZZYLpFKuTo5OXCybVyure3w0wx0FPJAl2/dnkP+a9/C2vYovRaskDVr13dQz46muLwqLu7TDoGIRlg+rUqpShK1t1D3t4Z4/mLMMu0YDCSBXm/NkiqSQl/8SLF1nZ4wxZlcJIF8/kSb+b3lSnV3UPe2R7j+WdhpxiIbFvTJScn6y3SN/Mlrt+v1sml0Dey4yQp/IqjB+H2Ycpgk0x5f73CmzdL3LxfqZMtpfzB8TQayUHfamyL3b0xfv9VisdPpuVEcyTxpBjYJJnl7X+XePv2XjlZH0eUYmAjWcnNzQo/v13i9mZVGLp2dsb47PPwhy3KRrKGm5sVzn9e4u5uvb7+/IsU24EvmWQ2kg05P1/i7nYVXYoB4P9d2ONb7wqUjAAAAABJRU5ErkJggg=="
  })))))))), _view27 || (_view27 = /*#__PURE__*/React.createElement("view", {
    id: "coach",
    viewBox: "90 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-632H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.539 9.546L8.544 4.064a1.167 1.167 0 012.192-.798l1.996 5.482-2.193.798zm3.436-1.25l.81-4.596a1.167 1.167 0 012.298.405l-.576 3.269-2.532.921zM6.979 11.1L4.221 8.786A1.167 1.167 0 015.721 7l3.575 3-.402.146a9.361 9.361 0 00-1.915.956z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.319 19.366l1.995 5.482a1.75 1.75 0 01-2.243-1.046l-.798-2.193a1.75 1.75 0 011.046-2.243zm4.834 1.345a5.25 5.25 0 0010.156-2.35l-.166-1.555 7.062-3.823-1.306-3.59-6.578 2.394a3.5 3.5 0 01-6.567 2.424 5.25 5.25 0 00-2.6 6.5zm4.782-7.328a1.167 1.167 0 102.193-.798l-.798-2.193 9.867-3.59a1.167 1.167 0 011.495.697l2.05 5.631a1.167 1.167 0 01-.54 1.426l-6.573 3.557a7.583 7.583 0 11-10.136-6.324l1.644-.599.798 2.193z",
    fill: "#9896E0"
  }))))), _view28 || (_view28 = /*#__PURE__*/React.createElement("view", {
    id: "codes",
    viewBox: "300 141 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 141,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-3793H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3.492a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2v-14a2 2 0 012-2h20zm0 2H2v14h20v-14zm-4.5 8.5a1 1 0 01.117 1.993l-.117.007H13a1 1 0 01-.117-1.993l.117-.007h4.5zM7.05 8.157l.1.076 3.324 2.848a1.2 1.2 0 01.095 1.732l-.095.09L7.15 15.75a1 1 0 01-1.392-1.43l.09-.088 2.614-2.241-2.614-2.24a1 1 0 01-.184-1.31l.076-.101a1 1 0 011.31-.184z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view29 || (_view29 = /*#__PURE__*/React.createElement("view", {
    id: "coffee",
    viewBox: "120 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-776H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.188 1.804c.563 0 1.02.457 1.02 1.021 0 1.524-.571 2.667-1.73 3.247-.397.197-.603.61-.603 1.42a1.02 1.02 0 01-2.042 0c0-1.524.572-2.667 1.731-3.247.396-.198.603-.61.603-1.42 0-.564.457-1.02 1.02-1.02zm4.666 0a1.02 1.02 0 011.021 1.021c0 1.524-.571 2.667-1.731 3.247-.396.197-.602.61-.602 1.42a1.02 1.02 0 01-2.042 0c0-1.524.571-2.667 1.731-3.247.396-.198.602-.61.602-1.42 0-.564.457-1.02 1.021-1.02zm4.667 0c.564 0 1.02.457 1.02 1.021 0 1.524-.57 2.667-1.73 3.247-.396.197-.603.61-.603 1.42a1.02 1.02 0 11-2.041 0c0-1.524.571-2.667 1.73-3.247.397-.198.603-.61.603-1.42 0-.564.457-1.02 1.02-1.02z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667 24.992a1 1 0 011 1v.333a1 1 0 01-1 1H6.833a1 1 0 01-1-1v-.333a1 1 0 011-1h10.834zM20 9.825a1 1 0 011 1v1.333h1.13a4.152 4.152 0 014.12 4.667 5.327 5.327 0 01-5.286 4.667h-2.765A8.75 8.75 0 013.5 15.075v-4.25a1 1 0 011-1H20zm-1.333 2.333H5.833v2.917a6.417 6.417 0 1012.834 0v-2.917zm3.428 2.334H21v.583a8.712 8.712 0 01-1.01 4.083h.938a3.08 3.08 0 002.989-2.333 1.878 1.878 0 00-1.822-2.333z",
    fill: "#9896E0"
  }))))), _view30 || (_view30 = /*#__PURE__*/React.createElement("view", {
    id: "com",
    viewBox: "330 130 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "bfa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.728 21.345l.176.166a10.009 10.009 0 01-6.855-8.51h2.985c.231 3.367 1.623 6.341 3.694 8.344zM21.951 13a10.009 10.009 0 01-6.83 8.504c2.163-2.003 3.624-5.046 3.861-8.504zm-4.975 0c-.26 3.238-1.77 6.064-3.965 7.653l.088-.067V13zM10.9 13v7.574l-.126-.095c-2.069-1.617-3.483-4.356-3.733-7.478L10.9 13zm-5.865-2H2.05a10.009 10.009 0 016.867-8.515C6.742 4.486 5.274 7.535 5.034 11zM10.9 3.431V11H7.04c.257-3.183 1.723-5.967 3.86-7.569zm2.202-.012c2.145 1.6 3.617 4.39 3.875 7.58H13.1zm2.008-.926A10.009 10.009 0 0121.951 11h-2.97c-.232-3.37-1.627-6.344-3.701-8.346z",
    id: "bfb"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-6641H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#bfa)",
    fillRule: "nonzero",
    xlinkHref: "#bfb"
  })))), _view31 || (_view31 = /*#__PURE__*/React.createElement("view", {
    id: "community",
    viewBox: "150 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3791H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.093 2.825a4.668 4.668 0 014.303 2.856 6.695 6.695 0 00-2.023 1.32 2.333 2.333 0 00-4.613.491c0 1.816 1.189 3.5 2.333 3.5.086 0 .171-.01.257-.028a6.32 6.32 0 00-.052.577l-.006.293.01.385.03.388c.024.233.058.467.102.701-.11.012-.224.017-.34.017-1.07 0-1.981-.437-2.708-1.118a2.544 2.544 0 00-2.034 2.814l.03.18.79 3.957h1.986c-.012.374.008.752.061 1.131l.065.38.164.823H2.216a1.167 1.167 0 01-1.144-.938l-.979-4.896a4.879 4.879 0 012.915-5.462 6.948 6.948 0 01-.581-2.704 4.667 4.667 0 014.666-4.667zm13.814 0a4.667 4.667 0 014.666 4.667c0 .875-.201 1.828-.582 2.706a4.871 4.871 0 012.916 5.46l-.98 4.896a1.165 1.165 0 01-1.143.938H22.55l.165-.824.056-.322c.032-.216.054-.433.065-.65l.008-.327-.005-.21h1.987l.792-3.958c.022-.11.036-.22.044-.332l.005-.167a2.544 2.544 0 00-2.055-2.497l-.141.13c-.702.607-1.565.99-2.565.99-.117 0-.23-.005-.343-.015a7.8 7.8 0 00.144-1.476 6.74 6.74 0 00-.056-.87c.084.018.17.028.255.028 1.144 0 2.333-1.684 2.333-3.5A2.333 2.333 0 0018.625 7a6.68 6.68 0 00-2.02-1.32 4.664 4.664 0 014.302-2.856z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.908c2.738 0 4.958 2.206 4.958 4.926 0 .998-.274 2.092-.766 3.077l-.107-.047A4.875 4.875 0 0121 20.325l-.98 4.896a1.164 1.164 0 01-1.143.937H9.123a1.167 1.167 0 01-1.144-.937L7 20.325a4.879 4.879 0 012.807-5.416c-.491-.984-.765-2.077-.765-3.075 0-2.72 2.22-4.926 4.958-4.926zm-2.723 9.97l.016-.004a2.544 2.544 0 00-2.034 2.814l.029.18.79 3.957h7.842l.792-3.957c.022-.11.037-.22.044-.332l.005-.167a2.544 2.544 0 00-2.038-2.494l-.023.024c-.161.142-.33.273-.504.391a4.02 4.02 0 01-.797.433 3.955 3.955 0 01-1.399.252 3.96 3.96 0 01-1.43-.264 4.042 4.042 0 01-.735-.4 4.996 4.996 0 01-.558-.433zM14 9.242c-1.453 0-2.625 1.164-2.625 2.592 0 1.882 1.417 3.824 2.625 3.824s2.625-1.942 2.625-3.824c0-1.428-1.172-2.592-2.625-2.592z",
    fill: "#9896E0"
  }))))), _view32 || (_view32 = /*#__PURE__*/React.createElement("view", {
    id: "company",
    viewBox: "150 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3503H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.833 16.825a1 1 0 011 1v8.5a1 1 0 01-1 1H11.5a1 1 0 01-1-1v-8.5a1 1 0 011-1h.333zm4.667 0a1 1 0 011 1v8.5a1 1 0 01-1 1h-.333a1 1 0 01-1-1v-8.5a1 1 0 011-1h.333z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 2.825a1.167 1.167 0 012.334 0v4.667h3.5c.644 0 1.166.522 1.166 1.166v3.5H21c.644 0 1.167.523 1.167 1.167v13a1 1 0 01-1 1h-.334a1 1 0 01-1-1V14.492H8.167v11.833a1 1 0 01-1 1h-.334a1 1 0 01-1-1v-13c0-.644.523-1.167 1.167-1.167h1.167v-3.5c0-.644.522-1.166 1.166-1.166h3.5V2.825zm4.667 7h-7v2.333h7V9.825z",
    fill: "#9896E0"
  }))))), _view33 || (_view33 = /*#__PURE__*/React.createElement("view", {
    id: "cool",
    viewBox: "150 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-776H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.701 6.66a4.667 4.667 0 015.221 1.232l3.034 3.412.042.05.627-.112A1.167 1.167 0 0128 12.39v4.143a6.068 6.068 0 01-5.519 6.044l-.898.081a5.884 5.884 0 01-6.416-5.832h-2.334l-.004.193a5.884 5.884 0 01-6.412 5.64l-.898-.082A6.068 6.068 0 010 16.533V12.39a1.167 1.167 0 011.375-1.148l.627.113.043-.05 3.033-3.413A4.667 4.667 0 0110.3 6.659l.634.254a1.167 1.167 0 01-.866 2.166l-.634-.253a2.333 2.333 0 00-2.61.616l-2.136 2.401 7.325 1.333a1 1 0 01.821.984v.331h2.333v-.331a1 1 0 01.822-.984l7.325-1.333-2.135-2.401a2.333 2.333 0 00-2.438-.678l-.172.062-.634.253a1.167 1.167 0 01-.867-2.166zM2.333 13.787v2.745a3.735 3.735 0 003.397 3.72l.898.082a3.55 3.55 0 003.872-3.536v-1.527l-8.167-1.484zm23.334 0L17.5 15.272V16.8a3.55 3.55 0 003.872 3.536l.898-.082a3.735 3.735 0 003.397-3.72v-2.745z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view34 || (_view34 = /*#__PURE__*/React.createElement("view", {
    id: "dance",
    viewBox: "300 168 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 168,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-4081h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.164 4.586a1 1 0 01-.404 1.266l-.104.054-4.207 1.87.21.186c1.534 1.391 2.173 2.476 2.837 4.419l.317.965a5.777 5.777 0 001.203 2.754l.09.114a3.5 3.5 0 01.718 1.597 1 1 0 01-1.155-.005c-1.544-1.103-2.171-2.082-2.785-3.924l-.274-.835c-.593-1.744-1.107-2.567-2.519-3.803a1 1 0 01-.094-1.41l.092-.092a1 1 0 01.151-1.611l.104-.053 4.5-2a1 1 0 011.32.508zm2.672 2.812a1 1 0 01.404-1.266l.104-.054 4.5-2a1 1 0 01.916 1.774l-.104.054-4.207 1.87.21.186c1.534 1.391 2.173 2.476 2.837 4.419l.201.61c.527 1.654.928 2.325 2.134 3.187a1 1 0 01-1.162 1.628c-1.544-1.103-2.171-2.082-2.785-3.924l-.274-.835c-.593-1.744-1.107-2.567-2.519-3.803a1 1 0 01-.094-1.41l.092-.092a.996.996 0 01-.253-.344z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.868 1.492c.253 0 .486.094.663.251a2.47 2.47 0 00-.086 1.129l.719 4.679-1.106 1.328a5.65 5.65 0 00-.465.646l-.077-.963a137.93 137.93 0 00-.396-3.899l-.138-1.171H6.081l.577 3.75a3 3 0 01-.539 2.22l-.121.157-1.251 1.5a2.146 2.146 0 00-.497 1.373c0 .452.135.893.385 1.266l.114.156.09.113a7 7 0 011.49 3.573l.028.302.175 2.456c.046.64.578 1.135 1.219 1.135.885 0 1.657-.602 1.874-1.46.442-1.752.753-3.288.934-4.6.135.234.288.456.458.668l.09.114a3.5 3.5 0 01.759 1.937l.06.854c-.11.488-.23.994-.362 1.517a3.932 3.932 0 01-3.813 2.97A3.222 3.222 0 014.537 20.5l-.175-2.455a5 5 0 00-1.083-2.767l-.091-.114a4.276 4.276 0 01-.937-2.671c0-.97.34-1.908.96-2.653l1.251-1.5a1 1 0 00.22-.793l-.754-4.902a1 1 0 01.989-1.152h5.952zm9 0a1 1 0 01.992.877l.132 1.08.121 1.036c.425 3.72.637 6.556.637 8.507 0 1.883-.396 4.393-1.187 7.53a3.932 3.932 0 01-3.813 2.97 3.222 3.222 0 01-3.214-2.993l-.175-2.455a5 5 0 00-1.083-2.767l-.091-.114a4.276 4.276 0 01-.937-2.671c0-.97.34-1.908.96-2.653l1.251-1.5a1 1 0 00.22-.793l-.754-4.902a1 1 0 01.989-1.152h5.952zm-.886 2h-3.901l.577 3.75a3 3 0 01-.539 2.22l-.121.157-1.251 1.5a2.146 2.146 0 00-.497 1.373c0 .452.135.893.385 1.266l.114.156.09.113a7 7 0 011.489 3.572l.028.302.175 2.456c.046.64.578 1.135 1.219 1.135.885 0 1.657-.602 1.874-1.46.754-2.99 1.126-5.348 1.126-7.04l-.005-.533-.017-.61c-.063-1.798-.266-4.197-.608-7.186l-.138-1.171z",
    fill: "#9896E0"
  }))))), _view35 || (_view35 = /*#__PURE__*/React.createElement("view", {
    id: "de",
    viewBox: "330 156 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 156,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "bka"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.329%",
    y1: "20.883%",
    x2: "50%",
    y2: "124.299%",
    id: "bkb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-6803h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.462 6.484a4.221 4.221 0 01-1.537 5.755l-.105.057.001.003-15.583 9.028-.002-.003-.084.047a4.19 4.19 0 01-5.545-1.646 4.222 4.222 0 011.433-5.693v-.002l.094-.055.01-.005.009-.007 15.47-8.961.103-.06a4.19 4.19 0 015.736 1.542z",
    fill: "url(#bka)",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.758 22.289c-.916-1.812-.71-3.77.54-5.112 1.182-1.27 2.982-1.614 4.477-.856a1.51 1.51 0 001.496-.066c.47-.286.763-.771.803-1.332a4.123 4.123 0 011.947-3.23c1.122-.683 2.478-.743 3.626-.161a1.51 1.51 0 001.495-.067c.47-.286.763-.77.803-1.332a4.123 4.123 0 011.947-3.23c1.123-.682 2.478-.743 3.626-.16.736.372 1.476.071 1.883-.391.561-.637.562-1.536.005-2.52l-.014-.024 1.955-1.222c1.327 2.275.69 4.213-.297 5.334-1.183 1.345-3.013 1.722-4.555.941A1.51 1.51 0 0019 8.928c-.47.286-.763.771-.803 1.332a4.123 4.123 0 01-1.947 3.23c-1.122.682-2.478.743-3.626.16a1.51 1.51 0 00-1.495.067c-.47.286-.763.772-.803 1.332a4.123 4.123 0 01-1.948 3.23c-1.122.683-2.477.743-3.626.161-.712-.36-1.443-.08-1.85.357-.55.59-.602 1.452-.142 2.363L.794 22.356l-.036-.067z",
    fillOpacity: 0.75,
    fill: "url(#bkb)",
    transform: "translate(-1)"
  }))))), _view36 || (_view36 = /*#__PURE__*/React.createElement("view", {
    id: "deals",
    viewBox: "150 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-776H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.966 2.287l2.069 3.899 4.347.763-.618 4.37 3.07 3.173-3.07 3.172.618 4.371-4.347.763-2.07 3.899L14 24.758l-3.966 1.939-2.069-3.9-4.347-.762.618-4.37-3.07-3.173 3.07-3.173-.618-4.37 4.347-.763 2.07-3.9L14 4.227l3.966-1.94zm-1.004 3.087L14 6.822l-2.962-1.448-1.546 2.913-3.248.57.462 3.265-2.293 2.37 2.293 2.37-.462 3.265 3.248.57 1.546 2.912L14 22.161l2.962 1.448 1.546-2.912 3.248-.57-.462-3.265 2.293-2.37-2.293-2.37.462-3.265-3.248-.57-1.546-2.913zm-.045 10.284a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm.825-4.908a1.167 1.167 0 010 1.65l-5.834 5.833a1.167 1.167 0 11-1.65-1.65l5.834-5.833a1.167 1.167 0 011.65 0zm-6.659-.925a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view37 || (_view37 = /*#__PURE__*/React.createElement("view", {
    id: "default",
    viewBox: "330 182 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "bma9e5757a-0a9c-480d-84e8-643a3af24c6d",
    "data-name": "Layer 1",
    viewBox: "-1 -1 26 26",
    width: 26,
    height: 26,
    x: 330,
    y: 182,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bmaa6f2180-a61b-44e8-826b-e7203f86111c{fill:#9e9de5}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bmaa6f2180-a61b-44e8-826b-e7203f86111c",
    x: 2,
    y: 11,
    width: 20,
    height: 2,
    rx: 1,
    transform: "rotate(-45 12 12)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bmaa6f2180-a61b-44e8-826b-e7203f86111c",
    x: 0.17,
    y: 8.17,
    width: 18,
    height: 2,
    rx: 1,
    transform: "rotate(-45 9.17 9.172)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bmaa6f2180-a61b-44e8-826b-e7203f86111c",
    x: 5.83,
    y: 13.83,
    width: 18,
    height: 2,
    rx: 1,
    transform: "rotate(-45 14.831 14.827)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "bmaa6f2180-a61b-44e8-826b-e7203f86111c",
    x: 1.34,
    y: 5.34,
    width: 10,
    height: 2,
    rx: 1,
    transform: "rotate(-45 6.338 6.345)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "bmaa6f2180-a61b-44e8-826b-e7203f86111c",
    x: 12.66,
    y: 16.66,
    width: 10,
    height: 2,
    rx: 1,
    transform: "rotate(-45 17.663 17.654)"
  }))), _view38 || (_view38 = /*#__PURE__*/React.createElement("view", {
    id: "design",
    viewBox: "300 195 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 195,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-4750h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 16.497c0 3.857-3.14 6.995-7 6.995-3.165 0-5.842-2.11-6.705-4.996H2a1 1 0 01-1-1V3.507a1 1 0 011-1h10.96a1 1 0 110 2H3v11.99h6c0-.374.03-.75.089-1.117a1 1 0 111.975.318A5.004 5.004 0 0016 21.493c2.757 0 5-2.24 5-4.996a4.99 4.99 0 00-1.269-3.327.999.999 0 111.492-1.33A6.983 6.983 0 0123 16.496",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.501h1.624l6.961-6.086-1.355-1.532L12 9.967v1.534zm2 1.998h-3a1 1 0 01-1-.999V9.502c0-.294.13-.574.356-.764l8.332-7.01a1 1 0 011.394.101l2.667 3.014a1.002 1.002 0 01-.09 1.414l-8 6.995A1 1 0 0114 13.5z",
    fill: "#9896E0"
  }))))), _view39 || (_view39 = /*#__PURE__*/React.createElement("view", {
    id: "direct",
    viewBox: "0 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-4079H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.31 15.587a1.167 1.167 0 010 1.65L3.835 19.71a1.167 1.167 0 11-1.65-1.65l2.475-2.474a1.167 1.167 0 011.65 0zm6.6 6.6a1.167 1.167 0 010 1.65l-2.475 2.474a1.167 1.167 0 11-1.65-1.65l2.475-2.475a1.167 1.167 0 011.65 0zm-2.64-3.96a1.167 1.167 0 010 1.65L7.795 22.35a1.167 1.167 0 11-1.65-1.65l2.475-2.474a1.167 1.167 0 011.65 0z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.108 3.155c.07.226.07.468 0 .694L19.65 24.58a1.167 1.167 0 01-2.079.31l-5.652-8.313-8.313-5.653a1.167 1.167 0 01.31-2.079l20.73-6.457a1.167 1.167 0 011.46.767zm-5.284 2.867L6.919 10.353l5.699 3.875 8.206-8.206zm1.649 1.65l-8.205 8.206 3.874 5.699 4.33-13.904z",
    fill: "#9896E0"
  }))))), _view40 || (_view40 = /*#__PURE__*/React.createElement("view", {
    id: "discount",
    viewBox: "30 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-3935H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.966 2.287l2.069 3.899 4.347.763-.618 4.37 3.07 3.173-3.07 3.172.618 4.371-4.347.763-2.07 3.899L14 24.758l-3.966 1.939-2.069-3.9-4.347-.762.618-4.37-3.07-3.173 3.07-3.173-.618-4.37 4.347-.763 2.07-3.9L14 4.227l3.966-1.94zm-1.004 3.087L14 6.822l-2.962-1.448-1.546 2.913-3.248.57.462 3.265-2.293 2.37 2.293 2.37-.462 3.265 3.248.57 1.546 2.912L14 22.161l2.962 1.448 1.546-2.912 3.248-.57-.462-3.265 2.293-2.37-2.293-2.37.462-3.265-3.248-.57-1.546-2.913zm-.045 10.284a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm.825-4.908a1.167 1.167 0 010 1.65l-5.834 5.833a1.167 1.167 0 11-1.65-1.65l5.834-5.833a1.167 1.167 0 011.65 0zm-6.659-.925a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view41 || (_view41 = /*#__PURE__*/React.createElement("view", {
    id: "doctor",
    viewBox: "60 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-776H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 2.825c.644 0 1.166.522 1.166 1.167v4.023a8.005 8.005 0 01-3.414 6.558 6.242 6.242 0 01-2.419 1.02v3.274a4.958 4.958 0 009.76 1.239 4.084 4.084 0 112.37.084 7.294 7.294 0 01-14.463-1.323v-3.274a6.242 6.242 0 01-2.42-1.02 8.005 8.005 0 01-3.414-6.558V3.992a1.167 1.167 0 112.334 0v4.023c0 1.85.903 3.585 2.419 4.646a3.92 3.92 0 004.495 0A5.671 5.671 0 0014 8.015V3.992c0-.645.522-1.167 1.167-1.167zm4.804 14.098a1.74 1.74 0 00.418.598l.027.024a1.748 1.748 0 002.336 0h-.001l.027-.024a1.76 1.76 0 00.07-.07l-.097.094a1.76 1.76 0 00.406-.538l.039-.084.012-.03a1.737 1.737 0 00.125-.651 1.75 1.75 0 00-3.5 0l.001.056a1.756 1.756 0 00.112.564l.013.031z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view42 || (_view42 = /*#__PURE__*/React.createElement("view", {
    id: "dog",
    viewBox: "300 222 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 222,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-2692h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.258 20.303a6.45 6.45 0 001.807.895l-1.233 1.849a1 1 0 01-1.723-1.01l.06-.1 1.089-1.634zM12.5 1.492a4.503 4.503 0 014.184 2.84l.059.16H20.9a1.1 1.1 0 011.094.98l.006.12v4.65a4.25 4.25 0 01-4.044 4.245l-.206.005-1.639-.001.012.027c.399.865.715 1.674.948 2.426l.11.372c.618 2.205-.27 4.77-2.126 6.008a1 1 0 11-1.11-1.664c1.12-.747 1.7-2.417 1.31-3.804-.302-1.078-.823-2.331-1.565-3.756a1.1 1.1 0 01.855-1.601l.12-.007h3.085a2.25 2.25 0 002.245-2.096l.005-.154V6.49h-4.903l-.122-.858a2.5 2.5 0 00-2.306-2.136l-.169-.005h-1.543l-.176.003a7 7 0 00-6.777 6.756L4 10.49v4.476l.004.175a3 3 0 005.996-.15c0-.677-.122-1.286-.395-2.1L9.22 11.81c-.48-1.337-.726-2.281-.841-3.507a1 1 0 011.991-.187c.087.926.264 1.664.61 2.672l.478 1.34.044.129c.335 1 .498 1.811.498 2.734a5 5 0 01-5 5 5.004 5.004 0 01-4.98-4.554l-.015-.222L2 14.992v-4.5c0-4.778 3.729-8.702 8.471-8.984l.184-.01v-.006H12.5zm1.343 4.838l.26 1.477a1 1 0 01-1.969.347l-.26-1.477a1 1 0 111.97-.347z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view43 || (_view43 = /*#__PURE__*/React.createElement("view", {
    id: "email",
    viewBox: "90 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-2834H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5.158a2.333 2.333 0 012.333 2.334v14a2.333 2.333 0 01-2.333 2.333h-21a2.333 2.333 0 01-2.333-2.333v-14A2.333 2.333 0 013.5 5.158h21zm0 3.764l-8.997 7.58a2.334 2.334 0 01-2.849.12l-.157-.12L3.5 8.921v12.57h21V8.922zm-1.922-1.43H5.42L14 14.717l8.578-7.225z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view44 || (_view44 = /*#__PURE__*/React.createElement("view", {
    id: "energy",
    viewBox: "120 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-920H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.333 26.158a2.333 2.333 0 11-4.666 0h4.666zM14 1.658c5.799 0 10.5 4.701 10.5 10.5 0 3.997-2.233 7.473-5.52 9.247l-.455 1.82a2.333 2.333 0 01-2.263 1.767h-4.524a2.333 2.333 0 01-2.263-1.768l-.455-1.82a10.498 10.498 0 01-5.52-9.246c0-5.799 4.701-10.5 10.5-10.5zm0 2.334a8.167 8.167 0 00-3.872 15.36l.906.488.704 2.818h4.524l.704-2.818.906-.489A8.167 8.167 0 0014 3.991zm.562 2.374c.132.066.215.2.215.348v4.569h2.102a.621.621 0 01.555.9l-3.475 6.95a.388.388 0 01-.736-.174V14.39h-2.102a.621.621 0 01-.555-.9l3.475-6.95a.388.388 0 01.521-.174z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view45 || (_view45 = /*#__PURE__*/React.createElement("view", {
    id: "es",
    viewBox: "330 208 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "buLayer_1",
    "data-name": "Layer 1",
    viewBox: "-1 -1 26 26",
    width: 26,
    height: 26,
    x: 330,
    y: 208,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulinear-gradient",
    x1: -272.11,
    y1: 414.26,
    x2: -272.11,
    y2: 413.32,
    gradientTransform: "matrix(23.01 0 0 -22 6273.33 9116.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8be0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulinear-gradient-2",
    x1: -260.51,
    y1: 399.84,
    x2: -260.79,
    y2: 398.05,
    gradientTransform: "matrix(12 0 0 -12 3145 4795.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8be0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bulinear-gradient-3",
    x1: -266.71,
    y1: 409.65,
    x2: -267.11,
    y2: 409.2,
    gradientTransform: "matrix(16 0 0 -18 4275 7389.02)",
    xlinkHref: "#bulinear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, ".bucls-1{fill:url(#bulinear-gradient)}.bucls-2{fill:url(#bulinear-gradient-2)}.bucls-3{fill:url(#bulinear-gradient-3)}.bucls-4{fill:#fff}"))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "buart_icons_tld_es",
    "data-name": "art/icons/tld/es"
  }, /*#__PURE__*/React.createElement("path", {
    id: "buCombined-Shape",
    className: "bucls-1",
    d: "M5.45 2a4 4 0 012.94 1.29 3.53 3.53 0 01.46-.15 4 4 0 014.72 2.3l.39.69 2-1.13 1.85 3.2A8 8 0 1110 10.72L9 9l3.23-1.87-.38-.66a1.54 1.54 0 00-.05-.17l-.08-.13a2 2 0 00-2.34-1.1 3.93 3.93 0 01.07.93h-1.3v.07L8 6.22a4 4 0 01-7-2.14l1.73-.22-.43-.33A4 4 0 015.21 2zm0 2a2 2 0 00-1.58.77L3 4.11a2 2 0 003.48.74l.25-.36A2 2 0 005.45 4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buOval-19-Copy",
    className: "bucls-2",
    cx: 16,
    cy: 16,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "buCombined-Shape-2",
    "data-name": "Combined-Shape",
    className: "bucls-3",
    d: "M12 6v3.07a8 8 0 11-8 0V6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "buRectangle-24",
    className: "bucls-4",
    d: "M7 9h2v2H7z"
  })))), _view46 || (_view46 = /*#__PURE__*/React.createElement("view", {
    id: "events",
    viewBox: "150 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-920H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0EC",
    d: "M3.5 9.825h21v2.333h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.833 1.658c.645 0 1.167.523 1.167 1.167v1.167h2.333a2.333 2.333 0 012.334 2.333v17.5a2.333 2.333 0 01-2.334 2.333H4.667a2.333 2.333 0 01-2.334-2.333v-17.5a2.333 2.333 0 012.334-2.333H7V2.825a1.167 1.167 0 012.333 0v1.167h9.334V2.825c0-.644.522-1.167 1.166-1.167zM7 6.325H4.667v17.5h18.666v-17.5H21v.583a1.167 1.167 0 01-2.333 0v-.583H9.333v.583a1.167 1.167 0 01-2.333 0v-.583zm11.496 8.217a1.167 1.167 0 010 1.65l-4.667 4.666a1.167 1.167 0 01-1.65 0l-2.675-2.675a1.167 1.167 0 111.65-1.65l1.85 1.85 3.842-3.841a1.167 1.167 0 011.65 0z",
    fill: "#9896E0"
  }))))), _view47 || (_view47 = /*#__PURE__*/React.createElement("view", {
    id: "express",
    viewBox: "180 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-3215H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.004 12.158l.212.007.241.023.235.038.296.073.11.034.163.058.157.065.137.064.154.08.05.03c.074.042.148.089.22.138l.176.129.185.155.14.132 4.946 4.947a1.168 1.168 0 011.653-.003l.825.825a1.167 1.167 0 010 1.65l-.825.825-.825-.825-4.95 4.95.825.825-.825.825a1.167 1.167 0 01-1.65 0l-.825-.825a1.167 1.167 0 01-.003-1.647l-.905-.906h-9.25l-.145-.003-.198-.014-.22-.028-.195-.038-.216-.054-.199-.064a3.447 3.447 0 01-.367-.155l-.128-.066-.108-.06-.132-.083-.164-.113-.093-.071-.153-.128-.157-.148-3.416-3.416a3.5 3.5 0 114.95-4.95l.951.953a3.5 3.5 0 013.49-3.229h5.833zm.02 2.334h-5.853a1.167 1.167 0 00-.136 2.325l.116.007 3.52.001a1.167 1.167 0 110 2.333h-4.585a4.667 4.667 0 01-3.3-1.367l-1.707-1.707a1.167 1.167 0 00-1.747 1.54l.098.11 3.487 3.483.065.05.104.069.073.038.059.027.117.042.117.029.12.016.099.004h10.216l1.589 1.589 3.3-3.3-4.914-4.915-.072-.069-.142-.113-.113-.066a1.153 1.153 0 00-.124-.054l-.152-.044a1.157 1.157 0 00-.235-.028zM12.037 1.659c.08 0 .162.008.243.018a2.9 2.9 0 011.625.726l.095.089c.47-.46 1.045-.73 1.723-.81 2.577-.324 5.26 3.733-1.479 7.992l-.243.151-.021-.014c-6.804-4.173-4.469-8.2-1.943-8.152z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view48 || (_view48 = /*#__PURE__*/React.createElement("view", {
    id: "farm",
    viewBox: "180 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-920H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.226 16.825a22.3 22.3 0 00-3.532 3.442 11.6 11.6 0 01-1.026-2.382c.329-.363.669-.717 1.019-1.06h3.54zm8.064 0a22.278 22.278 0 00-7.335 7.747 11.683 11.683 0 01-1.897-1.382 24.616 24.616 0 015.323-6.365h3.91zm9.325 0a19.899 19.899 0 00-10.786 9.333 11.71 11.71 0 01-2.482-.265 22.264 22.264 0 018.027-9.068h5.241zm-10.782-4.083H8.167V9.825a2.333 2.333 0 114.666 0v2.917zm13.474 5.224a11.65 11.65 0 01-2.442 4.3 19.95 19.95 0 00-1.88 1.693 11.608 11.608 0 01-4.529 1.975 22.267 22.267 0 018.851-7.968z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.718 5.158A6.974 6.974 0 0117.5 9.825v2.917h-2.333V9.825a4.667 4.667 0 00-9.334 0v2.917H3.5V9.825a7 7 0 017-7h7a7 7 0 017 7v2.917h-2.333V9.825A4.667 4.667 0 0017.5 5.158h-1.782zM1.167 14.492h25.666c0 .799-.08 1.58-.233 2.333H1.4a11.72 11.72 0 01-.233-2.333z",
    fill: "#9896E0"
  }))))), _view49 || (_view49 = /*#__PURE__*/React.createElement("view", {
    id: "fashion",
    viewBox: "180 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-920H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0EC",
    d: "M10.5 9.825h7v2.333h-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 24.408v1.75H17.5a1.167 1.167 0 110 2.334h-7a1.167 1.167 0 010-2.334h2.333v-1.75h2.334zM14 .492c.644 0 1.167.522 1.167 1.166v1.166l2.023.001c1.177 0 2.17.876 2.315 2.044l.037.29a7.766 7.766 0 01-.76 4.436l-.699 1.397 1.613 3.224A12.355 12.355 0 0121 19.742v1.75c0 .644-.522 1.166-1.167 1.166H8.167A1.167 1.167 0 017 21.492v-1.75c0-1.918.447-3.81 1.304-5.526l1.613-3.224-.699-1.397a7.766 7.766 0 01-.76-4.437l.037-.289a2.333 2.333 0 012.315-2.044l2.023-.001V1.658c0-.644.523-1.166 1.167-1.166zm3.19 4.666h-6.38l-.036.29a5.433 5.433 0 00.531 3.104l1.22 2.44-2.134 4.268a10.022 10.022 0 00-1.058 4.482v.583h9.334v-.583c0-1.556-.363-3.09-1.058-4.482l-2.134-4.268 1.22-2.44c.48-.96.664-2.04.531-3.104l-.036-.29z",
    fill: "#9896E0"
  }))))), _view50 || (_view50 = /*#__PURE__*/React.createElement("view", {
    id: "fitness",
    viewBox: "180 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-2690H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.925 21.917l1.65 1.65-1.65 1.65a1.167 1.167 0 11-1.649-1.65l1.649-1.65zm18.15-18.15a1.167 1.167 0 111.65 1.65l-1.651 1.651-1.65-1.65 1.651-1.65zm-5.776 5.776l1.65 1.65-8.25 8.25-1.65-1.65 8.25-8.25z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05 15.317l4.125 4.125A4.083 4.083 0 017.4 25.216l-4.124-4.125a4.083 4.083 0 015.774-5.774zm-4.125 1.65a1.75 1.75 0 00-.113 2.35l.113.125 4.125 4.124a1.75 1.75 0 002.589-2.35l-.114-.125L7.4 16.967a1.75 1.75 0 00-2.475 0zM20.6 3.767l4.124 4.125a4.083 4.083 0 11-5.774 5.775l-4.125-4.125A4.083 4.083 0 0120.6 3.767zm-4.125 1.65a1.75 1.75 0 00-.114 2.35l.114.125 4.125 4.125a1.75 1.75 0 002.588-2.35l-.113-.125-4.125-4.125a1.75 1.75 0 00-2.475 0z",
    fill: "#9896E0"
  }))))), _view51 || (_view51 = /*#__PURE__*/React.createElement("view", {
    id: "forsale",
    viewBox: "180 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1064H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.833 19.8v-2.975h2.334v3.5a2.915 2.915 0 00-2.334-.525zm2.334-14.642h-2.334V2.825a1.167 1.167 0 012.334 0v2.333z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.377 23.303l1.166 2.334a1.167 1.167 0 01-2.086 1.043L8.29 24.347a1.167 1.167 0 012.087-1.044zm4.146-1.013l1.167 3.5a1.167 1.167 0 11-2.214.737l-1.166-3.5a1.167 1.167 0 012.213-.737zm8.75 1.75l.584 1.75a1.167 1.167 0 01-2.214.737l-.583-1.75a1.167 1.167 0 012.213-.737zm-16.356.227l.583 1.458a1.167 1.167 0 01-2.167.867l-.583-1.459a1.167 1.167 0 012.167-.866zm11.666-1.458l1.167 2.916a1.167 1.167 0 01-2.167.867l-1.166-2.917a1.167 1.167 0 112.166-.866zm4.75-18.817c.645 0 1.167.522 1.167 1.166v11.667c0 .644-.522 1.167-1.167 1.167H4.667A1.167 1.167 0 013.5 16.825V5.158c0-.644.522-1.166 1.167-1.166h18.666zm-1.166 2.333H5.833v9.333h16.334V6.325zm-5.25 3.5a1.167 1.167 0 010 2.333h-5.834a1.167 1.167 0 010-2.333h5.834z",
    fill: "#9896E0"
  }))))), _view52 || (_view52 = /*#__PURE__*/React.createElement("view", {
    id: "foundation",
    viewBox: "300 249 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 300,
    y: 249,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-3217h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.575 10.492l.182.006.206.019.202.033.254.062.093.03.14.049.134.055.119.056.131.069.043.024c.064.037.127.077.189.12l.15.11.159.132.12.113 4.24 4.24a1.001 1.001 0 011.416-.001l.707.707a1 1 0 010 1.414l-.707.707-.707-.707-4.242 4.243.707.707-.707.707a1 1 0 01-1.415 0l-.707-.707a1 1 0 01-.003-1.411l-.775-.778H6.575l-.124-.002-.17-.012-.188-.024-.168-.032-.185-.047-.17-.055a2.954 2.954 0 01-.315-.133l-.11-.056-.092-.052-.114-.07-.14-.098-.08-.06-.13-.11-.135-.127-2.929-2.928a3 3 0 114.243-4.243l.816.817a3 3 0 012.991-2.767h5zm.017 2H9.575a1 1 0 00-.116 1.993l.099.006h3.017a1 1 0 010 2h-3.93a4 4 0 01-2.828-1.172l-1.463-1.463a1 1 0 00-1.498 1.32l.084.094 2.989 2.986.055.043.09.059.062.033.05.023.101.036.1.025.104.013.084.004h8.757l1.362 1.362 2.828-2.83-4.211-4.211-.062-.06-.122-.096-.097-.057a.988.988 0 00-.106-.046l-.13-.038a.992.992 0 00-.202-.024zm-4.275-11c.07 0 .14.007.209.016a2.485 2.485 0 011.392.622l.082.076a2.473 2.473 0 011.477-.694c2.21-.278 4.509 3.2-1.267 6.85l-.209.13-.018-.012c-5.832-3.577-3.83-7.03-1.666-6.988z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view53 || (_view53 = /*#__PURE__*/React.createElement("view", {
    id: "fr",
    viewBox: "330 234 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 234,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "22.885%",
    x2: "84.852%",
    y2: "98.767%",
    id: "cca"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-6803H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.977 14.794l.697.041a1 1 0 01.86.606l1.72 4.03c-1.63.806-2.974 1.116-4.032.93a1 1 0 01-.817-1.127l.523-3.625a1 1 0 011.05-.855zm6.025-6.41a2 2 0 012.308-.375l4.368 2.183c.446 4.018-2.067 7.19-7.539 9.517a1 1 0 01-1.32-.549l-1.965-4.915a2 2 0 01.442-2.157zM1.632 16.78c.422-1.567 2.762-1.172 2.762-1.172l-.668 3.543c-1.676-.536-2.374-1.327-2.093-2.371zm18.46-12.244c.357 1.783.308 3.162-.145 4.136a1 1 0 01-1.3.497L15.28 7.726a1 1 0 01-.555-1.235l.22-.662a1 1 0 01.808-.674zm-2.593-2.593c1.61-.197 2.121 2.121 2.121 2.121l-1.832.367-.43.086-1.273.254c-.131-1.754.34-2.697 1.414-2.828z",
    fill: "url(#cca)",
    fillRule: "nonzero"
  })))), _view54 || (_view54 = /*#__PURE__*/React.createElement("view", {
    id: "fund",
    viewBox: "0 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-2690H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0EC",
    d: "M9.333 7.492h9.333v2.333H9.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.718 1.385a1.167 1.167 0 01.919 1.485L19.25 7.492l5.263 9.418a7 7 0 01-6.11 10.415H9.597a7 7 0 01-6.11-10.415L8.75 7.492 7.707 4.014a1.167 1.167 0 011.475-1.446c1.93.622 3.47.56 4.62-.187L14 2.24c1.334-1 3.24-1.285 5.718-.856zM15.4 4.108c-1.313.985-2.888 1.353-4.657 1.175l-.229-.028.755 2.513-5.745 10.28a4.667 4.667 0 003.84 6.938l.233.006h8.806a4.667 4.667 0 004.189-6.724l-.116-.22-5.745-10.28 1.27-4.236-.196-.007c-1.086-.026-1.875.186-2.405.583zm-.714 7.633v1.115c1.143.131 1.849.62 2.118.844l.124.112-.907 1.751-.154-.12c-.297-.217-.991-.651-1.781-.651-.441 0-.931.196-.931.686 0 1.04 3.981.967 3.981 3.675 0 1.236-.8 2.317-2.23 2.63l-.22.04v1.115h-1.335v-1.115c-1.362-.196-2.202-.913-2.434-1.135l-.065-.065 1.127-1.63.153.127c.32.25 1.098.78 1.941.78.441 0 .92-.172.92-.698 0-.98-3.982-1.066-3.982-3.7 0-1.303.884-2.253 2.139-2.565l.2-.044V11.74h1.336z",
    fill: "#9896E0"
  }))))), _view55 || (_view55 = /*#__PURE__*/React.createElement("view", {
    id: "games",
    viewBox: "30 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1064H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.94 10.074a7 7 0 01.06.919V21.79a3.907 3.907 0 01-3.208 3.844l-.158.029a5.467 5.467 0 01-5.092-1.779l-1.345-1.536a2.333 2.333 0 00-1.756-.797H11.56a2.33 2.33 0 00-1.756.797l-1.345 1.536a5.467 5.467 0 01-5.092 1.779l-.158-.029A3.907 3.907 0 010 21.791V10.993a7 7 0 017.918-6.94l.896.116c2.31.293 3.977.448 5.001.465l.185.001c1.122 0 3.149-.194 6.082-.582a7 7 0 017.857 6.021zm-7.552-3.708l-1.367.175c-2.162.267-3.755.41-4.816.426L14 6.969c-1.254 0-3.358-.202-6.388-.603a4.667 4.667 0 00-5.279 4.627V21.79c0 .76.544 1.413 1.293 1.549l.158.028a3.133 3.133 0 002.918-1.02l1.345-1.536a4.667 4.667 0 013.512-1.593h4.882c1.346 0 2.626.58 3.512 1.593l1.345 1.537a3.133 3.133 0 002.918 1.02l.158-.03a1.574 1.574 0 001.293-1.548V10.993a4.667 4.667 0 00-5.28-4.627zM9.333 9.302c.645 0 1.167.522 1.167 1.167v1.75h1.75a1.167 1.167 0 110 2.333H10.5v1.75a1.167 1.167 0 01-2.333 0v-1.75h-1.75a1.167 1.167 0 010-2.333h1.75v-1.75c0-.645.522-1.167 1.166-1.167zm8.167 4.083a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zm3.5-3.5a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view56 || (_view56 = /*#__PURE__*/React.createElement("view", {
    id: "gg",
    viewBox: "330 260 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 330,
    y: 260,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cfa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-6803H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#cfa)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18a6 6 0 100-12 6 6 0 000 12zm0 2a8 8 0 110-16 8 8 0 010 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 110-8 4 4 0 010 8z"
  }))))), _view57 || (_view57 = /*#__PURE__*/React.createElement("view", {
    id: "gold",
    viewBox: "60 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-1064H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.616 4.858l1.238 2.263 2.262 1.237-2.262 1.238-1.238 2.262-1.237-2.262-2.263-1.238 2.263-1.237 1.237-2.263zM4.95 1.942l1.237 2.262L8.45 5.442 6.187 6.679 4.95 8.942 3.712 6.679 1.45 5.442l2.262-1.238L4.95 1.942z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.41 17.992c.266 0 .498.179.565.435l1.834 7a.583.583 0 01-.565.731H14.756a.583.583 0 01-.565-.73l1.834-7a.583.583 0 01.564-.436h-5.178c.265 0 .497.179.564.435l1.834 7a.583.583 0 01-.565.731H.756a.583.583 0 01-.565-.73l1.834-7a.583.583 0 01.564-.436h5.167a.583.583 0 01-.565-.731l1.834-7a.583.583 0 01.564-.436h8.822c.265 0 .497.18.564.436l1.834 7a.583.583 0 01-.565.73h5.167zm-15.35 2.333H3.94l-.917 3.5h7.954l-.917-3.5zm14 0h-6.12l-.917 3.5h7.954l-.917-3.5zm-7-8.167h-6.12l-.917 3.5h7.954l-.917-3.5z",
    fill: "#9896E0"
  }))))), _view58 || (_view58 = /*#__PURE__*/React.createElement("view", {
    id: "golf",
    viewBox: "90 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-1064H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.017 16.125a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm-4.9 0a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm-4.9 0a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm2.333-2.333a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm5.133 0a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm3.734-1.036a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334zm-12.6 0a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334zm6.3-1.998a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334zm3.966-.335a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm-7.933 0a1.167 1.167 0 110 2.333 1.167 1.167 0 010-2.333zm11.317-1.765a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334zm-14.7 0a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.54 20.976c.809.3 1.293.683 1.293 1.1 0 .823-1.898 1.514-4.454 1.7l-1.158 3.468a.233.233 0 01-.442 0l-1.157-3.468c-2.556-.186-4.455-.877-4.455-1.7 0-.417.484-.8 1.293-1.1 1.384.632 2.921.982 4.54.982 1.594 0 3.108-.34 4.475-.951l.065-.03zM14 1.658a9.333 9.333 0 110 18.667 9.333 9.333 0 010-18.667zm0 2.334a7 7 0 100 14 7 7 0 000-14z",
    fill: "#9896E0"
  }))))), _view59 || (_view59 = /*#__PURE__*/React.createElement("view", {
    id: "group",
    viewBox: "120 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3215H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.093 2.825a4.668 4.668 0 014.303 2.856 6.695 6.695 0 00-2.023 1.32 2.333 2.333 0 00-4.613.491c0 1.816 1.189 3.5 2.333 3.5.086 0 .171-.01.257-.028a6.32 6.32 0 00-.052.577l-.006.293.01.385.03.388c.024.233.058.467.102.701-.11.012-.224.017-.34.017-1.07 0-1.981-.437-2.708-1.118a2.544 2.544 0 00-2.034 2.814l.03.18.79 3.957h1.986c-.012.374.008.752.061 1.131l.065.38.164.823H2.216a1.167 1.167 0 01-1.144-.938l-.979-4.896a4.879 4.879 0 012.915-5.462 6.948 6.948 0 01-.581-2.704 4.667 4.667 0 014.666-4.667zm13.814 0a4.667 4.667 0 014.666 4.667c0 .875-.201 1.828-.582 2.706a4.871 4.871 0 012.916 5.46l-.98 4.896a1.165 1.165 0 01-1.143.938H22.55l.165-.824.056-.322c.032-.216.054-.433.065-.65l.008-.327-.005-.21h1.987l.792-3.958c.022-.11.036-.22.044-.332l.005-.167a2.544 2.544 0 00-2.055-2.497l-.141.13c-.702.607-1.565.99-2.565.99-.117 0-.23-.005-.343-.015a7.8 7.8 0 00.144-1.476 6.74 6.74 0 00-.056-.87c.084.018.17.028.255.028 1.144 0 2.333-1.684 2.333-3.5A2.333 2.333 0 0018.625 7a6.68 6.68 0 00-2.02-1.32 4.664 4.664 0 014.302-2.856z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.908c2.738 0 4.958 2.206 4.958 4.926 0 .998-.274 2.092-.766 3.077l-.107-.047A4.875 4.875 0 0121 20.325l-.98 4.896a1.164 1.164 0 01-1.143.937H9.123a1.167 1.167 0 01-1.144-.937L7 20.325a4.879 4.879 0 012.807-5.416c-.491-.984-.765-2.077-.765-3.075 0-2.72 2.22-4.926 4.958-4.926zm-2.723 9.97l.016-.004a2.544 2.544 0 00-2.034 2.814l.029.18.79 3.957h7.842l.792-3.957c.022-.11.037-.22.044-.332l.005-.167a2.544 2.544 0 00-2.038-2.494l-.023.024c-.161.142-.33.273-.504.391a4.02 4.02 0 01-.797.433 3.955 3.955 0 01-1.399.252 3.96 3.96 0 01-1.43-.264 4.042 4.042 0 01-.735-.4 4.996 4.996 0 01-.558-.433zM14 9.242c-1.453 0-2.625 1.164-2.625 2.592 0 1.882 1.417 3.824 2.625 3.824s2.625-1.942 2.625-3.824c0-1.428-1.172-2.592-2.625-2.592z",
    fill: "#9896E0"
  }))))), _view60 || (_view60 = /*#__PURE__*/React.createElement("view", {
    id: "guide",
    viewBox: "150 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1208H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.833 19.8v-2.975h2.334v3.5a2.915 2.915 0 00-2.334-.525zm2.334-14.642h-2.334V2.825a1.167 1.167 0 012.334 0v2.333z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.377 23.303l1.166 2.334a1.167 1.167 0 01-2.086 1.043L8.29 24.347a1.167 1.167 0 012.087-1.044zm4.146-1.013l1.167 3.5a1.167 1.167 0 11-2.214.737l-1.166-3.5a1.167 1.167 0 012.213-.737zm8.75 1.75l.584 1.75a1.167 1.167 0 01-2.214.737l-.583-1.75a1.167 1.167 0 012.213-.737zm-16.356.227l.583 1.458a1.167 1.167 0 01-2.167.867l-.583-1.459a1.167 1.167 0 012.167-.866zm11.666-1.458l1.167 2.916a1.167 1.167 0 01-2.167.867l-1.166-2.917a1.167 1.167 0 112.166-.866zM17.5 3.992c.644 0 1.167.522 1.167 1.166v4.666l2.913.001c.258 0 .507.085.71.24l.115.102 2.917 2.917c.42.42.453 1.082.097 1.54l-.097.11-2.917 2.916a1.167 1.167 0 01-.671.332l-.154.01H10.5c-.598 0-1.091-.45-1.159-1.03l-.008-.137v-4.668l-2.913.001c-.31 0-.606-.122-.825-.341L2.678 8.9a1.167 1.167 0 010-1.65l2.917-2.916c.219-.22.515-.342.825-.342H17.5zm3.589 8.166h-9.422v3.5h9.422l1.75-1.75-1.75-1.75zm-4.756-5.833H6.911l-1.75 1.75 1.75 1.75h9.422v-3.5z",
    fill: "#9896E0"
  }))))), _view61 || (_view61 = /*#__PURE__*/React.createElement("view", {
    id: "health",
    viewBox: "0 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-4606h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 12.48a1 1 0 01-1 1h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2v-2a1 1 0 012 0v2h2a1 1 0 011 1",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.153 4.493c-2.184-.042-4.071 1.718-4.15 4.17-.106 3.285 2.675 7.32 8.851 11.367l.15.096.191-.123c6.193-4.066 8.955-8.128 8.8-11.402l-.013-.195c-.206-2.47-2.302-4.15-4.526-3.871-1.133.135-2.07.545-2.864 1.249l-.195.18-1.37 1.338-1.598-1.5c-.795-.716-1.739-1.137-2.889-1.28L7.331 4.5l-.077-.005-.101-.002zm.039-2c.197 0 .398.02.595.045 1.55.192 2.876.784 3.98 1.777l.233.219c1.153-1.125 2.56-1.787 4.219-1.984 6.312-.794 12.883 9.143-3.62 19.572l-.595.37-.053-.033C-4.711 12.238 1.007 2.374 7.192 2.493z",
    fill: "#9896E0"
  }))))), _view62 || (_view62 = /*#__PURE__*/React.createElement("view", {
    id: "hockey",
    viewBox: "180 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1208H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 2.825c-3.597 0-6.681 3.846-7.983 9.317a22.448 22.448 0 00-1.598-.278c.434-1.873 1.07-3.588 1.868-5.07-1.195.855-2.395 1.883-3.598 3.086a11.115 11.115 0 00-1.395 1.716 40.236 40.236 0 00-1.294-.02l-.595.004a13.17 13.17 0 012.138-2.846 31.502 31.502 0 013.168-2.79c-3.787 1.305-6.843 3.376-8.704 5.863-.763.095-1.493.217-2.18.368C10.941 6.707 18.8 2.825 28 2.825z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.825v5.833c0 1.933-4.701 3.5-10.5 3.5s-10.5-1.567-10.5-3.5v-5.833c0-1.933 4.701-3.5 10.5-3.5s10.5 1.567 10.5 3.5zM6.174 19.158h-.34v3.078c.3.217.808.46 1.48.684 1.7.567 4.1.905 6.686.905 2.586 0 4.986-.338 6.687-.905.671-.224 1.18-.467 1.48-.684v-3.078h-.34c-1.923.717-4.717 1.167-7.827 1.167-3.11 0-5.904-.45-7.826-1.167zm14.513-2.594c-1.701-.567-4.101-.906-6.687-.906-2.586 0-4.986.339-6.687.906a8.935 8.935 0 00-.693.261c.206.088.438.176.693.261 1.701.567 4.101.906 6.687.906 2.586 0 4.986-.339 6.687-.906.255-.085.487-.173.693-.26a8.935 8.935 0 00-.693-.262z",
    fill: "#9896E0"
  }))))), _view63 || (_view63 = /*#__PURE__*/React.createElement("view", {
    id: "holdings",
    viewBox: "210 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-3359H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.667 3.992A2.333 2.333 0 0128 6.325v16.333a2.333 2.333 0 01-2.333 2.334H2.333A2.333 2.333 0 010 22.658V6.325a2.333 2.333 0 012.333-2.333h23.334zm0 2.333H2.333v16.333h23.334V6.325zM21 9.825l.133.007c.345.037.624.216.805.464l.047.07.009.018c.1.164.157.344.172.528v3.58c0 .598-.45 1.091-1.03 1.159l-.136.007c-.598 0-1.091-.45-1.159-1.03l-.008-.136v-.684l-5.008 5.009c-.42.42-1.082.453-1.54.097l-.11-.097-2.675-2.674-4.767 4.765h-1.65v-1.65l5.592-5.591a1.167 1.167 0 011.54-.097l.11.097L14 16.34l4.183-4.183H17.5l-.155-.008c-1.349-.144-1.349-2.172 0-2.317l.155-.008H21z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view64 || (_view64 = /*#__PURE__*/React.createElement("view", {
    id: "id",
    viewBox: "0 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cnb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cnc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cne"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "cnf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cng"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cnh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "508.609%",
    id: "cni"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "cna",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-6965h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cnd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cna"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#cnb)",
    fillRule: "nonzero",
    xlinkHref: "#cna"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-7 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm8 6a2.5 2.5 0 110 5h-9a2.5 2.5 0 110-5zm-1-6v5h-7v-5h7zM14 8a2 2 0 110 4H8a2 2 0 110-4zm-.3-4v.013a1.5 1.5 0 010 2.974V7H8.5a1.5 1.5 0 010-3h5.2zM9 3a1 1 0 110-2h4a1 1 0 010 2z",
    fill: "url(#cnc)",
    fillRule: "nonzero",
    mask: "url(#cnd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.002 18.197s-2.88 3.308-6.002.129c0 0 2.633-2.896 6.002-.129z",
    fillOpacity: 0.72,
    fill: "url(#cne)",
    fillRule: "nonzero",
    mask: "url(#cnd)",
    transform: "rotate(-60 18 18.353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16a1 1 0 11.085-1.996 1.499 1.499 0 012.831 0L3 14a1 1 0 010 2z",
    fill: "url(#cnf)",
    fillRule: "nonzero",
    mask: "url(#cnd)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#cnd)",
    cx: 18,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.524 21.906S4.184 19.55 7.394 17c0 0 2.963 2.152.13 4.906z",
    fillOpacity: 0.72,
    fill: "url(#cng)",
    fillRule: "nonzero",
    mask: "url(#cnd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.313 21.115s-4.421.22-4.311-3.114c0 0 3.96-.143 4.31 3.114z",
    fillOpacity: 0.72,
    fill: "url(#cnh)",
    fillRule: "nonzero",
    mask: "url(#cnd)",
    transform: "rotate(14 5.156 19.56)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5.5a.5.5 0 111 0v3a.5.5 0 11-1 0v-3z",
    fill: "url(#cni)",
    fillRule: "nonzero"
  })))), _view65 || (_view65 = /*#__PURE__*/React.createElement("view", {
    id: "in",
    viewBox: "26 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 26,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-6965h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.547 17.68s11.065 3.477 14.036-7.69c0 0-9.965-2.935-14.036 7.69z",
    fill: "#B5B4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.81 17.68S3.743 21.157.773 9.99c0 0 9.964-2.935 14.035 7.69z",
    fill: "#B5B4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.382 18.404s-11.32-2.522-8.31-13.678c0 0 10.097 2.44 8.31 13.678z",
    fill: "#9D9CDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.68 18.404S24 15.882 20.99 4.726c0 0-10.097 2.44-8.31 13.678z",
    fill: "#9D9CDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.506 18.6s-8.544-7.844-.359-16c0 0 7.524 7.162.359 16z",
    fillOpacity: 0.91,
    fill: "#7674E1"
  }))))), _view66 || (_view66 = /*#__PURE__*/React.createElement("view", {
    id: "industries",
    viewBox: "26 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 26,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-3793h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.492v8h-2v-8h2zm-8-4v2H3v-2h5zm6.129-5.708l.119.23c.75 1.51 1.797 2.087 3.344 1.87 1.546-.218 2.394-1.062 2.7-2.72a1 1 0 111.966.363c-.458 2.49-1.973 3.997-4.388 4.337-2.331.327-4.156-.623-5.294-2.73l-.119-.23c-.75-1.508-1.797-2.086-3.344-1.868-.849.119-1.487.427-1.94.954l-2.314.001c.703-1.656 2.054-2.666 3.976-2.936 2.331-.328 4.156.623 5.294 2.73z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.064 22.492a1 1 0 01-1-1l.002-.063.875-14a1 1 0 01.998-.937h5.122a1 1 0 01.998.937l.366 5.879 5.196-2.225a.99.99 0 011.379.909v1.5l5.606-2.403a1 1 0 011.394.92v9.483a1 1 0 01-1 1H2.064zm5.057-14H3.878l-.75 12h4.743l-.75-12zM21 13.524l-7 3v-3l-4.442 1.904.316 5.063H21v-6.967z",
    fill: "#9896E0"
  }))))), _view67 || (_view67 = /*#__PURE__*/React.createElement("view", {
    id: "institute",
    viewBox: "210 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2834H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 10.992v9.333H3.5v-9.333h2.333zm4.667 0v9.333H8.167v-9.333H10.5zm4.667 0v9.333h-2.334v-9.333h2.334zm4.666 0v9.333H17.5v-9.333h2.333zm4.667 0v9.333h-2.333v-9.333H24.5z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19.158c.644 0 1.167.523 1.167 1.167v4.667c0 .644-.523 1.166-1.167 1.166h-21a1.167 1.167 0 01-1.167-1.166v-4.667c0-.644.523-1.167 1.167-1.167h21zm-1.167 2.334H4.667v2.333h18.666v-2.333zm-8.375-18.82l10.02 4.51c.42.189.689.605.689 1.064v2.746c0 .644-.523 1.166-1.167 1.166h-21a1.167 1.167 0 01-1.167-1.166V8.246c0-.459.27-.875.688-1.064l10.021-4.51a2.333 2.333 0 011.916 0zM14 4.802L4.667 9v.824h18.666V9L14 4.8z",
    fill: "#9896E0"
  }))))), _view68 || (_view68 = /*#__PURE__*/React.createElement("view", {
    id: "io",
    viewBox: "210 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "cra"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2546H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.667 2.333A5.833 5.833 0 0124.5 8.167l-.001.042.001 3.605a4.669 4.669 0 013.5 4.52V20a1 1 0 01-1 1h-7.333a1 1 0 01-1-1v-3.667a4.669 4.669 0 013.5-4.52V8.168a3.5 3.5 0 00-6.995-.192l-.005.192v11.666a5.833 5.833 0 11-11.667 0l-.001-3.647A4.669 4.669 0 010 11.666V8a1 1 0 011-1h7.333a1 1 0 011 1v3.667a4.669 4.669 0 01-3.5 4.52v3.646l.006.192a3.5 3.5 0 006.994-.192V8.167a5.833 5.833 0 015.834-5.834zm8.166 19.834v2.5a1 1 0 01-1 1h-5a1 1 0 01-1-1v-2.5h7zm-1.666-5.834H21.5a.5.5 0 00-.5.5v1.334a.5.5 0 00.5.5h3.667a.5.5 0 00.5-.5v-1.334a.5.5 0 00-.5-.5zm-18.667-7H2.833a.5.5 0 00-.5.5v1.334a.5.5 0 00.5.5H6.5a.5.5 0 00.5-.5V9.833a.5.5 0 00-.5-.5zm.667-7a1 1 0 011 1v2.5h-7v-2.5a1 1 0 011-1h5z",
    transform: "translate(0 .492)",
    fill: "url(#cra)",
    fillRule: "nonzero"
  })))), _view69 || (_view69 = /*#__PURE__*/React.createElement("view", {
    id: "jewelry",
    viewBox: "210 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-1208H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0EC",
    d: "M12.833 2.825h2.333v5.833h-2.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.917 1.658L21 4.575l-2.623 3.933a9.917 9.917 0 015.54 8.9c0 5.477-4.44 9.917-9.917 9.917-5.477 0-9.917-4.44-9.917-9.917a9.917 9.917 0 015.539-8.9L7 4.575l4.083-2.917h5.834zM14 9.825a7.583 7.583 0 100 15.167 7.583 7.583 0 000-15.167zM16.262 3.7h-4.524L9.795 5.087l1.798 2.696h.015A9.94 9.94 0 0114 7.491c.825 0 1.626.1 2.392.29l.015.001 1.798-2.696L16.262 3.7z",
    fill: "#9896E0"
  }))))), _view70 || (_view70 = /*#__PURE__*/React.createElement("view", {
    id: "kitchen",
    viewBox: "210 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-4223H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16.825v1.75a2.917 2.917 0 01-2.917 2.917h-1.75a1.167 1.167 0 010-2.334H17.5c.644 0 1.167-.522 1.167-1.166v-1.167a1.167 1.167 0 112.333 0z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 1.658A2.333 2.333 0 0117.5 3.992v1.166h1.167a7.002 7.002 0 016.903 5.834h1.263a1.167 1.167 0 010 2.333h-1.166v7a5.833 5.833 0 01-5.834 5.833H8.167a5.833 5.833 0 01-5.834-5.833v-7H1.167a1.167 1.167 0 110-2.333H2.43a7.002 7.002 0 016.903-5.834H10.5V3.992a2.333 2.333 0 012.333-2.334h2.334zm8.166 11.667H4.667v7A3.5 3.5 0 007.96 23.82l.206.006h11.666a3.5 3.5 0 003.494-3.294l.006-.206v-7zm-4.666-5.833H9.333a4.669 4.669 0 00-4.52 3.5h18.373A4.67 4.67 0 0018.9 7.498l-.233-.006zm-3.5-3.5h-2.334v1.166h2.334V3.992z",
    fill: "#9896E0"
  }))))), _view71 || (_view71 = /*#__PURE__*/React.createElement("view", {
    id: "land",
    viewBox: "210 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-3503H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .492)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C1C0EC",
    x: 12.833,
    y: 18.667,
    width: 2.333,
    height: 4.667,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.167c3.406 0 6.705.456 9.84 1.31l.669.19a1.612 1.612 0 011.159 1.546v.046a.888.888 0 01-1.155.847h-.002A34.985 34.985 0 0014 24.5a34.986 34.986 0 00-10.511 1.606.888.888 0 01-1.156-.847v-.027a1.64 1.64 0 011.042-1.526l.137-.046A37.347 37.347 0 0114 22.167zm.47-20.109c.108.069.2.16.268.269l6.573 10.328A.875.875 0 0120.573 14H20l2.585 4.524a.875.875 0 01-.76 1.31H6.176a.875.875 0 01-.76-1.31L7.999 14h-.572a.875.875 0 01-.738-1.345l6.573-10.328a.875.875 0 011.208-.269zM14 5.513l-3.916 6.154h1.934L8.686 17.5h10.626l-3.332-5.833h1.935L14 5.513z",
    fill: "#9896E0"
  }))))), _view72 || (_view72 = /*#__PURE__*/React.createElement("view", {
    id: "legal",
    viewBox: "0 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-4223H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.167 22.658a3.5 3.5 0 013.5 3.5h-2.334c0-.644-.522-1.166-1.166-1.166h-7c-.645 0-1.167.522-1.167 1.166h-2.333a3.5 3.5 0 013.5-3.5h7zM8.862 15.47l1.65 1.65-6.187 6.188a1.167 1.167 0 11-1.65-1.65l6.187-6.188zm5.362-11.96l1.238 1.237c.61.61.812 1.476.604 2.254l2.916 2.916a2.332 2.332 0 012.255.605l1.237 1.237a2.333 2.333 0 010 3.3l-4.95 4.95a2.333 2.333 0 01-3.3 0l-1.237-1.238a2.332 2.332 0 01-.604-2.254L9.466 13.6a2.332 2.332 0 01-2.254-.604l-1.237-1.238a2.333 2.333 0 010-3.3l4.95-4.95a2.333 2.333 0 013.3 0zm-1.65 1.65l-4.95 4.95 1.238 1.237 1.303-.348 4.82 4.82-.348 1.3 1.237 1.24 4.95-4.95-1.237-1.237-1.303.347-4.82-4.82.348-1.3-1.237-1.24z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view73 || (_view73 = /*#__PURE__*/React.createElement("view", {
    id: "life",
    viewBox: "30 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2309H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.47 10.341l.073.13L14 15.381l1.873-3.745c.407-.815 1.53-.858 2.013-.129l.074.129.844 1.688h3.131c-.38.753-.893 1.534-1.537 2.334h-2.315c-.392 0-.755-.198-.97-.52l-.073-.125-.123-.247-1.874 3.747c-.407.814-1.53.857-2.012.128l-.074-.128L10.5 13.6l-.707 1.414a1.167 1.167 0 01-.897.635l-.146.01H7.613c-.642-.799-1.154-1.579-1.535-2.333h1.95l1.429-2.856c.407-.815 1.53-.857 2.012-.129z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 2.826c.231 0 .464.024.695.053 1.808.223 3.355.914 4.643 2.072l.272.256c1.346-1.313 2.987-2.085 4.923-2.315 7.364-.926 15.03 10.667-4.225 22.835l-.694.431-.061-.039C-5.497 14.195 1.175 2.688 8.39 2.826zM8.345 5.16c-2.547-.049-4.75 2.004-4.842 4.865-.123 3.832 3.122 8.54 10.327 13.261l.175.113.223-.144c7.225-4.743 10.447-9.482 10.266-13.301l-.015-.228c-.24-2.882-2.685-4.842-5.28-4.516-1.321.157-2.415.635-3.341 1.456l-.229.212-1.598 1.56-1.863-1.75c-.928-.835-2.03-1.327-3.371-1.493l-.244-.026a2.597 2.597 0 00-.09-.006l-.118-.003z",
    fill: "#9896E0"
  }))))), _view74 || (_view74 = /*#__PURE__*/React.createElement("view", {
    id: "live",
    viewBox: "60 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2546H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.054 6.16l.098-.094a1.167 1.167 0 011.645.135c4.049 4.775 4.049 11.807 0 16.581a1.167 1.167 0 01-1.78-1.509 10.503 10.503 0 000-13.563 1.167 1.167 0 01.037-1.55zM18.49 9.175l.099-.094a1.167 1.167 0 011.644.135 8.168 8.168 0 010 10.552 1.167 1.167 0 11-1.78-1.51 5.835 5.835 0 000-7.533 1.167 1.167 0 01.037-1.55zM9.41 9.08c.491.417.552 1.153.135 1.644a5.835 5.835 0 000 7.535 1.167 1.167 0 11-1.78 1.51 8.168 8.168 0 010-10.554A1.167 1.167 0 019.41 9.08zM5.835 6.056c.462.38.556 1.042.239 1.532l-.08.11-.195.235a10.504 10.504 0 00.184 13.34 1.167 1.167 0 01-1.78 1.51C.31 18.19.153 11.497 3.783 6.723l.206-.263.204-.248a1.167 1.167 0 011.642-.157z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.992a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2.333a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333z",
    fill: "#9896E0"
  }))))), _view75 || (_view75 = /*#__PURE__*/React.createElement("view", {
    id: "llc",
    viewBox: "52 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 52,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-2023h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08 2.492A4.001 4.001 0 019.768 4.94a5.739 5.739 0 00-1.734 1.13 2 2 0 00-3.954.42c0 1.559 1.019 3.002 2 3.002.073 0 .147-.008.22-.024a5.417 5.417 0 00-.044.494l-.006.252.009.33.025.332c.02.2.05.4.088.602a2.83 2.83 0 01-.292.014c-.916 0-1.698-.375-2.32-.958a2.18 2.18 0 00-1.744 2.412l.025.154.678 3.392h1.702c-.01.32.007.644.053.969l.055.325.141.706H1.9a1 1 0 01-.98-.804l-.84-4.196A4.182 4.182 0 012.578 8.81a5.956 5.956 0 01-.498-2.318 4 4 0 014-4zm11.84 0a4 4 0 014 4c0 .75-.173 1.567-.5 2.32a4.175 4.175 0 012.5 4.68l-.84 4.196a1 1 0 01-.98.804h-2.77l.142-.706.048-.276a5.68 5.68 0 00.055-.558l.007-.28-.004-.18h1.703l.679-3.392a2.18 2.18 0 00.037-.285l.005-.143a2.18 2.18 0 00-1.76-2.14l-.122.112c-.602.52-1.342.848-2.199.848-.1 0-.198-.005-.294-.013a6.71 6.71 0 00.124-1.265 5.75 5.75 0 00-.048-.747.98.98 0 00.218.025c.981 0 2-1.443 2-3a2 2 0 00-3.956-.42 5.726 5.726 0 00-1.73-1.132 3.998 3.998 0 013.686-2.448z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.992c2.347 0 4.25 1.89 4.25 4.222 0 .855-.235 1.793-.657 2.637l-.092-.04A4.178 4.178 0 0118 17.49l-.84 4.197a1 1 0 01-.98.804H7.82a1 1 0 01-.98-.804L6 17.492a4.182 4.182 0 012.406-4.643c-.42-.843-.656-1.78-.656-2.635 0-2.332 1.903-4.222 4.25-4.222zm2.334 8.543l-.02.02a4.274 4.274 0 01-.432.335c-.36.25-.76.435-1.2.53L13 17.88c0 .614-.448 1.112-1 1.112s-1-.498-1-1.111l.316-2.462a3.309 3.309 0 01-1.172-.51 4.283 4.283 0 01-.478-.372l.013-.003a2.18 2.18 0 00-1.743 2.412l.025.154.678 3.392h6.721l.679-3.392a2.18 2.18 0 00.037-.285l.005-.143a2.18 2.18 0 00-1.747-2.137zM12 7.992c-1.246 0-2.25.998-2.25 2.222 0 1.613 1.215 3.278 2.25 3.278s2.25-1.665 2.25-3.278c0-1.224-1.004-2.222-2.25-2.222z",
    fill: "#9896E0"
  }))))), _view76 || (_view76 = /*#__PURE__*/React.createElement("view", {
    id: "marketing",
    viewBox: "78 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 78,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-3937H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.668 11.372l3 5.196-1.732 1-3-5.196 1.732-1zm15.439-.383a1 1 0 01.116 1.994l-.116.006h-3.5a1 1 0 01-.117-1.993l.117-.007h3.5zm-.489-4.784a1 1 0 01-.268 1.302l-.098.064-3.897 2.25a1 1 0 01-1.098-1.668l.098-.064 3.897-2.25a1 1 0 011.366.366zM17.356 2.03a1 1 0 01.419 1.261l-.053.105-1.75 3.03a1 1 0 01-1.784-.895l.052-.104 1.75-3.031a1 1 0 011.366-.366z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.203 19.146l.012-.001 2.334 2.413a1 1 0 01-1.352 1.469l-.086-.08-2.684-2.776 1.776-1.025zm.98-14.802a1 1 0 01.316.334l6.382 11.054a1 1 0 01-.806 1.498l-7.313.44-4.33 2.5a1 1 0 01-1.367-.367l-3-5.196a1 1 0 01.367-1.366l4.33-2.5 4.036-6.114a1 1 0 011.386-.283zm-.608 2.734l-3.404 5.159-3.874 2.235 2 3.464 3.874-2.235 6.169-.37-4.765-8.253z",
    fill: "#9896E0"
  }))))), _view77 || (_view77 = /*#__PURE__*/React.createElement("view", {
    id: "me",
    viewBox: "104 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 104,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-4606H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.844 15.213H9.876a2.147 2.147 0 003.968 0z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.739 1.66a1 1 0 011.533 1.035c-.067.32-.51 2.286-1.579 4.018a6.28 6.28 0 01.572 1.662c.412 2.286.168 5.677-1.429 8.326.336.115.93.301 1.942.571 3.297.836 3.476 3.92 3.108 5.433a1 1 0 01-1.944-.468c.095-.415.458-2.49-1.667-3.03-1.981-.529-2.572-.788-2.67-.835l-.052-.038a7.754 7.754 0 01-3.108 1.905 4.69 4.69 0 01-1.457.23h-.085a4.709 4.709 0 01-1.474-.23 7.772 7.772 0 01-3.036-1.813c-.21.09-.883.343-2.614.798-2.161.541-1.795 2.603-1.7 3.011a1.003 1.003 0 01-.975 1.231.996.996 0 01-.968-.758c-.432-1.755.049-4.646 3.145-5.42a35.029 35.029 0 001.793-.514c-1.142-1.884-1.478-4.016-1.591-5.378-.006-.07-.007-.137-.013-.204-.265-2.906.12-5.154 1.533-6.713 1.358-1.498 3.508-2.234 6.067-2.072l.271.017c2.243.145 4.786.307 6.398-.765zm-1.504 6.798c-.079.065-.161.118-.242.177-.011.01-.023.017-.035.026-1.204.868-2.6 1.048-4.063.48-.119-.047-.23-.075-.345-.113-.136-.045-.274-.095-.404-.129-.158-.04-.309-.066-.459-.092-.073-.012-.149-.03-.22-.039a4.848 4.848 0 00-.553-.04l-.057-.002c-1.92-.004-3.16 1.193-3.83 2.11a6.292 6.292 0 00-.51.846c.221 2.073 1.111 5.537 4.534 6.656.272.09.581.131.858.13a2.9 2.9 0 00.914-.13c4.784-1.565 4.834-7.613 4.474-9.608a3.29 3.29 0 00-.062-.272zm-7.939 2.447c.28-.28.72-.37 1.09-.22.12.05.23.12.32.22a.976.976 0 010 1.41c-.09.09-.2.17-.32.22-.12.05-.25.07-.38.07-.27 0-.53-.1-.71-.29a.973.973 0 01-.29-.71c0-.26.1-.52.29-.7zm4 0c.38-.38 1.04-.37 1.41 0a.976.976 0 010 1.41c-.18.19-.44.29-.7.29a.99.99 0 01-1-1c0-.26.1-.52.29-.7zm4.407-6.67c-1.755.423-3.706.298-5.49.185l-.269-.017a8.948 8.948 0 00-.561-.018c-1.68 0-3.05.502-3.898 1.437-.616.68-.985 1.59-1.107 2.722l.076-.064a7.515 7.515 0 01.731-.587c.08-.056.162-.109.245-.162a6.509 6.509 0 01.833-.456 5.463 5.463 0 01.951-.345 6.517 6.517 0 011.239-.197c.229-.014.465-.013.707 0 .089.003.177.007.267.015.293.026.594.072.904.14.074.016.15.037.225.056.309.077.624.171.949.293.029.011.057.016.087.027.722.278 1.353.26 1.933-.058.227-.124.439-.29.639-.484.017-.016.033-.027.05-.045.052-.05.1-.11.151-.167.099-.112.199-.23.299-.367.425-.572.773-1.255 1.039-1.909z",
    fill: "#9896E0"
  }))))), _view78 || (_view78 = /*#__PURE__*/React.createElement("view", {
    id: "media",
    viewBox: "90 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2021H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 22.658h21a1.167 1.167 0 110 2.334h-21a1.167 1.167 0 010-2.334z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.333 20.908c.645 0 1.167.523 1.167 1.167v3.5a1.167 1.167 0 01-2.333 0v-3.5c0-.644.522-1.167 1.166-1.167zM24.5 2.825c.644 0 1.167.522 1.167 1.167v14c0 .644-.523 1.166-1.167 1.166h-21a1.167 1.167 0 01-1.167-1.166v-14c0-.645.523-1.167 1.167-1.167h21zm-1.167 2.333H4.667v11.667h18.666V5.158zM12.25 7.388c.11 0 .22.031.313.091l4.747 3.02a.583.583 0 010 .985l-4.747 3.02a.583.583 0 01-.896-.492v-6.04c0-.323.26-.584.583-.584z",
    fill: "#9896E0"
  }))))), _view79 || (_view79 = /*#__PURE__*/React.createElement("view", {
    id: "mx",
    viewBox: "52 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 52,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "82.052%",
    x2: "50%",
    y2: "142.263%",
    id: "dca"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "18.277%",
    x2: "51.072%",
    y2: "128.239%",
    id: "dcc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-37.412%",
    x2: "51.406%",
    y2: "10.569%",
    id: "dcd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "389.876%",
    id: "dce"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11z",
    id: "dcb"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-6965H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#dca)",
    xlinkHref: "#dcb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6a4.002 4.002 0 013.889 3.06L11.949 8l1.143 1.143A4.001 4.001 0 0117 6h4v4a4 4 0 01-4 4l-1.711.001a3.503 3.503 0 01-1.624 2L15 16v.05a2.5 2.5 0 110 4.9V21H8v-.05a2.5 2.5 0 010-4.9V16l2.234.002A3.503 3.503 0 018.61 14l-1.571-.001L7 14a4 4 0 01-3.995-3.8L3 10V6z",
    fill: "url(#dcc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.06 11.121l1.281 1.28-1.28 1.281-1.28-1.28 1.28-1.28zM7 8a2 2 0 011.995 1.85L9 10v2H7a2 2 0 01-2-2V8h2zm8 4v-2l.005-.15A2 2 0 0117 8h2v2a2 2 0 01-2 2h-2zm.5 5.5a1 1 0 010 2h-7a1 1 0 010-2h7zm-2.159-5.098a1.81 1.81 0 11-2.56 2.56 1.81 1.81 0 012.56-2.56z",
    fill: "url(#dcd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dce)",
    d: "M17 5.236l-3.774-1.132L12.094 7.5 7 3.16l4.15 1.132.944-3.207z"
  }))))), _view80 || (_view80 = /*#__PURE__*/React.createElement("view", {
    id: "net",
    viewBox: "78 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 78,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "dda"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.88 7.404c.096.082.198.157.306.223L11 16a3 3 0 00-2.886 3.823 10.015 10.015 0 01-6.845-4.944 2.5 2.5 0 001.718-2.126zm4.116-1.776A9.96 9.96 0 0120 10c0 4.102-2.47 7.628-6.005 9.17L14 19c0-.555-.151-1.076-.414-1.522l3.692-9.602A2.501 2.501 0 0019 5.5zM10 0a9.972 9.972 0 017.253 3.116 2.501 2.501 0 00-3.097 1.512l-11.9 6.093a2.516 2.516 0 00-.048-.047L8.966.053C9.306.018 9.651 0 10 0zM7.802.242l-7.8 9.533c.104-4.668 3.405-8.547 7.8-9.533z",
    id: "ddb"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-7127h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#dda)",
    fillRule: "nonzero",
    xlinkHref: "#ddb",
    transform: "translate(2 2)"
  })))), _view81 || (_view81 = /*#__PURE__*/React.createElement("view", {
    id: "network",
    viewBox: "120 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-2021H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.658c6.443 0 11.667 5.224 11.667 11.667 0 3.088-1.2 5.895-3.158 7.982l-.26.268a1.167 1.167 0 01-1.746-1.54l.097-.11a9.333 9.333 0 10-13.435-.244l.235.244a1.167 1.167 0 01-1.54 1.747l-.11-.097a11.63 11.63 0 01-3.417-8.25C2.333 6.882 7.557 1.658 14 1.658zm0 4.667a7 7 0 015.168 11.721l-.218.229a1.167 1.167 0 01-1.747-1.54l.097-.11a4.667 4.667 0 10-6.775-.185l.175.185a1.167 1.167 0 01-1.54 1.747l-.11-.098A7 7 0 0114 6.325z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 15.346A2.332 2.332 0 0114 10.992a2.333 2.333 0 011.168 4.354l-.001 9.646H17.5a1.167 1.167 0 010 2.333h-7a1.167 1.167 0 110-2.333h2.333v-9.646z",
    fill: "#9896E0"
  }))))), _view82 || (_view82 = /*#__PURE__*/React.createElement("view", {
    id: "new",
    viewBox: "150 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-5222H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9896E0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3.992c-5.789 0-10.5 4.71-10.5 10.5 0 5.265 3.817 9.639 8.965 10.385l11.92-11.92A10.444 10.444 0 0014 3.993M12.89 27.27a1.15 1.15 0 01-.11-.005A12.772 12.772 0 011.167 14.492C1.167 7.416 6.924 1.658 14 1.658a12.77 12.77 0 0112.771 11.613c.033.347-.09.69-.335.935L13.714 26.927c-.22.22-.517.342-.825.342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.784 26.269a12.798 12.798 0 01-.062-1.222c0-7.075 5.758-12.832 12.834-12.832.411 0 .819.022 1.221.061l-.22 2.323c-.33-.032-.663-.05-1.001-.05-5.79 0-10.5 4.71-10.5 10.498 0 .339.02.671.05 1.001l-2.322.221z"
  }))))), _view83 || (_view83 = /*#__PURE__*/React.createElement("view", {
    id: "news",
    viewBox: "180 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-1208H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.249 6.613v13.98L1.554 10.441A2.333 2.333 0 012.95 7.45l2.3-.838z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 1.658a2.333 2.333 0 012.334 2.334v21a2.333 2.333 0 01-2.334 2.333h-14A2.333 2.333 0 017 24.992v-21a2.333 2.333 0 012.333-2.334h14zm0 2.334h-14v21h14v-21zm-3.5 16.333a1.167 1.167 0 010 2.333h-7a1.167 1.167 0 010-2.333h7zm0-4.667a1.167 1.167 0 110 2.334h-7a1.167 1.167 0 010-2.334h7zm0-9.333c.645 0 1.167.522 1.167 1.167v4.666c0 .645-.522 1.167-1.167 1.167h-7a1.167 1.167 0 01-1.166-1.167V7.492c0-.645.522-1.167 1.166-1.167h7zm-1.166 2.333H14v2.334h4.667V8.658z",
    fill: "#9896E0"
  }))))), _view84 || (_view84 = /*#__PURE__*/React.createElement("view", {
    id: "ninja",
    viewBox: "210 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-3215H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.088 8.812a1.167 1.167 0 011.272 1.952l-.115.074-2.444 1.396 1.93 1.287c.497.332.658.98.392 1.5l-.069.118c-.332.498-.98.658-1.5.392l-.118-.068-3.5-2.334a1.167 1.167 0 01-.057-1.901l.126-.082 4.083-2.334z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.825c5.155 0 8.75 4.179 8.75 9.333 0 2.102-.582 4.429-1.627 6.448l2.08.52a4.667 4.667 0 013.395 5.659l-.035.13-.168.54a1 1 0 01-.954.703h-.487a.899.899 0 01-.858-1.167l.221-.707.017-.065a2.334 2.334 0 00-1.53-2.781l-.167-.049-2.846-.709c-1.486 1.87-3.467 3.145-5.791 3.145-2.324 0-4.305-1.276-5.791-3.145l-2.846.71a2.333 2.333 0 00-1.707 2.791l.046.168.201.643a.899.899 0 01-.858 1.166h-.487a1 1 0 01-.955-.702l-.128-.41a4.667 4.667 0 013.322-5.92l2.079-.52c-1.045-2.02-1.626-4.347-1.626-6.448 0-5.154 3.595-9.333 8.75-9.333zM9.458 18.42c1.203 1.837 2.854 3.073 4.542 3.073 1.688 0 3.34-1.236 4.544-3.073l-.717.043a68.703 68.703 0 01-3.827.113c-1.41 0-2.924-.052-4.542-.156zM14 10.409c-1.944 0-3.889.078-5.833.235l-.457.04a8.49 8.49 0 00-.127 1.474c0 1.314.248 2.627.678 3.835 2.087.166 4 .249 5.739.249 1.739 0 3.652-.083 5.737-.249.432-1.208.68-2.52.68-3.835a8.49 8.49 0 00-.127-1.474l-.457-.04A72.546 72.546 0 0014 10.408zm-2.333 1.166c.644 0 1.166.522 1.166 1.167v1.166a1.167 1.167 0 11-2.333 0v-1.166c0-.645.522-1.167 1.167-1.167zm4.666 0c.645 0 1.167.522 1.167 1.167v1.166a1.167 1.167 0 01-2.333 0v-1.166c0-.645.522-1.167 1.166-1.167zM14 5.158c-2.359 0-4.314 1.203-5.424 3.117 1.809-.134 3.616-.2 5.424-.2 1.808 0 3.615.066 5.423.197C18.314 6.361 16.36 5.158 14 5.158z",
    fill: "#9896E0"
  }))))), _view85 || (_view85 = /*#__PURE__*/React.createElement("view", {
    id: "nyc",
    viewBox: "104 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 104,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "dia"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-7127h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20a1 1 0 110 2 1 1 0 010-2zm-6 0a1 1 0 110 2 1 1 0 010-2zm3-19c.552 0 1 .492 1 1.1l.001 7.466a7.473 7.473 0 014.03 1.871l4.128-4.128a1.055 1.055 0 011.492 1.492l-4.264 4.265A7.46 7.46 0 0119.23 15H23a1 1 0 010 2h-6.5a4.5 4.5 0 10-9 0H1.055C.472 17 0 16.552 0 16s.472-1 1.055-1H4.77a7.473 7.473 0 011.233-2.504L2.309 8.8a1.055 1.055 0 011.492-1.49l3.695 3.694A7.462 7.462 0 0111 9.566V2.1c0-.608.448-1.1 1-1.1z",
    fill: "url(#dia)",
    fillRule: "nonzero"
  })))), _view86 || (_view86 = /*#__PURE__*/React.createElement("view", {
    id: "online",
    viewBox: "300 0 30 30"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-1 -1 30 30",
    x: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-968-5454H472v8778H-968z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.833v2.334H7v-2.334h14zm0-4.666V10.5H7V8.167h14z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.333c1.289 0 2.333 1.115 2.333 2.49V18.51c0 1.376-1.043 2.49-2.333 2.49h-9.333v2.333h7.583a1.167 1.167 0 010 2.334H5.25a1.167 1.167 0 010-2.334h7.583V21H3.5c-1.289 0-2.333-1.114-2.333-2.489V4.822c0-1.374 1.044-2.489 2.333-2.489h21zm0 2.49h-21V18.51h21V4.822z",
    fill: "#9896E0"
  }))))), _view87 || (_view87 = /*#__PURE__*/React.createElement("view", {
    id: "org",
    viewBox: "130 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    id: "dkLayer_1",
    "data-name": "Layer 1",
    viewBox: "-1 -1 26 26",
    width: 26,
    height: 26,
    x: 130,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient",
    x1: -271.55,
    y1: 414.26,
    x2: -271.55,
    y2: 413.32,
    gradientTransform: "matrix(22 0 0 -22 5986 9116.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3a2e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8be0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-2",
    x1: -320.32,
    y1: 305.8,
    x2: -320.32,
    y2: 304.86,
    gradientTransform: "matrix(2.32 -8.66 -2.9 -.78 1637.86 -2517.67)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-3",
    x1: -343.1,
    y1: 376.37,
    x2: -343.1,
    y2: 375.43,
    gradientTransform: "matrix(-2.07 -7.73 -2.9 .78 384.38 -2919.93)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-4",
    x1: -316.01,
    y1: 305.8,
    x2: -316.01,
    y2: 304.86,
    gradientTransform: "matrix(2.64 -9.85 -2.9 -.78 1730.88 -2853.64)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-5",
    x1: -320.36,
    y1: 296.95,
    x2: -320.36,
    y2: 296.01,
    gradientTransform: "matrix(2.74 -7.52 -2.82 -1.03 1727.16 -2081.81)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-6",
    x1: -313.63,
    y1: 267.26,
    x2: -313.63,
    y2: 266.32,
    gradientTransform: "matrix(3.63 -6.29 -2.36 -1.36 1785.45 -1586.64)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-7",
    x1: -123.42,
    y1: 400.93,
    x2: -123.42,
    y2: 400,
    gradientTransform: "matrix(2.29 .61 2.61 -9.72 -748.86 3985.87)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-8",
    x1: -188.59,
    y1: 424.87,
    x2: -188.59,
    y2: 423.93,
    gradientTransform: "matrix(3.62 3.62 7.77 -7.77 -2597.57 3987.4)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-9",
    x1: -240.55,
    y1: 415.43,
    x2: -240.55,
    y2: 414.5,
    gradientTransform: "matrix(7.9 7.9 3.56 -3.56 431 3384.66)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dklinear-gradient-10",
    x1: -223.34,
    y1: 421.4,
    x2: -223.34,
    y2: 420.47,
    gradientTransform: "matrix(5.67 5.67 5.42 -5.42 -1000.06 3553.88)",
    xlinkHref: "#dklinear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dkmask",
    x: 1,
    y: 2,
    width: 22,
    height: 23.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkmask-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2",
    className: "dkcls-1",
    cx: 12,
    cy: 13,
    r: 11
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dkmask-2",
    x: 1,
    y: 2,
    width: 22,
    height: 25.17,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkmask-3-2",
    "data-name": "mask-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2-2",
    "data-name": "path-2",
    className: "dkcls-1",
    cx: 12,
    cy: 13,
    r: 11
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dkmask-3-3",
    x: 1,
    y: 2,
    width: 22,
    height: 24.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkmask-3-4",
    "data-name": "mask-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2-3",
    "data-name": "path-2",
    className: "dkcls-1",
    cx: 12,
    cy: 13,
    r: 11
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dkmask-4",
    x: 1,
    y: 2,
    width: 22,
    height: 24.12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkmask-3-5",
    "data-name": "mask-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2-4",
    "data-name": "path-2",
    className: "dkcls-1",
    cx: 12,
    cy: 13,
    r: 11
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dkmask-5",
    x: 1,
    y: 2,
    width: 22,
    height: 25.16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkmask-3-6",
    "data-name": "mask-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2-5",
    "data-name": "path-2",
    className: "dkcls-1",
    cx: 12,
    cy: 13,
    r: 11
  }))), /*#__PURE__*/React.createElement("style", null, ".dkcls-1{fill:#fff}.dkcls-2{fill-opacity:.29;fill:url(#dklinear-gradient)}.dkcls-3{mask:url(#dkmask)}.dkcls-10,.dkcls-12,.dkcls-4,.dkcls-6,.dkcls-8{fill-opacity:.7}.dkcls-4{fill:url(#dklinear-gradient-2)}.dkcls-5{mask:url(#dkmask-2)}.dkcls-6{fill:url(#dklinear-gradient-3)}.dkcls-7{mask:url(#dkmask-3-3)}.dkcls-8{fill:url(#dklinear-gradient-4)}.dkcls-9{mask:url(#dkmask-4)}.dkcls-10{fill:url(#dklinear-gradient-5)}.dkcls-11{mask:url(#dkmask-5)}.dkcls-12{fill:url(#dklinear-gradient-6)}.dkcls-13{fill:url(#dklinear-gradient-7)}.dkcls-14{fill:url(#dklinear-gradient-8)}.dkcls-15{fill:url(#dklinear-gradient-9)}.dkcls-16{fill:url(#dklinear-gradient-10)}"))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "dkart_icons_tld_org",
    "data-name": "art/icons/tld/org"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkCombined-Shape-_-Combined-Shape-Copy-4-_-Combined-Shape-Copy-_-Combined-Shape-Copy-2-_-Combined-Shape-Copy-3-Mask",
    "data-name": "Combined-Shape-+-Combined-Shape-Copy-4-+-Combined-Shape-Copy-+-Combined-Shape-Copy-2-+-Combined-Shape-Copy-3-Mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dkMask-6",
    "data-name": "Mask"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "dkpath-2-6",
    "data-name": "path-2",
    className: "dkcls-2",
    cx: 12,
    cy: 13,
    r: 11
  })), /*#__PURE__*/React.createElement("g", {
    className: "dkcls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkCombined-Shape",
    className: "dkcls-4",
    d: "M10.05 23.92a1.57 1.57 0 01-1.85 1.13 1.6 1.6 0 01-1-2v.11l1.45-5.42v-.11a1.62 1.62 0 011.75-1.26h.13a1.59 1.59 0 011 2v.11z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dkcls-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkCombined-Shape-Copy-4",
    className: "dkcls-6",
    d: "M7.61 25.38a1.5 1.5 0 01-2.93.67v.1l-1.3-4.83v-.09a1.51 1.51 0 01.92-1.8h.14a1.5 1.5 0 011.84 1.06.44.44 0 000 .1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dkcls-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkCombined-Shape-Copy",
    className: "dkcls-8",
    d: "M12.79 24.9a1.72 1.72 0 01-1.91 1.34 1.75 1.75 0 01-1-2.24v.13L11.54 18v-.12a1.78 1.78 0 011.81-1.49h.13a1.73 1.73 0 011 2.23v.12z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dkcls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkCombined-Shape-Copy-2",
    className: "dkcls-10",
    d: "M15.3 25.23a1.5 1.5 0 01-2.79-1.12v.09l1.71-4.7v-.09a1.51 1.51 0 011.78-.94h.14a1.51 1.51 0 01.86 1.97.36.36 0 010 .09z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dkcls-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkCombined-Shape-Copy-3",
    className: "dkcls-12",
    d: "M16 26.56a1.37 1.37 0 01-2.32-1.45v.09l2.27-3.93v-.08a1.37 1.37 0 011.75-.56l.11.06a1.35 1.35 0 01.5 1.86.22.22 0 010 .08z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "dkPath-11",
    className: "dkcls-13",
    d: "M12.62 11.15l1-.22c.85 4.16 0 7.42-2.64 9.72l-.7-.8c2.35-2.02 3.12-4.85 2.34-8.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dkGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "dkShape",
    className: "dkcls-14",
    d: "M13.55 12s-.67-8.15 7.59-8c0 0 .49 7.34-7.59 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dkShape-2",
    "data-name": "Shape",
    className: "dkcls-15",
    d: "M13.23 11.8s-8.14.56-8.06-7.73c0 0 7.27-.34 8.06 7.73z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dkShape-3",
    "data-name": "Shape",
    className: "dkcls-16",
    d: "M13.46 11.93S7.26 6.5 13.2.85a7.74 7.74 0 01.26 11.08z"
  }))))), _view88 || (_view88 = /*#__PURE__*/React.createElement("view", {
    id: "pe",
    viewBox: "156 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 156,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "dla"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.305%",
    y1: "53.225%",
    x2: "50%",
    y2: "50.09%",
    id: "dlb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-7127H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2v19a1.5 1.5 0 01-3 0V2h3zm4 0v17a1.5 1.5 0 01-3 0V2h3zm4 0v15a1.5 1.5 0 01-3 0V2h3zm4 0v13a1.5 1.5 0 01-3 0V2h3zm4 0v11a1.5 1.5 0 01-3 0V2h3zm4 0v9a1.5 1.5 0 01-3 0V2h3z",
    fill: "url(#dla)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#dlb)",
    d: "M.5 5h23v1H.5zm0 1h23v1H.5zm0 1h23v1H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6l1 2H1l1-2zm2 0l1 2H3l1-2zm2 0l1 2H5l1-2zm2 0l1 2H7l1-2zm2 0l1 2H9l1-2zm2 0l1 2h-2l1-2zm2 0l1 2h-2l1-2zm2 0l1 2h-2l1-2zm2 0l1 2h-2l1-2zm2 0l1 2h-2l1-2zm2 0l1 2h-2l1-2z",
    fill: "#FFF"
  }))))), _view89 || (_view89 = /*#__PURE__*/React.createElement("view", {
    id: "photography",
    viewBox: "240 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1352H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 3.992h1.166C6.478 3.992 7 4.514 7 5.158v1.167H3.5V5.158c0-.644.522-1.166 1.167-1.166z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.653 3.992c.37 0 .718.175.938.472l2.242 3.028H24.5a2.333 2.333 0 012.333 2.333v12.833a2.333 2.333 0 01-2.333 2.334h-21a2.333 2.333 0 01-2.333-2.334V9.825A2.333 2.333 0 013.5 7.492h4.667l2.242-3.028c.22-.297.568-.472.938-.472h5.306zm-.588 2.333h-4.13l-2.593 3.5H3.5v12.833h21V9.825h-5.842l-2.593-3.5zM14 10.408a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5zm0 2.334a2.917 2.917 0 100 5.833 2.917 2.917 0 000-5.833z",
    fill: "#9896E0"
  }))))), _view90 || (_view90 = /*#__PURE__*/React.createElement("view", {
    id: "photos",
    viewBox: "240 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2165H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 3.992h1.166C6.478 3.992 7 4.514 7 5.158v1.167H3.5V5.158c0-.644.522-1.166 1.167-1.166z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.653 3.992c.37 0 .718.175.938.472l2.242 3.028H24.5a2.333 2.333 0 012.333 2.333v12.833a2.333 2.333 0 01-2.333 2.334h-21a2.333 2.333 0 01-2.333-2.334V9.825A2.333 2.333 0 013.5 7.492h4.667l2.242-3.028c.22-.297.568-.472.938-.472h5.306zm-.588 2.333h-4.13l-2.593 3.5H3.5v12.833h21V9.825h-5.842l-2.593-3.5zM14 10.408a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5zm0 2.334a2.917 2.917 0 100 5.833 2.917 2.917 0 000-5.833z",
    fill: "#9896E0"
  }))))), _view91 || (_view91 = /*#__PURE__*/React.createElement("view", {
    id: "pictures",
    viewBox: "240 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1352H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .492)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C1C0EC",
    cx: 12.25,
    cy: 10.5,
    r: 2.917
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 3.5a2.333 2.333 0 012.333 2.333v16.334A2.333 2.333 0 0124.5 24.5h-21a2.333 2.333 0 01-2.333-2.333V5.833A2.333 2.333 0 013.5 3.5h21zm-5.833 10.983l-5.592 5.592a1.167 1.167 0 01-1.76-.128 1.252 1.252 0 01-.132-.114l-3.016-3.016L3.5 21.483v.684h21v-1.85l-5.833-5.834zm5.833-8.65h-21v12.348l3.842-3.84a1.167 1.167 0 011.65 0l3.257 3.258 5.593-5.59a1.167 1.167 0 011.65 0l5.008 5.007V5.833z",
    fill: "#9896E0"
  }))))), _view92 || (_view92 = /*#__PURE__*/React.createElement("view", {
    id: "pizza",
    viewBox: "240 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-4079H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 1.658a29.1 29.1 0 0110.607 1.99 3.5 3.5 0 01-.394 6.648l-8.14 15.766c-.84 1.63-3.123 1.682-4.058.158l-.088-.158-8.139-15.764a3.5 3.5 0 01-.397-6.649A29.1 29.1 0 0114 1.659zm0 7c-2.672 0-5.273.472-7.719 1.38l1.702 3.3a4.667 4.667 0 114.149 8.036L14 24.992l5.428-10.518a4.667 4.667 0 01-4.124-5.776c-.432-.027-.867-.04-1.304-.04zm-2.917 5.834c-.82 0-1.54.422-1.956 1.061l1.86 3.603a2.333 2.333 0 10.097-4.665zm6.584-5.532l-.055.148a2.333 2.333 0 003.1 2.879l1.005-1.949-.168-.062a21.977 21.977 0 00-3.882-1.016zM14 3.992c-3.38 0-6.676.626-9.76 1.83a1.167 1.167 0 00.85 2.174A24.434 24.434 0 0114 6.326c3.088 0 6.096.57 8.91 1.67a1.167 1.167 0 10.848-2.174A26.767 26.767 0 0014 3.992z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view93 || (_view93 = /*#__PURE__*/React.createElement("view", {
    id: "properties",
    viewBox: "240 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2834H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.367 4.517l2.978 2.233a7.012 7.012 0 00-1.307 1.938l-2.371-1.78-7 5.25v10.5h3.5v-5.833c0-.644.522-1.167 1.166-1.167H14c.644 0 1.167.523 1.167 1.167v5.833h3.5v-4.303c.56.144 1.146.22 1.75.22l.308-.007.275.007v5.25c0 .644-.522 1.167-1.167 1.167h-7v-7H10.5v7h-7a1.167 1.167 0 01-1.167-1.167v-9.919l-.464.35-.077.054a1.167 1.167 0 01-1.355-1.895l4.686-3.532.007.009 5.837-4.375a1.167 1.167 0 011.4 0zm8.05 1.808a5.25 5.25 0 014.445 8.044l2.796 2.798a1.167 1.167 0 01-.619 1.973l-.137.016h-.138a1.162 1.162 0 01-.646-.242l-.11-.097-2.797-2.796a5.25 5.25 0 11-2.794-9.696zm0 2.333a2.917 2.917 0 100 5.834 2.917 2.917 0 000-5.834z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view94 || (_view94 = /*#__PURE__*/React.createElement("view", {
    id: "recipes",
    viewBox: "240 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-3215H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.491 22.392l-.38.057c-.99.136-2.033.21-3.111.21a22.62 22.62 0 01-3.504-.268 7.62 7.62 0 01-3.274-3.327c1.795.794 4.198 1.261 6.778 1.261 2.583 0 4.99-.468 6.785-1.264a7.627 7.627 0 01-3.294 3.331z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.325c.92 0 1.816.053 2.675.154l-1.759 2.2c-.302-.014-.608-.02-.916-.02-2.79 0-5.375.546-7.206 1.462-1.465.732-2.127 1.515-2.127 2.037 0 .523.662 1.306 2.127 2.038l.407.192.276.118.206.083.386.143.381.128c1.6.51 3.52.798 5.55.798 1.806 0 3.525-.228 5.01-.638l.22-.065.408-.125.456-.157.114-.044.088-.032.252-.1.425-.188.233-.113c1.465-.732 2.127-1.515 2.127-2.038 0-.52-.656-1.298-2.108-2.028l1.483-1.853c1.753.982 2.85 2.262 2.951 3.67l.008.211v3.5c0 6.444-5.224 11.667-11.667 11.667S2.333 22.102 2.333 15.658v-3.5c0-3.221 5.224-5.833 11.667-5.833zm9.329 9.624l.004-.293.074-.047c-.279.19-.58.371-.903.543l-.499.25-.304.139-.295.125-.273.109-.284.106-.291.103-.395.128-.624.182-.587.148-.586.128-.13.026a22.303 22.303 0 01-4.236.396 21.96 21.96 0 01-4.677-.488l-.741-.178-.221-.06a15.443 15.443 0 01-.493-.144l-.423-.138-.388-.137-.463-.181-.456-.198-.536-.26-.187-.1a10.02 10.02 0 01-.355-.201l-.2-.123-.193-.124.004.29a9.334 9.334 0 009.038 9.037l.291.005a9.333 9.333 0 009.329-9.043zm.733-14.035c.465.372.57 1.026.267 1.52l-.085.12-7.27 9.09c.181.293.321.614.411.955-1.06.204-2.208.31-3.385.31-1.177 0-2.325-.107-3.385-.308a3.5 3.5 0 014.537-2.415l7.27-9.09a1.167 1.167 0 011.64-.182z",
    fill: "#9896E0"
  }))))), _view95 || (_view95 = /*#__PURE__*/React.createElement("view", {
    id: "rentals",
    viewBox: "240 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-2165H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.333 11.575v2.917h5.963l1.037 2.333h-8.166A1.167 1.167 0 0114 15.658v-4.083h2.333z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.54 9.825c.805 0 1.552.415 1.979 1.097l2.231 3.57h2.917c.644 0 1.166.522 1.166 1.166v7c0 .645-.522 1.167-1.166 1.167l-2.375.001a4.084 4.084 0 01-8.084 0h-2.416a4.084 4.084 0 01-8.084 0H2.333a1.167 1.167 0 01-1.166-1.168V16.5c0-.502.321-.948.797-1.106l2.703-.901a8.442 8.442 0 017.55-4.667h6.323zM8.75 21.492a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm10.5 0a1.75 1.75 0 100 3.5 1.75 1.75 0 000-3.5zm2.207-4.667l-2.917-4.667h-6.323a6.109 6.109 0 00-5.334 3.133l-.13.244-.432.865-2.821.94v4.152h1.56a4.084 4.084 0 017.38 0h3.12a4.084 4.084 0 017.38 0h1.56v-4.667h-3.043zM8.167 1.658a3.5 3.5 0 013.3 2.334h10.7c.644 0 1.166.522 1.166 1.166v1.167c0 .644-.522 1.167-1.166 1.167H21a1.167 1.167 0 01-1.167-1.167l-8.366.001a3.501 3.501 0 01-6.8-1.168 3.5 3.5 0 013.5-3.5zm0 2.334a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333z",
    fill: "#9896E0"
  }))))), _view96 || (_view96 = /*#__PURE__*/React.createElement("view", {
    id: "report",
    viewBox: "0 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-1352H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .492)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C1C0EC",
    x: 9.333,
    y: 18.667,
    width: 9.333,
    height: 2.333,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.333a2.333 2.333 0 012.333 2.334v18.666A2.333 2.333 0 0121 25.667H7a2.333 2.333 0 01-2.333-2.334V7.966c0-.618.245-1.212.683-1.65l3.3-3.3a2.333 2.333 0 011.65-.683H21zm0 2.334H10.3L7 7.967v15.366h14V4.667zm-10.333 8.166a1 1 0 011 1V16.5a1 1 0 01-1 1h-.334a1 1 0 01-1-1v-2.667a1 1 0 011-1h.334zm3.5-2.333a1 1 0 011 1v5a1 1 0 01-1 1h-.334a1 1 0 01-1-1v-5a1 1 0 011-1h.334zm3.5-3.5a1 1 0 011 1v8.5a1 1 0 01-1 1h-.334a1 1 0 01-1-1V8a1 1 0 011-1h.334z",
    fill: "#9896E0"
  }))))), _view97 || (_view97 = /*#__PURE__*/React.createElement("view", {
    id: "restaurant",
    viewBox: "30 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-1352H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.84 17.306a.875.875 0 11-1.669.528 4.389 4.389 0 00-2.699-2.797.875.875 0 11.589-1.648 6.139 6.139 0 013.778 3.917z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.667 22.658a1.167 1.167 0 110 2.334H2.333a1.167 1.167 0 010-2.334h23.334zM14 3.992a3.5 3.5 0 013.097 5.132c4.287 1.32 7.403 5.313 7.403 10.034v1.75h-2.333v-1.75a8.167 8.167 0 10-16.334 0v1.75H3.5v-1.75c0-4.72 3.116-8.714 7.404-10.036A3.5 3.5 0 0114 3.992zm0 2.333a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333z",
    fill: "#9896E0"
  }))))), _view98 || (_view98 = /*#__PURE__*/React.createElement("view", {
    id: "rocks",
    viewBox: "60 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-4079H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1.658a3.5 3.5 0 013.5 3.5v15.167a7 7 0 01-7 7h-7a7 7 0 01-7-7V5.158a3.5 3.5 0 117 0l-.001 2.533a3.498 3.498 0 013.502.693 3.479 3.479 0 012.332-.892c.41 0 .802.07 1.167.199V5.158a3.5 3.5 0 013.5-3.5zm0 2.334c-.598 0-1.091.45-1.159 1.03l-.008.136v9.334a3.502 3.502 0 01-2.482 3.35A3.503 3.503 0 0114 20.325h-3.5l-.136-.008a1.167 1.167 0 010-2.317l.136-.008H14a1.167 1.167 0 00.136-2.326L14 15.658H7c-.598 0-1.091.45-1.159 1.031l-.008.136v3.501a4.667 4.667 0 004.434 4.66l.233.006h7c2.5 0 4.54-1.965 4.661-4.434l.006-.232V5.158c0-.644-.523-1.166-1.167-1.166zm-4.667 5.833c-.598 0-1.091.45-1.158 1.03l-.008.137v2.533a3.511 3.511 0 011.977 1.76l.014.032c.181-.181.303-.421.334-.69l.008-.135v-3.5c0-.645-.522-1.167-1.167-1.167zM7 3.992c-.598 0-1.091.45-1.159 1.03l-.008.136-.002 8.367c.366-.13.76-.2 1.169-.2h1.167V5.158c0-.644-.523-1.166-1.167-1.166zm4.667 5.833c-.599 0-1.092.45-1.16 1.03l-.007.137v2.333h2.333v-2.333c0-.645-.522-1.167-1.166-1.167z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view99 || (_view99 = /*#__PURE__*/React.createElement("view", {
    id: "run",
    viewBox: "90 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-2978H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.89 22.307l1.522 1.522c.295.295.609.566.939.814L3.5 24.642a1.167 1.167 0 01-.136-2.326l.136-.008h6.39zm-4.668-4.666l2.334 2.333-4.056.001a1.167 1.167 0 01-.136-2.325l.136-.008 1.722-.001zM20.53 14.33c.1.636-.334 1.234-.97 1.334l-4.033.64a1.167 1.167 0 01-.365-2.306l4.033-.638a1.167 1.167 0 011.335.97zm-1.17-3.91c.1.636-.334 1.234-.97 1.334l-4.61.73a1.167 1.167 0 11-.365-2.304l4.61-.73a1.165 1.165 0 011.334.97z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.872 5.204l2.45 9.705c.125.494.408.933.805 1.25l2.644 2.116a2.953 2.953 0 01.243 4.395l-1.308 1.308a3.5 3.5 0 01-2.475 1.025h-3.584a7 7 0 01-4.95-2.05l-8.786-8.786a4.667 4.667 0 010-6.6l3.645-3.442a2.333 2.333 0 012.734-.343l2.328 1.294c.245.136.53.179.805.122l4.08-.85a1.167 1.167 0 011.369.856zM16.883 6.86l-2.984.623a3.5 3.5 0 01-2.19-.253l-.224-.114-2.328-1.293-3.596 3.395c-.87.87-.91 2.255-.118 3.172l.118.128 8.786 8.786a4.667 4.667 0 003.036 1.36l.264.007h3.584c.258 0 .507-.086.71-.24l.115-.102 1.332-1.333.022-.026a.62.62 0 00-.016-.795l-.08-.077-2.645-2.115a4.667 4.667 0 01-1.525-2.209l-.084-.293-2.177-8.62z",
    fill: "#9896E0"
  }))))), _view100 || (_view100 = /*#__PURE__*/React.createElement("view", {
    id: "sale",
    viewBox: "120 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1496H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 2.825a2.333 2.333 0 012.334 2.333v8.25c0 .619-.246 1.212-.683 1.65L14.939 25.099a2.333 2.333 0 01-3.3 0l-8.249-8.25a2.333 2.333 0 010-3.3L13.431 3.51a2.333 2.333 0 011.65-.684h8.25zm0 2.333h-8.249L5.04 15.2l8.25 8.25 10.04-10.042v-8.25zM11.64 13.55l3.3 3.3a1.167 1.167 0 11-1.65 1.65l-3.3-3.3a1.167 1.167 0 111.65-1.65zm8.25-4.95a3.5 3.5 0 11-4.95 4.95 3.5 3.5 0 014.95-4.95zm-3.3 1.65a1.167 1.167 0 101.65 1.65 1.167 1.167 0 00-1.65-1.65z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view101 || (_view101 = /*#__PURE__*/React.createElement("view", {
    id: "school",
    viewBox: "150 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2165H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.167 8.658v15.167H5.833V8.658h2.334zm14 0v15.167h-2.334V8.658h2.334z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.167 19.158h-2.334v5.834H1.167A1.167 1.167 0 010 23.825V8.658c0-.644.522-1.166 1.167-1.166h5.376c.203 0 .403-.053.579-.154l6.3-3.599a1.167 1.167 0 011.157 0l6.298 3.599c.176.1.376.154.579.154h5.377c.645 0 1.167.522 1.167 1.166v15.167c0 .644-.522 1.167-1.167 1.167H15.167v-5.834zM13.999 6.095l-5.72 3.269a3.5 3.5 0 01-1.475.451l-.26.01h-4.21v12.833H10.5v-4.666c0-.645.522-1.167 1.167-1.167h4.666c.645 0 1.167.522 1.167 1.167v4.666h8.167V9.824h-4.212a3.5 3.5 0 01-1.505-.34l-.23-.12-5.721-3.269zM14 9.242c.34 0 .631.24.698.572l.24 1.2c.086.434.149.87.186 1.31l.44.096c.237.052.498.113.783.182a.744.744 0 010 1.446l-.778.181c-.628.14-1.088.224-1.381.252l-.188.01a1.167 1.167 0 01-1.167-1.166c0-.776.077-1.55.23-2.31l.24-1.201A.712.712 0 0114 9.242z",
    fill: "#9896E0"
  }))))), _view102 || (_view102 = /*#__PURE__*/React.createElement("view", {
    id: "services",
    viewBox: "180 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-2309H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.925 7.25a1.167 1.167 0 011.85.27l.327.594c.575 1.036 1.023 1.767 1.331 2.178.346.46.865.98 1.557 1.548a1.167 1.167 0 01-1.48 1.803c-.827-.678-1.474-1.325-1.943-1.951-.278-.37-.614-.895-1.015-1.582l-.108-.186-.27.222c-.386.31-.8.619-1.242.926l-.452.307c-1.281.855-2.766 1.491-4.447 1.911a1.167 1.167 0 11-.566-2.263c1.43-.358 2.668-.888 3.72-1.59 1.105-.737 2.018-1.467 2.738-2.187z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.825c5.799 0 10.5 4.701 10.5 10.5l.001 1.366a3.501 3.501 0 012.332 3.3v2.334a3.5 3.5 0 01-4.61 3.32 8.135 8.135 0 01-5.89 2.513H14a1.167 1.167 0 010-2.334h2.333c1.57 0 2.995-.62 4.043-1.628a3.474 3.474 0 01-.543-1.87v-2.334c0-1.524.974-2.82 2.334-3.301v-1.366a8.167 8.167 0 00-7.886-8.162L14 5.158a8.167 8.167 0 00-8.162 7.886l-.005.281.001 1.366a3.501 3.501 0 012.333 3.3v2.334a3.5 3.5 0 11-7 0v-2.333c0-1.524.974-2.82 2.333-3.301v-1.366c0-5.799 4.701-10.5 10.5-10.5zm9.333 14c-.598 0-1.091.45-1.158 1.03l-.008.137v2.333c0 .598.449 1.09 1.028 1.159l.14.008.134-.008c.536-.062.96-.487 1.023-1.023l.008-.136v-2.333c0-.645-.522-1.167-1.167-1.167zm-18.666 0c-.599 0-1.092.45-1.16 1.03l-.007.137v2.333a1.167 1.167 0 002.325.136l.008-.136v-2.333c0-.645-.522-1.167-1.166-1.167z",
    fill: "#9896E0"
  }))))), _view103 || (_view103 = /*#__PURE__*/React.createElement("view", {
    id: "sg",
    viewBox: "182 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 182,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eab"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "ead"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "82.634%",
    y2: "232.739%",
    id: "eae"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "eaa",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-7289h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 23 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eac",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eaa"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#eab)",
    fillRule: "nonzero",
    xlinkHref: "#eaa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#eac)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(13 3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 17v13H6V17h2zm3 0v13H9V17h2zm3 0v13h-2V17h2zm7-4v13h-1V13h1zm-2-1v13h-3V12h3zM5 3v12h10v1H5v5H0V3h5z",
    fill: "url(#ead)",
    fillRule: "nonzero",
    mask: "url(#eac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19v1H9v-1h1zm3-2v1h-1v-1h1zm-5 0v1H7v-1h1zm10-1v1h-1v-1h1zM4 16v1H3v-1h1zm5-1v1H8v-1h1zm-5-1v1H3v1H2v-1h1v-1h1zm14 0v1h-1v-1h1zm3 0v1h-1v-1h1zM2 13v1H1v-1h1zm2-1v1H3v-1h1zm-2-2v1H1v-1h1zm1-2h1v1H3V8zm1-2v1H3V6h1zM2 6v1H1V6h1z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.609,
    mask: "url(#eac)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eae)",
    fillRule: "nonzero",
    d: "M18 5h5v8h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12v1h-1v-1h1zm0-2v1h-1v-1h1zm-2 0v1h-1v-1h1zm0-2h1v1h-1V8zm3-2v1h-1V6h1z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.609
  })))), _view104 || (_view104 = /*#__PURE__*/React.createElement("view", {
    id: "sh",
    viewBox: "300 30 30 30"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-1 -1 30 30",
    x: 300,
    y: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-5454H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9896E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.667 3.5A2.333 2.333 0 0128 5.833v16.334a2.333 2.333 0 01-2.333 2.333H2.333A2.333 2.333 0 010 22.167V5.833A2.333 2.333 0 012.333 3.5h23.334zm0 2.333H2.333v16.334h23.334V5.833zm-9.742 6.561l.087.067 2.875 2.492a1.059 1.059 0 01.082 1.515l-.082.08-2.875 2.491a.859.859 0 01-1.22-.095.882.882 0 01.015-1.157l.079-.076 2.261-1.961-2.261-1.96a.882.882 0 01-.16-1.147l.066-.087a.859.859 0 011.133-.162z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 17.454l.853-1.24s.938.959 2.155.959c.658 0 1.255-.359 1.255-1.1 0-1.536-4.117-1.382-4.117-4.133 0-1.317.938-2.34 2.29-2.57v-.68a.524.524 0 011.047 0v.654c1.413.127 2.144.933 2.144.933l-.682 1.344s-.828-.794-1.912-.794c-.731 0-1.303.448-1.303 1.088 0 1.522 4.104 1.253 4.104 4.119 0 1.305-.865 2.418-2.35 2.622v.654a.524.524 0 11-1.048 0v-.654c-1.571-.191-2.436-1.202-2.436-1.202z",
    stroke: "#9896E0",
    strokeWidth: 0.5
  }))))), _view105 || (_view105 = /*#__PURE__*/React.createElement("view", {
    id: "shop",
    viewBox: "210 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-2021H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.822 13.908a1 1 0 01.99.852l.75 5a1 1 0 01-.99 1.148h-.31a1 1 0 01-.99-.851l-.75-5a1 1 0 01.99-1.149h.31zm5.345 0a1 1 0 011 1v5a1 1 0 01-1 1h-.334a1 1 0 01-1-1v-5a1 1 0 011-1h.334zm5.322 0a1 1 0 01.989 1.149l-.75 5a1 1 0 01-.99.851h-.31a1 1 0 01-.99-1.148l.75-5a1 1 0 01.99-.852h.31z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.367 9.825a1.167 1.167 0 011.137 1.43l-2.962 12.832c-.122.53-.593.905-1.137.905H5.595a1.167 1.167 0 01-1.137-.905L1.496 11.254a1.167 1.167 0 011.137-1.429h22.734zm-1.468 2.333H4.1l2.423 10.5h14.955l2.422-10.5zM11.083 3.065c.558.322.75 1.036.427 1.594L9.537 8.075H6.845L9.49 3.492a1.167 1.167 0 011.593-.427zm7.427.427l2.646 4.583h-2.695L16.49 4.659a1.167 1.167 0 012.02-1.167z",
    fill: "#9896E0"
  }))))), _view106 || (_view106 = /*#__PURE__*/React.createElement("view", {
    id: "so",
    viewBox: "240 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-4985H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.953 5.607l7.107 5.41.103-.001a1.78 1.78 0 01.22-.013h3.292c.075 0 .148.004.22.013h.073l7.08-5.39c.76-.544 1.712-.614 2.514-.202a2.39 2.39 0 011.3 2.133v14.078c0 .87-.49 1.637-1.28 2a2.179 2.179 0 01-2.346-.331l-7.252-5.275h-.613a1.126 1.126 0 01-.384 0h-2.041c-.06.004-.119.004-.178 0l-.722-.002-7.327 5.334c-.357.312-.835.48-1.332.48a2.27 2.27 0 01-.939-.207 2.176 2.176 0 01-1.28-2V7.558c0-.903.497-1.721 1.3-2.133.8-.41 1.754-.34 2.485.183zM3.567 7.484l-.066 13.882 7.03-5.121a1.874 1.874 0 01-.002-.096v-3.294l.002-.07-6.964-5.3zm20.962.073l-7.002 5.215c.002.027.002.055.002.083v3.294l-.005.115 7.005 5.099V7.557zm-9.334 5.793h-2.333v2.32h2.334v-2.32z",
    fill: "#9896E0"
  })))), _view107 || (_view107 = /*#__PURE__*/React.createElement("view", {
    id: "social",
    viewBox: "270 0 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-3935H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 2.825a3.5 3.5 0 013.5 3.5v14a3.5 3.5 0 01-3.5 3.5H17.5l-3.088 3.088a.583.583 0 01-.824 0L10.5 23.825H4.667a3.5 3.5 0 01-3.5-3.5v-14a3.5 3.5 0 013.5-3.5h18.666zm0 2.333H4.667c-.599 0-1.092.45-1.16 1.031l-.007.136v14c0 .598.45 1.092 1.03 1.159l.137.008h6.8L14 24.025l2.534-2.533h6.8c.598 0 1.09-.45 1.158-1.03l.008-.137v-14c0-.598-.45-1.091-1.03-1.159l-.137-.008zm-11.57 2.334l.13.004a4.611 4.611 0 011.771.463l.27.146.066.041.133-.08c.341-.19.707-.334 1.094-.43l.295-.063.302-.045c2.186-.275 4.223 1.332 4.454 3.644.244 2.44-1.457 5.055-5.02 7.404l-.363.234-.901.56-.62-.395c-3.837-2.354-5.752-4.996-5.672-7.504.072-2.226 1.796-3.905 3.862-3.977l.198-.002zm-.03 2.333c-.892-.017-1.666.705-1.699 1.72-.044 1.37 1.086 3.077 3.622 4.83l.345.234.277-.185c2.481-1.699 3.637-3.36 3.688-4.698v-.166l-.01-.156c-.1-1.001-.952-1.673-1.849-1.56a2.147 2.147 0 00-1.137.464l-.155.138-.8.78-.904-.85a2.1 2.1 0 00-1.017-.505l-.265-.04-.095-.006z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view108 || (_view108 = /*#__PURE__*/React.createElement("view", {
    id: "solutions",
    viewBox: "270 31 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 31,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-2546H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.243 3.139l-2.675 2.676a3.746 3.746 0 10-5.244 5.244l-2.677 2.676a1.07 1.07 0 000 1.514l3.298 3.298a1.223 1.223 0 001.73 0l.648-.65.115-.103a1.606 1.606 0 012.26 2.26l-.104.114-.649.65a1.223 1.223 0 000 1.73l3.298 3.297a1.07 1.07 0 001.514 0l2.676-2.676a3.746 3.746 0 105.244-5.244l2.676-2.676a1.07 1.07 0 000-1.514l-3.298-3.298a1.223 1.223 0 00-1.73 0l-.648.649-.115.104a1.606 1.606 0 01-2.26-2.26l.104-.115.649-.649a1.223 1.223 0 000-1.73L14.757 3.14a1.07 1.07 0 00-1.514 0zm.758 2.542l1.624 1.624-.123.14a3.94 3.94 0 00.094 5.121l.16.17c1.383 1.383 3.556 1.532 5.183.33l.193-.15.053-.05 1.626 1.626-3.686 3.685 2.153 1.615a1.413 1.413 0 11-1.843 2.133l-.071-.076-.064-.08-1.614-2.152L14 23.302l-1.624-1.625.122-.138a3.94 3.94 0 00-.094-5.121l-.16-.17c-1.383-1.384-3.556-1.532-5.183-.331l-.193.15-.052.05-1.625-1.625 3.686-3.685-2.154-1.615A1.413 1.413 0 118.566 7.06l.07.076.065.08 1.614 2.154 3.686-3.688z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view109 || (_view109 = /*#__PURE__*/React.createElement("view", {
    id: "store",
    viewBox: "270 62 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 62,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-1877H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.167 17.992v7h-2.334v-7h2.334zM14 2.825c.644 0 1.167.522 1.167 1.167v5.833a1.167 1.167 0 01-2.334 0V3.992c0-.645.523-1.167 1.167-1.167zm-3.748.05c.617.184.967.835.782 1.452l-1.75 5.833a1.167 1.167 0 11-2.235-.67L8.8 3.657a1.167 1.167 0 011.453-.783zm8.949.782l1.75 5.833a1.167 1.167 0 11-2.235.67l-1.75-5.833a1.167 1.167 0 012.235-.67z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.112v8.88c0 .644-.522 1.166-1.167 1.166H4.667A1.167 1.167 0 013.5 24.992v-8.88a5.267 5.267 0 002.333 0v7.713h2.334v-5.833c0-.645.522-1.167 1.166-1.167h9.334c.644 0 1.166.522 1.166 1.167v5.833h2.334v-7.714a5.263 5.263 0 002.333 0zm-7 3.046h-7v4.667h7v-4.667zm9.333-8.75a4.083 4.083 0 01-7 2.858 4.071 4.071 0 01-2.916 1.226A4.071 4.071 0 0114 13.266a4.071 4.071 0 01-2.917 1.226 4.071 4.071 0 01-2.916-1.226 4.083 4.083 0 01-7-2.858v-1.34c0-.265.09-.522.255-.73l4.06-5.075c.222-.277.557-.438.912-.438h15.212c.354 0 .69.161.91.438l4.062 5.076c.165.207.255.464.255.729v1.34zM6.955 5.158l-2.8 3.5c-.388.586-.604 1.112-.647 1.578l-.008.172a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 012.333 0v.583a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 012.334 0v.583a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 112.333 0v.583a1.75 1.75 0 103.5 0c0-.508-.218-1.09-.655-1.75l-2.8-3.5H6.955z",
    fill: "#9896E0"
  }))))), _view110 || (_view110 = /*#__PURE__*/React.createElement("view", {
    id: "studio",
    viewBox: "270 93 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 93,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-2546H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.958 10.992a1.167 1.167 0 01.136 2.325l-.136.008H9.333v-2.333h2.625zm6.709 0v2.333h-2.625A1.167 1.167 0 0115.906 11l.136-.008h2.625zm-6.709-4.667a1.167 1.167 0 01.136 2.326l-.136.007H9.333V6.325h2.625zm6.709 0v2.333h-2.625a1.167 1.167 0 01-.136-2.325l.136-.008h2.625z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28.492a1.167 1.167 0 010-2.334h2.332v-2.332h2.335l-.001 2.332H17.5a1.167 1.167 0 110 2.334h-7zm11.038-7.6a1.167 1.167 0 01-.398 1.601 9.288 9.288 0 01-4.003 1.297l-.394.026-.41.01h-4.666a9.294 9.294 0 01-4.807-1.333 1.167 1.167 0 111.203-1.999c.98.59 2.091.932 3.253.99l.35.008h4.64l.356-.008a6.953 6.953 0 003.275-.99 1.167 1.167 0 011.601.398zM16.333.492c2.5 0 4.54 1.964 4.661 4.434l.006.232v9.334a4.665 4.665 0 01-4.434 4.66l-.233.006h-4.666c-2.5 0-4.54-1.964-4.661-4.433L7 14.492V5.158a4.666 4.666 0 014.434-4.66l.233-.006h4.666zm0 2.333h-4.666l-.174.007A2.334 2.334 0 009.34 4.976l-.007.182v9.334l.007.174a2.334 2.334 0 002.144 2.152l.183.007h4.666l.174-.006a2.334 2.334 0 002.153-2.144l.007-.183V5.158l-.007-.174a2.334 2.334 0 00-2.327-2.159z",
    fill: "#9896E0"
  }))))), _view111 || (_view111 = /*#__PURE__*/React.createElement("view", {
    id: "systems",
    viewBox: "130 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 130,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-3649h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.995 12.173l.003.126v.39l-.01.293a10.946 10.946 0 01-.705 3.425l-.174.43c-.24.559-.529 1.102-.866 1.623l-.14.21-.125.179a10.52 10.52 0 01-.343.459l-.195.24-.196.227-.246.269-.22.226-.304.293-.275.246-.198.168c-4.248 3.514-10.518 3.346-14.573-.506l-.205-.2L3.1 19.149v.414a1 1 0 01-1.992.125l-.007-.125v-2.829l.006-.115.013-.08.02-.081.02-.065.034-.082.056-.103.066-.093.025-.031.109-.109.124-.091.103-.056.082-.034.124-.036.108-.018.11-.006h2.828a1 1 0 01.125 1.993l-.125.007-.414.001 1.122 1.121a9 9 0 0012.537.185l.19-.185a9.13 9.13 0 00.438-.47l.199-.238c.204-.253.396-.517.572-.791l.178-.288.2-.356.162-.32.142-.31.06-.143.113-.283.105-.297.12-.388.094-.355.077-.345.031-.163.052-.32.039-.306.021-.22.023-.337a9.15 9.15 0 00.01-.434l-.01-.441-.024-.346-.019-.196-.019-.153a9.033 9.033 0 00-.053-.361l-.044-.247 1.068.001.137-.004.148-.013.117-.016.147-.028.08-.02.152-.045.152-.056a11 11 0 01.12.885l.028.363.015.358zM19.557 4.5l.221.215 1.12 1.12.001-.413.008-.126a1 1 0 011.985 0l.007.126V8.25l-.012.156-.015.08-.021.073-.045.114-.07.126-.089.115-.097.095-.101.077-.098.057-.057.026-.118.042-.08.02-.118.016-.079.003h-2.828l-.125-.008a1 1 0 010-1.984l.125-.008h.414l-1.122-1.121-.19-.185A9.001 9.001 0 006.284 5.54L6 5.783l-.244.227-.05.049a9.063 9.063 0 00-.306.313l-.21.236A9.027 9.027 0 004.257 7.9l-.197.35-.14.27-.13.277-.124.287-.041.104-.114.306-.12.36-.09.32-.05.2-.067.297-.056.298-.062.42A9.09 9.09 0 003 12.48l.004.274.018.369.012.149.036.342.023.175c.021.15.047.298.076.445H2.1l-.192.008-.163.018-.108.017-.174.04-.124.036-.172.061a10.983 10.983 0 01-.085-.567l-.042-.409-.02-.271-.017-.375-.003-.3.002-.187.009-.3.022-.362.024-.28.043-.355.049-.326.014-.08c.066-.389.154-.77.26-1.142l.155-.496.146-.406.162-.398.133-.298.085-.178c.342-.705.764-1.381 1.266-2.015l.182-.223.23-.267.294-.317.284-.284.289-.27.341-.294.283-.226C9.508.505 15.589.743 19.557 4.498z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.509 10.115a1 1 0 01-.522 1.314l-.561.243c.094.507.098 1.017.021 1.51l.57.226a1 1 0 11-.74 1.859l-.568-.226c-.283.412-.636.78-1.052 1.084l.242.561a1 1 0 11-1.836.793l-.243-.562a4.474 4.474 0 01-1.51.022l-.226.569a1 1 0 11-1.859-.738l.225-.57a4.474 4.474 0 01-1.083-1.05l-.562.24a1 1 0 01-.792-1.835l.561-.243a4.474 4.474 0 01-.022-1.51l-.568-.226a1 1 0 11.738-1.86l.569.227c.283-.412.636-.78 1.052-1.084l-.242-.562a1 1 0 011.836-.792l.243.561a4.474 4.474 0 011.51-.022l.226-.568a1 1 0 011.859.738l-.226.569c.412.282.78.636 1.084 1.052l.562-.242a1 1 0 011.314.522zM14.295 11.5a2.5 2.5 0 10-4.59 1.981 2.5 2.5 0 004.59-1.98z",
    fill: "#9896E0"
  }))))), _view112 || (_view112 = /*#__PURE__*/React.createElement("view", {
    id: "tax",
    viewBox: "270 124 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 124,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-3359H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.825l-2.625 2.333-2.625-2.333-2.625 2.333L14 23.825l-2.625 2.333-2.625-2.333-2.625 2.333L3.5 23.825V5.158H2.333a1.167 1.167 0 010-2.333h23.334a1.167 1.167 0 010 2.333H24.5v18.667zM22.167 5.158H5.833v17.618l.292.26 2.625-2.333 2.625 2.333L14 20.703l2.625 2.333 2.625-2.333 2.625 2.333.292-.26V5.158zm-5.25 8.75a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5zM17.742 9a1.167 1.167 0 010 1.65l-5.834 5.833a1.167 1.167 0 11-1.65-1.65L16.092 9a1.167 1.167 0 011.65 0zm-6.659-.925a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view113 || (_view113 = /*#__PURE__*/React.createElement("view", {
    id: "taxi",
    viewBox: "156 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 156,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-2836h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.992v2.5h5.111l.889 2h-7a1 1 0 01-1-1v-3.5h2z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.512 3.492a2 2 0 011.916 1.425l.472 1.575h.864a2 2 0 011.789 1.105L20 10.492h3a1 1 0 011 1v6a1 1 0 01-1 1h-2.536a3.5 3.5 0 01-6.928 0h-3.072a3.5 3.5 0 01-6.928 0H1a1 1 0 01-1-1v-5.22a1 1 0 01.757-.97L4 10.492l.432-1.728a3 3 0 012.91-2.272H8.1l.472-1.575a2 2 0 011.916-1.425h3.024zM7 16.492a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm10 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-.236-8H7.342a1 1 0 00-.936.649l-.034.108-.723 2.892L2 13.053v3.439l1.837-.001a3.5 3.5 0 016.326 0h3.674a3.5 3.5 0 016.326 0H22v-4h-3.236l-2-4zm-3.252-3h-3.024l-.3 1h3.623l-.3-1z",
    fill: "#9896E0"
  }))))), _view114 || (_view114 = /*#__PURE__*/React.createElement("view", {
    id: "tienda",
    viewBox: "270 155 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 155,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1496H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.167 17.992v7h-2.334v-7h2.334zM14 2.825c.644 0 1.167.522 1.167 1.167v5.833a1.167 1.167 0 01-2.334 0V3.992c0-.645.523-1.167 1.167-1.167zm-3.748.05c.617.184.967.835.782 1.452l-1.75 5.833a1.167 1.167 0 11-2.235-.67L8.8 3.657a1.167 1.167 0 011.453-.783zm8.949.782l1.75 5.833a1.167 1.167 0 11-2.235.67l-1.75-5.833a1.167 1.167 0 012.235-.67z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.112v8.88c0 .644-.522 1.166-1.167 1.166H4.667A1.167 1.167 0 013.5 24.992v-8.88a5.267 5.267 0 002.333 0v7.713h2.334v-5.833c0-.645.522-1.167 1.166-1.167h9.334c.644 0 1.166.522 1.166 1.167v5.833h2.334v-7.714a5.263 5.263 0 002.333 0zm-7 3.046h-7v4.667h7v-4.667zm9.333-8.75a4.083 4.083 0 01-7 2.858 4.071 4.071 0 01-2.916 1.226A4.071 4.071 0 0114 13.266a4.071 4.071 0 01-2.917 1.226 4.071 4.071 0 01-2.916-1.226 4.083 4.083 0 01-7-2.858v-1.34c0-.265.09-.522.255-.73l4.06-5.075c.222-.277.557-.438.912-.438h15.212c.354 0 .69.161.91.438l4.062 5.076c.165.207.255.464.255.729v1.34zM6.955 5.158l-2.8 3.5c-.388.586-.604 1.112-.647 1.578l-.008.172a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 012.333 0v.583a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 012.334 0v.583a1.75 1.75 0 103.5 0v-.583a1.167 1.167 0 112.333 0v.583a1.75 1.75 0 103.5 0c0-.508-.218-1.09-.655-1.75l-2.8-3.5H6.955z",
    fill: "#9896E0"
  }))))), _view115 || (_view115 = /*#__PURE__*/React.createElement("view", {
    id: "tips",
    viewBox: "270 186 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 186,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2978H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.825a3.5 3.5 0 013.5 3.5v14a3.5 3.5 0 01-3.5 3.5h-3.5l-3.088 3.088a.583.583 0 01-.824 0L10.5 23.825H7a3.5 3.5 0 01-3.5-3.5v-14a3.5 3.5 0 013.5-3.5h14zm0 2.333H7c-.598 0-1.091.45-1.159 1.031l-.008.136v14c0 .598.45 1.092 1.03 1.159l.137.008h4.466L14 24.025l2.534-2.533H21c.598 0 1.091-.45 1.159-1.03l.008-.137v-14c0-.598-.45-1.091-1.03-1.159L21 5.158zm-7 7.584c.644 0 1.167.522 1.167 1.166v3.5a1.167 1.167 0 01-2.334 0v-3.5c0-.644.523-1.166 1.167-1.166zm0-4.667a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view116 || (_view116 = /*#__PURE__*/React.createElement("view", {
    id: "tires",
    viewBox: "270 217 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 217,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-3791H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.658c4.51 0 8.167 5.746 8.167 12.834 0 7.087-3.657 12.833-8.167 12.833h-7c-4.51 0-8.167-5.746-8.167-12.833 0-7.088 3.657-12.834 8.167-12.834h7zm-4.697 2.335L10.5 3.992c-2.944 0-5.833 4.54-5.833 10.5 0 5.84 2.775 10.318 5.656 10.494l.177.006h2.304c-2.1-2.322-3.47-6.16-3.47-10.5s1.37-8.177 3.469-10.5zm4.697-.001c-2.944 0-5.833 4.54-5.833 10.5s2.89 10.5 5.833 10.5c2.944 0 5.833-4.54 5.833-10.5s-2.89-10.5-5.833-10.5zm0 3.5c1.772 0 3.208 3.134 3.208 7s-1.436 7-3.208 7c-1.772 0-3.208-3.134-3.208-7s1.436-7 3.208-7zm0 2.73l-.061.114-.086.178c-.45.98-.728 2.415-.728 3.978 0 1.562.278 2.997.728 3.977l.086.178.061.114.061-.114.086-.178c.45-.98.728-2.415.728-3.977 0-1.563-.278-2.997-.728-3.978l-.086-.178-.061-.114z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view117 || (_view117 = /*#__PURE__*/React.createElement("view", {
    id: "to",
    viewBox: "208 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 208,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eoa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eob"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eoc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eod"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eoe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eof"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eog"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eoh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-7289h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.432 17a.433.433 0 01-.35-.174.415.415 0 01-.06-.38L17.15 1.327a.426.426 0 01.32-.315.435.435 0 01.43.14c.105.122.13.292.064.439l-5.13 15.119a.43.43 0 01-.402.29z",
    fill: "url(#eoa)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#eob)",
    d: "M12.911 13.232h-1.223v7.894L7.41 23h5.5zm0 0V23h5.5l-4.276-1.874v-7.894z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.635 6.014a1.5 1.5 0 00-1.192-2.408H12.91v2.408h6.724z",
    fill: "url(#eoc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.688 13.232l-5.5-7.218h13.447l-5.5 7.218h-2.447z",
    fillOpacity: 0.65,
    fill: "url(#eod)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.906S3.534 3.07 6.745 0c0 0 2.962 2.59.13 5.906z",
    fillOpacity: 0.45,
    fill: "url(#eoe)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69 5.96S3.808 9.268.686 6.088c0 0 2.634-2.895 6.002-.128z",
    fillOpacity: 0.45,
    fill: "url(#eof)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.827 5.926s-4.42.29-4.31-4.113c0 0 3.96-.19 4.31 4.113z",
    fillOpacity: 0.45,
    fill: "url(#eog)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.188 6.014h6.723V3.606H7.38a1.5 1.5 0 00-1.192 2.408z",
    fill: "url(#eoc)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#eoh)",
    cx: 17.5,
    cy: 1.5,
    r: 1.5
  }))))), _view118 || (_view118 = /*#__PURE__*/React.createElement("view", {
    id: "today",
    viewBox: "0 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-4223H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C1C0EC",
    d: "M11.325 9.825l-.973 5.833h3.468l.972-5.833h2.366l-.973 5.833H21v2.334h-5.203l-1.001 6.01-2.302-.385.937-5.625H9.963l-1 6.01-2.302-.385.936-5.625H3.5v-2.334h4.487l.972-5.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.928 3.992c.57 0 1.057.412 1.151.975l3.111 18.666a1.167 1.167 0 01-.959 1.343l-.095.012-.097.004H1.96a1.167 1.167 0 01-1.15-1.359L3.92 4.967a1.168 1.168 0 011.152-.975h17.856zm-2.512 7H5.28L3.337 22.658H18.47l1.945-11.666zm2.333.193l-1.912 11.473h3.825L22.75 11.185zm-1.555-4.86H6.06l-.39 2.333h15.136l.388-2.333z",
    fill: "#9896E0"
  }))))), _view119 || (_view119 = /*#__PURE__*/React.createElement("view", {
    id: "tokyo",
    viewBox: "234 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 234,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eqa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eqb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eqc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-450-7289H990v8778H-450z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 16v6a2 2 0 01-2 2h-2a2 2 0 01-2-2v-6h6zm0-7v6H9V9h6zm-2-9a2 2 0 012 2v6H9V2a2 2 0 012-2h2z",
    fill: "url(#eqa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.394 8.62s-3.341-2.834-.13-5.905c0 0 2.963 2.59.13 5.905z",
    fillOpacity: 0.64,
    fill: "url(#eqb)",
    transform: "rotate(60 17.245 5.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.313 16.114s-4.421.291-4.311-4.113c0 0 3.96-.19 4.31 4.113z",
    fillOpacity: 0.64,
    fill: "url(#eqc)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13 14h1v1h-1zm-3-7h1v1h-1z"
  }))))), _view120 || (_view120 = /*#__PURE__*/React.createElement("view", {
    id: "tours",
    viewBox: "30 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 30,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2690H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.233 25.575L6.658 28.15a1.167 1.167 0 01-1.747-1.54l.097-.11.923-.925h3.302zm12.834 0l.925.925.097.11a1.167 1.167 0 01-1.637 1.637l-.11-.097-2.576-2.575h3.302zm-6.9-19.25v7h7v2.333H5.833v-2.333h7v-7h2.334z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 2.825H11.5a1 1 0 01-1-1v-.333a1 1 0 011-1h5a1 1 0 011 1v.333a1 1 0 01-1 1h-1.333v2.333H21a2.333 2.333 0 012.333 2.334v14A2.333 2.333 0 0121 23.825H7a2.333 2.333 0 01-2.333-2.333v-14A2.333 2.333 0 017 5.158h5.833V2.825zM21 7.492H7v14h14v-14zM9.917 17.408a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334zm8.166 0a1.167 1.167 0 110 2.334 1.167 1.167 0 010-2.334z",
    fill: "#9896E0"
  }))))), _view121 || (_view121 = /*#__PURE__*/React.createElement("view", {
    id: "town",
    viewBox: "60 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 60,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-1496H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.325v4.667H8.167v-4.667H10.5zm11.667-1.167v2.334H17.5v-2.334h4.667zm-11.667-3.5v2.334H8.167v-2.334H10.5zm11.667-1.166v2.333H17.5v-2.333h4.667zm-11.667-3.5v2.333H8.167v-2.333H10.5zm0-4.667v2.333H8.167V6.325H10.5z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.667 27.325A1.167 1.167 0 013.5 26.158V2.825c0-.644.522-1.167 1.167-1.167H14c.644 0 1.167.523 1.167 1.167v4.407l8.589 3.334c.448.174.744.606.744 1.087v14.505c0 .645-.522 1.167-1.167 1.167H4.667zm8.166-23.333h-7v21h7v-21zm2.334 5.742v15.258h7v-12.54l-7-2.718z",
    fill: "#9896E0"
  }))))), _view122 || (_view122 = /*#__PURE__*/React.createElement("view", {
    id: "toys",
    viewBox: "90 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 90,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1252-1496H188v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.753 19.483c.464.446.48 1.184.034 1.65A16.286 16.286 0 0114 26.157a16.286 16.286 0 01-11.776-5.014 1.167 1.167 0 011.682-1.617A13.953 13.953 0 0014 23.825c3.866 0 7.479-1.573 10.103-4.308a1.167 1.167 0 011.65-.034zm-.086-16.658v8.75c0 .644-.523 1.167-1.167 1.167h-.115a1.965 1.965 0 01-1.493-.687v-.001a1.966 1.966 0 01-.142-.187l-.072-.108a1.208 1.208 0 00-1.386-.476c-.5.167-.798.68-.694 1.197l.11.553c.195.973.374 1.948.536 2.926l.553 3.316a12.24 12.24 0 01-1.816 1.244 6.807 6.807 0 00-11.95.006c-.68-.38-1.326-.826-1.927-1.333l.019-.034-.057.002a12.336 12.336 0 01-.111-.096l.344-6.906H3.333a1 1 0 01-1-1v-.333a1 1 0 011-1h10.084l.516-3.1a4.667 4.667 0 014.604-3.9h7.13zm-2.334 2.333h-4.796a2.334 2.334 0 00-2.302 1.95l-.517 3.1a2.333 2.333 0 01-2.301 1.95h-4.78l-.22 4.393a9.136 9.136 0 012.516-1.377 9.124 9.124 0 017.962.884 89.898 89.898 0 00-.475-2.567l-.11-.554a3.378 3.378 0 012.244-3.867 3.54 3.54 0 012.78.231V5.158z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view123 || (_view123 = /*#__PURE__*/React.createElement("view", {
    id: "training",
    viewBox: "120 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 120,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-4367H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.925 21.917l1.65 1.65-1.65 1.65a1.167 1.167 0 11-1.649-1.65l1.649-1.65zm18.15-18.15a1.167 1.167 0 111.65 1.65l-1.651 1.651-1.65-1.65 1.651-1.65zm-5.776 5.776l1.65 1.65-8.25 8.25-1.65-1.65 8.25-8.25z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05 15.317l4.125 4.125A4.083 4.083 0 017.4 25.216l-4.124-4.125a4.083 4.083 0 015.774-5.774zm-4.125 1.65a1.75 1.75 0 00-.113 2.35l.113.125 4.125 4.124a1.75 1.75 0 002.589-2.35l-.114-.125L7.4 16.967a1.75 1.75 0 00-2.475 0zM20.6 3.767l4.124 4.125a4.083 4.083 0 11-5.774 5.775l-4.125-4.125A4.083 4.083 0 0120.6 3.767zm-4.125 1.65a1.75 1.75 0 00-.114 2.35l.114.125 4.125 4.125a1.75 1.75 0 002.588-2.35l-.113-.125-4.125-4.125a1.75 1.75 0 00-2.475 0z",
    fill: "#9896E0"
  }))))), _view124 || (_view124 = /*#__PURE__*/React.createElement("view", {
    id: "travel",
    viewBox: "260 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 260,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "evb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "evd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "96.859%",
    id: "eve"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF1F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "eva",
    cx: 11,
    cy: 11,
    r: 11
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-594-7289H846v8778H-594z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "evc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eva"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.29,
    fill: "url(#evb)",
    fillRule: "nonzero",
    xlinkHref: "#eva"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#evc)",
    cx: 14,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12a1 1 0 11.085-1.996 1.499 1.499 0 012.831 0L19 10a1 1 0 010 2z",
    fill: "url(#evd)",
    fillRule: "nonzero",
    mask: "url(#evc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.3 16v-.013a1.5 1.5 0 11.882-2.823A2 2 0 113 16H.3z",
    fill: "url(#eve)",
    fillRule: "nonzero",
    mask: "url(#evc)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.804 3.248c-.61-.61-1.689-.6-2.31.022l-4.279 4.278-8.921-1.977a2 2 0 00-1.847.539l-.78.78 8.048 4.158L6.5 15.8 4 15l-1 1.053 3.026 1.973L8 20.975 9 20l-.5-2.5 4.504-4.163 4.159 8.048.78-.78a2 2 0 00.538-1.847l-1.977-8.921 4.278-4.278c.622-.622.633-1.7.022-2.311z",
    fill: "#9896E0"
  })))), _view125 || (_view125 = /*#__PURE__*/React.createElement("view", {
    id: "tv",
    viewBox: "182 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 182,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-310-5450h1440v8778H-310z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11.492v2H6v-2h12zm0-4v2H6v-2h12z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.492c1.105 0 2 .955 2 2.133v11.733c0 1.179-.895 2.134-2 2.134h-8v2h6.5a1 1 0 010 2h-15a1 1 0 010-2H11v-2H3c-1.105 0-2-.955-2-2.134V4.625c0-1.178.895-2.133 2-2.133h18zm0 2.133H3v11.733h18V4.625z",
    fill: "#9896E0"
  }))))), _view126 || (_view126 = /*#__PURE__*/React.createElement("view", {
    id: "uk",
    viewBox: "286 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 286,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "exa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "exb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-7451h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5a9.5 9.5 0 110-19 9.5 9.5 0 010 19zm0-3a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    fillOpacity: 0.5,
    fill: "url(#exa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9h22a1 1 0 011 1v4a1 1 0 01-1 1H1a1 1 0 01-1-1v-4a1 1 0 011-1z",
    fill: "url(#exb)"
  }))))), _view127 || (_view127 = /*#__PURE__*/React.createElement("view", {
    id: "vacations",
    viewBox: "150 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 150,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-820-1640H620v8778H-820z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.364 24.116h2.483l.158.434a1.167 1.167 0 01-2.193.798l-.448-1.232zm-1.778-11.702l2.35 6.453h-2.483l-2.058-5.656 2.191-.797zM8.301 1.3a1.167 1.167 0 011.495.697l.624 1.713a9.425 9.425 0 00-2.193.798l-.623-1.713A1.167 1.167 0 018.3 1.301z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 20.325h12.345l4.407-4.471a1.167 1.167 0 011.662 1.638l-3.97 4.027 1.742 2.867a1.167 1.167 0 01-1.995 1.212L19.42 22.68l-.013-.023H7.483l-3.158 3.159a1.167 1.167 0 11-1.65-1.65l3.5-3.5c.219-.219.516-.342.825-.342zM9.1 3.494c5.448-1.984 11.474.826 13.457 6.275L2.824 16.952C.84 11.502 3.65 5.477 9.099 3.494zm.797 2.192a8.17 8.17 0 00-5.361 8.16L19.249 8.49a8.17 8.17 0 00-9.352-2.804z",
    fill: "#9896E0"
  }))))), _view128 || (_view128 = /*#__PURE__*/React.createElement("view", {
    id: "vegas",
    viewBox: "312 306 26 26"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    x: 312,
    y: 306,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eza"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-204.346%",
    x2: "50%",
    y2: "97.846%",
    id: "ezc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "ezd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A2E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8BE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "4.319%",
    x2: "50%",
    y2: "97.846%",
    id: "eze"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.314 19.953a9.622 9.622 0 110-19.244 9.622 9.622 0 010 19.244z",
    id: "ezb"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-306-7451h1440v8778H-306z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.69,
    fill: "url(#eza)",
    xlinkHref: "#ezb",
    transform: "translate(8 4)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "url(#ezc)",
    cx: 20.5,
    cy: 19.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0c.803 0 1.561.19 2.233.525C28.04.853 28.69 1.378 29 2l.003.006C29.629 2.84 30 3.876 30 5a4.98 4.98 0 01-.518 2.218A8.522 8.522 0 0129 9.158V18a2 2 0 01-2 2h-4l3-4v-4.61c-2.876.215-6.434-1.275-8.325-2.273-2.117-1.117-5.082-2.54-5.928 0-.18.539-.429 1.206-.747 2V16l3 4h-4a2 2 0 01-2-2c-.89-3.946-1.052-7.613-.488-11 .847-5.081 5.603-6.039 8.046-4.658 1.852 1.048 3.162 2.429 4.56 1.577A5.002 5.002 0 0125 0z",
    fill: "url(#ezd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 9a3 3 0 010 6h-3a3 3 0 010-6zm-14 6a3 3 0 010-6h3a3 3 0 010 6z",
    fillOpacity: 0.83,
    fill: "url(#eze)"
  }))))), _view129 || (_view129 = /*#__PURE__*/React.createElement("view", {
    id: "ventures",
    viewBox: "180 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 180,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-4223H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.917 6.325c5.476 0 9.916 4.44 9.916 9.917 0 5.477-4.44 9.916-9.916 9.916C4.44 26.158 0 21.718 0 16.242c0-5.377 4.28-9.755 9.619-9.912l.298-.005zm8.75-3.5c5.04 0 9.147 1.998 9.327 4.496l.006.17v14c0 2.578-4.179 4.667-9.333 4.667-.818 0-1.61-.052-2.366-.15a11.696 11.696 0 002.483-2.184l-.117.001c2.163 0 4.159-.422 5.556-1.12.961-.481 1.386-.94 1.438-1.168l.006-.045.001-1.581c-1.351.766-3.198 1.309-5.29 1.503.385-.778.685-1.605.89-2.468 1.131-.19 2.144-.503 2.955-.908.961-.48 1.386-.939 1.438-1.167l.006-.046.001-1.58c-1.086.615-2.492 1.086-4.088 1.348l.003-.351c0-.678-.058-1.343-.169-1.99 1.072-.19 2.033-.493 2.809-.88.961-.482 1.386-.94 1.438-1.168l.006-.046.001-1.58c-1.26.714-2.95 1.233-4.866 1.458a11.6 11.6 0 00-1.16-2.24c1.783-.106 3.397-.5 4.58-1.091 1.031-.516 1.445-1.004 1.445-1.213 0-.209-.414-.698-1.444-1.213-1.397-.698-3.393-1.12-5.556-1.12-1.396 0-2.722.175-3.862.487a11.569 11.569 0 00-3.544-.994c1.705-1.11 4.388-1.827 7.406-1.827zm-8.75 5.833a7.583 7.583 0 107.583 7.584l-.005-.272a7.583 7.583 0 00-7.578-7.312zm.684 1.984v1.115c1.143.13 1.849.62 2.118.843l.124.112-.907 1.752-.154-.12c-.298-.218-.991-.652-1.781-.652-.441 0-.931.196-.931.686 0 1.041 3.98.968 3.98 3.675 0 1.237-.8 2.318-2.23 2.63l-.22.04v1.115H9.267v-1.114a4.56 4.56 0 01-2.38-1.085l-.12-.116 1.128-1.63.153.128c.32.25 1.098.78 1.941.78.441 0 .92-.172.92-.699 0-.98-3.982-1.066-3.982-3.7 0-1.303.884-2.252 2.139-2.565l.2-.044v-1.151h1.336z",
    fill: "#9896E0",
    fillRule: "nonzero"
  })))), _view130 || (_view130 = /*#__PURE__*/React.createElement("view", {
    id: "villas",
    viewBox: "208 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 208,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-3937h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.492v2H4v-2h4.5zm11.5-3v2h-9v-2h9zm0-4v2h-9v-2h9z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 2.751l.123.076 6.272 4.343a1 1 0 01-1.03 1.709l-.108-.065L21 8.515v4.3l.629-.252a1 1 0 01.848 1.808l-.106.05-20 8a1 1 0 01-.848-1.808l.106-.05 1.37-.549v-5.19l-.43.298a1 1 0 01-1.313-.155l-.078-.098a1 1 0 01.154-1.314l.099-.078 5.272-3.65c.13-.09.27-.154.415-.196l.091.096.156.142c.34.287.73.475 1.135.562v1.967l-1-.691-2.5 1.73v5.777l5-2V8.515l-.43.299a1 1 0 01-1.314-.154l-.078-.099a1 1 0 01.154-1.314l.099-.077 6.272-4.343a1.4 1.4 0 011.471-.076zM15.5 4.707L12 7.13v9.284l7-2.8V7.13l-3.5-2.423z",
    fill: "#9896E0"
  }))))), _view131 || (_view131 = /*#__PURE__*/React.createElement("view", {
    id: "vote",
    viewBox: "210 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 210,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-964-1640H476v8778H-964z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.718 13.154l.167.289a1 1 0 01-.366 1.366l-2.814 1.625a1 1 0 01-1.366-.366l-.167-.289a1 1 0 01.366-1.366l2.814-1.625a1 1 0 011.366.366zm-2.333-4.041l.167.288a1 1 0 01-.366 1.366l-2.815 1.625a1 1 0 01-1.366-.366l-.166-.288a1 1 0 01.366-1.366l2.814-1.625a1 1 0 011.366.366z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 23.825a1.167 1.167 0 010 2.333h-21a1.167 1.167 0 010-2.333h21zM20.76 3.893l5.833 10.103a2.333 2.333 0 01-.854 3.188l-8.473 4.89h-4.667l11.974-6.911-5.834-10.104-15.155 8.75 4.772 8.266H5.661l-4.098-7.099a2.333 2.333 0 01.854-3.187l15.156-8.75a2.333 2.333 0 013.187.854zm-8.789 8.82c.623.164.996.802.833 1.425l-.333 1.265 1.266.333a1.167 1.167 0 11-.592 2.257l-1.266-.333-.331 1.266a1.167 1.167 0 01-2.257-.592l.33-1.265-1.264-.332a1.167 1.167 0 01.592-2.257l1.265.331.333-1.265a1.167 1.167 0 011.424-.832z",
    fill: "#9896E0"
  }))))), _view132 || (_view132 = /*#__PURE__*/React.createElement("view", {
    id: "wine",
    viewBox: "240 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 240,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-1640H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8.03c1.436.718 2.814.718 4.135 0a13.6 13.6 0 01.173 2.154 4.308 4.308 0 11-8.616 0c0-.718.058-1.436.173-2.154 1.32-.718 2.7-.718 4.135 0z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.417 1.658c.544 0 1.016.377 1.137.907.41 1.795.613 5.185.613 7.843a8.168 8.168 0 01-7 8.084v6.5h3.5a1.167 1.167 0 010 2.333H9.333a1.167 1.167 0 110-2.333h3.5v-6.5a8.168 8.168 0 01-7-8.084c0-2.658.202-6.048.613-7.843.121-.53.593-.907 1.137-.907h12.834zm-.958 2.334H8.541c-.248 1.45-.374 4.368-.374 6.416a5.833 5.833 0 0011.666 0l-.006-.804c-.027-1.951-.15-4.344-.368-5.612z",
    fill: "#9896E0"
  }))))), _view133 || (_view133 = /*#__PURE__*/React.createElement("view", {
    id: "world",
    viewBox: "270 248 30 31"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "-1 -1 30 31",
    x: 270,
    y: 248,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-1108-2309H332v8778h-1440z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.134 9.674c-.129.165-.785.518-1.969 1.059l-1.06.472a4.74 4.74 0 00-.53.274l-.772.463a1.54 1.54 0 01-1.882-.231l-.749-.75-.069-.073c-.046.073-.1.142-.164.205l-.642.643 1.347 1.886c.374.524.414 2.277-.11 2.651l-1.237.413-3.3.825c-.475.302-.523-.35-.825-.825-.042-.066.815-1.618 1.062-2.044l3.257-5.433c.017-.378.125-.756.33-1.098L14.36 5.55l1.616 1.069c2.87 1.913 4.256 2.931 4.159 3.056z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.158 2c.423.423.454 1.09.09 1.548l-.09.102-.635.635.157.187c4.426 5.409 4.193 13.356-.699 18.498l-.248.255c-5.132 5.132-13.275 5.455-18.791.914l-.148-.125-.636.636a1.167 1.167 0 01-1.548.09l-.102-.09a1.167 1.167 0 01-.09-1.548l.09-.102 2.241-2.24 1.032 1.008c4.577 4.37 11.818 4.29 16.302-.193 4.479-4.48 4.555-11.694.228-16.265l-.228-.234-.825-.825L22.508 2a1.167 1.167 0 011.65 0zm-4.725 4.725a9.333 9.333 0 11-13.2 13.2 9.333 9.333 0 0113.2-13.2zm-11.55 1.65a7 7 0 109.9 9.9 7 7 0 00-9.9-9.9z",
    fill: "#9896E0"
  }))))), _view134 || (_view134 = /*#__PURE__*/React.createElement("view", {
    id: "zone",
    viewBox: "234 279 26 27"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "-1 -1 26 27",
    x: 234,
    y: 279,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-162-2548h1440v8778H-162z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.201 14.094l5.01 2.503a1 1 0 010 1.79l-9.764 4.881a1 1 0 01-.894 0l-9.764-4.882a1 1 0 010-1.789l5.01-2.504c.362.54.767 1.083 1.213 1.63l-3.54 1.769L12 21.255l7.527-3.763-3.54-1.77a21.7 21.7 0 001.214-1.628z",
    fill: "#C1C0EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.492a6 6 0 016 6c0 2.988-1.846 6.264-5.537 9.827a.667.667 0 01-.844.067l-.082-.067-.388-.38C7.716 13.522 6 10.373 6 7.491a6 6 0 016-6zm0 2a4 4 0 00-4 4c0 2.032 1.19 4.418 3.673 7.11l.327.348.28-.297c2.422-2.614 3.629-4.938 3.715-6.932L16 7.49a4 4 0 00-4-4zm0 2.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: "#9896E0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTldSprite);
export default __webpack_public_path__ + "static/media/tld-sprite.3e26e3ab7e6312b6586f7418fffb0d16.svg";
export { ForwardRef as ReactComponent };